// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.jj.cR === region.fZ.cR)
	{
		return 'on line ' + region.jj.cR;
	}
	return 'on lines ' + region.jj.cR + ' through ' + region.fZ.cR;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iv,
		impl.jA,
		impl.jn,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bq: func(record.bq),
		fm: record.fm,
		e6: record.e6
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bq;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.fm;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.e6) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iv,
		impl.jA,
		impl.jn,
		function(sendToApp, initialModel) {
			var view = impl.jC;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iv,
		impl.jA,
		impl.jn,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ff && impl.ff(sendToApp)
			var view = impl.jC;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fK);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.js) && (_VirtualDom_doc.title = title = doc.js);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.iW;
	var onUrlRequest = impl.iX;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ff: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.gW === next.gW
							&& curr.ga === next.ga
							&& curr.gR.a === next.gR.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		iv: function(flags)
		{
			return A3(impl.iv, flags, _Browser_getUrl(), key);
		},
		jC: impl.jC,
		jA: impl.jA,
		jn: impl.jn
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { iq: 'hidden', h_: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { iq: 'mozHidden', h_: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { iq: 'msHidden', h_: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { iq: 'webkitHidden', h_: 'webkitvisibilitychange' }
		: { iq: 'hidden', h_: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		g6: _Browser_getScene(),
		hy: {
			hE: _Browser_window.pageXOffset,
			hF: _Browser_window.pageYOffset,
			fz: _Browser_doc.documentElement.clientWidth,
			ei: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fz: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		ei: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			g6: {
				fz: node.scrollWidth,
				ei: node.scrollHeight
			},
			hy: {
				hE: node.scrollLeft,
				hF: node.scrollTop,
				fz: node.clientWidth,
				ei: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			g6: _Browser_getScene(),
			hy: {
				hE: x,
				hF: y,
				fz: _Browser_doc.documentElement.clientWidth,
				ei: _Browser_doc.documentElement.clientHeight
			},
			fX: {
				hE: x + rect.left,
				hF: y + rect.top,
				fz: rect.width,
				ei: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.iJ) { flags += 'm'; }
	if (options.hY) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.f0.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.f0.b, xhr)); });
		$elm$core$Maybe$isJust(request.hq) && _Http_track(router, xhr, request.hq.a);

		try {
			xhr.open(request.gw, request.hv, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.hv));
		}

		_Http_configureRequest(xhr, request);

		request.fK.a && xhr.setRequestHeader('Content-Type', request.fK.a);
		xhr.send(request.fK.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.f9; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.hm.a || 0;
	xhr.responseType = request.f0.d;
	xhr.withCredentials = request.hL;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		hv: xhr.responseURL,
		hf: xhr.status,
		jk: xhr.statusText,
		f9: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			jg: event.loaded,
			hb: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			i1: event.loaded,
			hb: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.D) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.H),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.H);
		} else {
			var treeLen = builder.D * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.M) : builder.M;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.D);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.H) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.H);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{M: nodeList, D: (len / $elm$core$Array$branchFactor) | 0, H: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {f4: fragment, ga: host, gO: path, gR: port_, gW: protocol, c$: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$NotificationForm$AbsoluteConsumptionSelected = 2;
var $author$project$NotificationForm$ArbitraryDateSelected = 0;
var $author$project$NotificationForm$ConsumptionLimitSelected = 4;
var $author$project$NotificationForm$DataSeriesSelected = 6;
var $author$project$Types$El = 1;
var $author$project$NotificationForm$HolidaySelected = 1;
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$NotificationForm$QExtremeSelected = 5;
var $author$project$NotificationForm$RelativeConsumptionSelected = 3;
var $author$project$NotificationForm$SpecificConsumptionSelected = 7;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$NotificationForm$boolToMaybe = F2(
	function (predicate, val) {
		return predicate ? $elm$core$Maybe$Just(val) : $elm$core$Maybe$Nothing;
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$NotificationsForm$SourceSelection$DataSeriesData = F3(
	function (id, name, unit) {
		return {K: id, a8: name, ad: unit};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$NotificationForm$dataSeriesDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unit',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$NotificationsForm$SourceSelection$DataSeriesData))));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Types$fullEntityDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'icon_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ancestry',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed(
						F5(
							function (id, name, ancestry, typeId, icon) {
								return {hN: ancestry, gd: icon, K: id, a8: name, hu: typeId};
							})))))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$NotificationForm$dataSeriesWithBreadcrumbsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$NotificationForm$dataSeriesDataDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'breadcrumbs',
		$elm$json$Json$Decode$list($author$project$Types$fullEntityDecoder),
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Divisor$AggregateAreaTypeDivisor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Divisor$StructuredDivisor = F3(
	function (id, name, unit) {
		return {K: id, a8: name, ad: unit};
	});
var $author$project$Divisor$structuredDivisorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unit',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Divisor$StructuredDivisor))));
var $author$project$Divisor$aggregateAreaTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$AggregateAreaTypeDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $author$project$Divisor$DataSourceDivisor = function (a) {
	return {$: 0, a: a};
};
var $author$project$Divisor$dataSourceDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$DataSourceDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Divisor$IndividualAreaTypeDivisor = function (a) {
	return {$: 3, a: a};
};
var $author$project$Divisor$individualAreaTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$IndividualAreaTypeDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Divisor$PropertyDivisor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Divisor$propertyDecoder = A2($elm$json$Json$Decode$map, $author$project$Divisor$PropertyDivisor, $author$project$Divisor$structuredDivisorDecoder);
var $author$project$Divisor$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (tp) {
				switch (tp) {
					case 'data_source':
						return $author$project$Divisor$dataSourceDecoder;
					case 'property':
						return $author$project$Divisor$propertyDecoder;
					case 'aggregate_area_type':
						return $author$project$Divisor$aggregateAreaTypeDecoder;
					case 'individual_area_type':
						return $author$project$Divisor$individualAreaTypeDecoder;
					default:
						return $elm$json$Json$Decode$fail('unknown divisor type ' + tp);
				}
			},
			A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string))
		]));
var $author$project$NotificationForm$entityDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Types$fullEntityDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'breadcrumbs',
		$elm$json$Json$Decode$list($author$project$Types$fullEntityDecoder),
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$NotificationForm$UnconfiguredPhoneNumber = {$: 1};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$intersect, dict1, dict2);
	});
var $author$project$NotificationForm$NotAsked = {$: 0};
var $author$project$NotificationForm$UnselectedSpec = {$: 0};
var $author$project$Enectiva$ValidatedValue$NotValidated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Enectiva$ValidatedValue$init = function (v) {
	return $author$project$Enectiva$ValidatedValue$NotValidated(v);
};
var $author$project$NotificationForm$newNotification = F2(
	function (smsRecipient, ids) {
		return {
			z: $krisajenkins$remotedata$RemoteData$NotAsked,
			K: $elm$core$Maybe$Nothing,
			a8: $author$project$Enectiva$ValidatedValue$init(''),
			dJ: ids,
			bU: $author$project$NotificationForm$NotAsked,
			aI: smsRecipient,
			j: $author$project$NotificationForm$UnselectedSpec,
			c7: ''
		};
	});
var $author$project$NotificationForm$Notification = F8(
	function (id, name, text, spec, save, preselectedRecipientIds, emailRecipients, smsRecipient) {
		return {z: emailRecipients, K: id, a8: name, dJ: preselectedRecipientIds, bU: save, aI: smsRecipient, j: spec, c7: text};
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$NotificationForm$AbsoluteConsumptionSpec = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$NotificationForm$ConsumptionLimitSpec = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $author$project$NotificationForm$RelativeConsumptionSpec = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$NotificationForm$SpecificConsumptionSpec = F4(
	function (a, b, c, d) {
		return {$: 10, a: a, b: b, c: c, d: d};
	});
var $author$project$NotificationForm$ArbitraryDate = function (date) {
	return {dn: date};
};
var $author$project$NotificationForm$ArbitraryDateSpec = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.jj, posixMinutes) < 0) {
					return posixMinutes + era.iV;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		fR: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		gz: month,
		hG: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fR;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gz;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hG;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {fO: col, h4: contextStack, gT: problem, g2: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.g2, s.fO, x, s.l));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.iV, s.d);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{fO: 1, l: s.l, q: s.q, iV: s.iV + 1, g2: s.g2 + 1, d: s.d}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{fO: s.fO + 1, l: s.l, q: s.q, iV: newOffset, g2: s.g2, d: s.d}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.gT;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.d),
			s.iV) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.iV, s1.iV, s0.d),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.iV, s.g2, s.fO, s.d);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{fO: newCol, l: s.l, q: s.q, iV: newOffset, g2: newRow, d: s.d});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {fO: col, gT: problem, g2: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.g2, p.fO, p.gT);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{fO: 1, l: _List_Nil, q: 1, iV: 0, g2: 1, d: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {iu: index, iD: match, dG: number, hi: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{hY: false, iJ: false},
		string);
};
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Enectiva$Conversion$parseStdDateWithFallback = F2(
	function (fallback, str) {
		return A2(
			$elm$core$Result$withDefault,
			fallback,
			$justinmimbs$date$Date$fromIsoString(
				function () {
					var _v0 = $elm$regex$Regex$fromString('T.+$');
					if (_v0.$ === 1) {
						return str;
					} else {
						var regex = _v0.a;
						return A3(
							$elm$regex$Regex$replace,
							regex,
							$elm$core$Basics$always(''),
							str);
					}
				}()));
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Enectiva$Conversion$parseStdDate = $author$project$Enectiva$Conversion$parseStdDateWithFallback(
	A2(
		$justinmimbs$date$Date$fromPosix,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(0)));
var $author$project$Enectiva$Conversion$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$Conversion$parseStdDate(s));
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationForm$arbitraryDateDecoder = function (object) {
	return A2(
		$elm$json$Json$Decode$field,
		object,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$NotificationForm$ArbitraryDateSpec,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$author$project$Enectiva$Conversion$dateDecoder,
				$elm$json$Json$Decode$succeed($author$project$NotificationForm$ArbitraryDate))));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$NotificationForm$bareDateDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'month', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'day', $elm$json$Json$Decode$int));
var $author$project$NotificationForm$dateRangesConstrainDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['constraints', 'days_of_year']),
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			A2($elm$json$Json$Decode$field, 'from', $author$project$NotificationForm$bareDateDecoder),
			A2($elm$json$Json$Decode$field, 'to', $author$project$NotificationForm$bareDateDecoder))));
var $author$project$Enectiva$ValidatedValue$setDecoder = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Set$fromList,
			A2($elm$core$Basics$composeR, $author$project$Enectiva$ValidatedValue$init, $elm$json$Json$Decode$succeed)),
		$elm$json$Json$Decode$list(decoder));
};
var $author$project$NotificationForm$daysOfWeekConstraintDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['constraints', 'days_of_week']),
	$author$project$Enectiva$ValidatedValue$setDecoder($elm$json$Json$Decode$int));
var $author$project$NotificationForm$hoursOfDayConstraintDecoder = function () {
	var d = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (a, b) {
				return _Utils_Tuple2(a, b);
			}),
		A2($elm$json$Json$Decode$field, 'from', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'to', $elm$json$Json$Decode$int));
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['constraints', 'hours_of_day']),
		d);
}();
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$NotificationForm$constraintsDecoder = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (a, b, c) {
			return _Utils_Tuple3(a, b, c);
		}),
	$author$project$NotificationForm$daysOfWeekConstraintDecoder,
	$author$project$NotificationForm$hoursOfDayConstraintDecoder,
	$author$project$NotificationForm$dateRangesConstrainDecoder);
var $author$project$NotificationForm$ConsumptionCore = F5(
	function (source, energy, threshold, measure, preview) {
		return {g: energy, aa: measure, u: preview, e: source, E: threshold};
	});
var $author$project$Enectiva$Conversion$decodeResult = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$json$Json$Decode$succeed(a);
	} else {
		var err = result.a;
		return $elm$json$Json$Decode$fail(err);
	}
};
var $author$project$NotificationsForm$Measure$Consumption = 0;
var $author$project$NotificationsForm$Measure$Cost = 1;
var $author$project$NotificationsForm$Measure$Production = 2;
var $author$project$NotificationsForm$Measure$ProductionCost = 3;
var $author$project$NotificationsForm$Measure$fromString = function (m) {
	switch (m) {
		case 'consumption':
			return $elm$core$Result$Ok(0);
		case 'cost':
			return $elm$core$Result$Ok(1);
		case 'production':
			return $elm$core$Result$Ok(2);
		case 'production_cost':
			return $elm$core$Result$Ok(3);
		default:
			return $elm$core$Result$Err('unknown measure' + m);
	}
};
var $author$project$NotificationsForm$Measure$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$NotificationsForm$Measure$fromString, $author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$SelectList$SelectList = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$SelectList$fromLists = $author$project$SelectList$SelectList;
var $author$project$NotificationsForm$SourceSelection$Closed = 1;
var $author$project$NotificationsForm$SourceSelection$new = function (list) {
	return {a6: $elm$core$Maybe$Nothing, _: list, c$: '', c5: 1};
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$NotificationsForm$SourceSelection$decoderHelp = F3(
	function (field, matcher, sources) {
		return A2(
			$elm$json$Json$Decode$field,
			field,
			A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					var index = $elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							matcher(id),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (a, b) {
										return _Utils_Tuple2(a, b);
									}),
								sources)));
					var fail = function (_v2) {
						return $elm$json$Json$Decode$fail(
							'unavailable ' + (field + (' ' + $elm$core$String$fromInt(id))));
					};
					if (index.$ === 1) {
						return fail(0);
					} else {
						var i = index.a;
						var _v1 = A2($elm$core$List$drop, i, sources);
						if (_v1.b) {
							var slctd = _v1.a;
							var after = _v1.b;
							return $elm$json$Json$Decode$succeed(
								$author$project$NotificationsForm$SourceSelection$new(
									A3(
										$author$project$SelectList$fromLists,
										A2($elm$core$List$take, i, sources),
										slctd,
										after)));
						} else {
							return fail(0);
						}
					}
				},
				$elm$json$Json$Decode$int));
	});
var $author$project$NotificationsForm$SourceSelection$dataSeriesDecoder = A2(
	$author$project$NotificationsForm$SourceSelection$decoderHelp,
	'data_series_id',
	F2(
		function (id, _v0) {
			var i = _v0.a;
			var source = _v0.b;
			if (source.$ === 3) {
				var ds = source.c;
				return _Utils_eq(ds.K, id) ? $elm$core$Maybe$Just(i) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}));
var $author$project$NotificationsForm$SourceSelection$entityDecoder = A2(
	$author$project$NotificationsForm$SourceSelection$decoderHelp,
	'entity_id',
	F2(
		function (id, _v0) {
			var i = _v0.a;
			var source = _v0.b;
			if (source.$ === 2) {
				var entity = source.c;
				return _Utils_eq(entity.K, id) ? $elm$core$Maybe$Just(i) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}));
var $author$project$NotificationsForm$SourceSelection$physicalMeterDecoder = A2(
	$author$project$NotificationsForm$SourceSelection$decoderHelp,
	'physical_meter_id',
	F2(
		function (id, _v0) {
			var i = _v0.a;
			var source = _v0.b;
			if (!source.$) {
				var physicalMeter = source.c;
				return _Utils_eq(physicalMeter.K, id) ? $elm$core$Maybe$Just(i) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}));
var $author$project$NotificationsForm$SourceSelection$virtualMeterDecoder = A2(
	$author$project$NotificationsForm$SourceSelection$decoderHelp,
	'virtual_meter_id',
	F2(
		function (id, _v0) {
			var i = _v0.a;
			var source = _v0.b;
			if (source.$ === 1) {
				var vm = source.c;
				return _Utils_eq(vm.K, id) ? $elm$core$Maybe$Just(i) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}));
var $author$project$NotificationsForm$SourceSelection$decoder = function (sources) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$NotificationsForm$SourceSelection$physicalMeterDecoder(sources),
				$author$project$NotificationsForm$SourceSelection$virtualMeterDecoder(sources),
				$author$project$NotificationsForm$SourceSelection$entityDecoder(sources),
				$author$project$NotificationsForm$SourceSelection$dataSeriesDecoder(sources)
			]));
};
var $author$project$Types$Co = 5;
var $author$project$Types$Ga = 2;
var $author$project$Types$Hca = 6;
var $author$project$Types$He = 4;
var $author$project$Types$Lf = 7;
var $author$project$Types$Wa = 3;
var $author$project$Types$energyFromString = function (str) {
	switch (str) {
		case 'el':
			return $elm$core$Result$Ok(1);
		case 'ga':
			return $elm$core$Result$Ok(2);
		case 'wa':
			return $elm$core$Result$Ok(3);
		case 'he':
			return $elm$core$Result$Ok(4);
		case 'co':
			return $elm$core$Result$Ok(5);
		case 'hca':
			return $elm$core$Result$Ok(6);
		case 'lf':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('unknown energy ' + str);
	}
};
var $author$project$Types$energyDecoder = A3(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$map($author$project$Types$energyFromString),
	$elm$json$Json$Decode$andThen($author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Enectiva$ValidatedValue$floatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$ValidatedValue$init(v));
	},
	$elm$json$Json$Decode$float);
var $author$project$NotificationForm$thresholdFieldDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'threshold', $author$project$Enectiva$ValidatedValue$floatDecoder);
var $author$project$NotificationForm$consumptionDecoder = F4(
	function (object, sources, extraDecoder, specConstructor) {
		var tupleSpecConstructor = function (_v0) {
			var core = _v0.a;
			var extra = _v0.b;
			return A2(specConstructor, core, extra);
		};
		var coreAndExtra = F6(
			function (s, e, thr, m, pr, extra) {
				return _Utils_Tuple2(
					A5($author$project$NotificationForm$ConsumptionCore, s, e, thr, m, pr),
					extra);
			});
		return A2(
			$elm$json$Json$Decode$field,
			object,
			A2(
				$elm$json$Json$Decode$andThen,
				A2($elm$core$Basics$composeR, tupleSpecConstructor, $elm$json$Json$Decode$succeed),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					extraDecoder,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						$author$project$NotificationForm$NotAsked,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measure',
							$author$project$NotificationsForm$Measure$decoder,
							$author$project$NotificationForm$thresholdFieldDecoder(
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'energy',
									$author$project$Types$energyDecoder,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										$author$project$NotificationsForm$SourceSelection$decoder(sources),
										$elm$json$Json$Decode$succeed(coreAndExtra)))))))));
	});
var $author$project$NotificationForm$ConsumptionExtension = F3(
	function (period, snoozePeriod, direction) {
		return {Z: direction, aE: period, p: snoozePeriod};
	});
var $author$project$NotificationForm$GreaterThan = 0;
var $author$project$NotificationForm$LessThan = 1;
var $author$project$NotificationForm$directionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (e) {
		switch (e) {
			case 'greater_than':
				return $elm$json$Json$Decode$succeed(0);
			case 'less_than':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown direction ' + e);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationForm$directionFieldDecoder = A2($elm$json$Json$Decode$field, 'direction', $author$project$NotificationForm$directionDecoder);
var $author$project$NotificationsForm$Period$Custom = function (a) {
	return {$: 4, a: a};
};
var $author$project$BareTime$fromComponents = F2(
	function (hours, minutes) {
		return (hours * 100) + minutes;
	});
var $author$project$BareTime$toComponents = function (time) {
	return _Utils_Tuple2(
		(time / 100) | 0,
		A2($elm$core$Basics$modBy, 100, time));
};
var $author$project$BareTime$normalize = function (time) {
	var _v0 = $author$project$BareTime$toComponents(time);
	var hours = _v0.a;
	var minutes = _v0.b;
	var extraHours = (minutes / 60) | 0;
	var normalizedHours = A2($elm$core$Basics$modBy, 24, hours + extraHours);
	var normalizedMinutes = A2($elm$core$Basics$modBy, 60, minutes);
	return A2($author$project$BareTime$fromComponents, normalizedHours, normalizedMinutes);
};
var $author$project$BareTime$newRange = F2(
	function (from, to) {
		return _Utils_Tuple2(
			$author$project$BareTime$normalize(from),
			$author$project$BareTime$normalize(to));
	});
var $author$project$NotificationsForm$Period$customDecoder = A2(
	$elm$json$Json$Decode$field,
	'custom',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'to',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'from',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed(
				F2(
					function (from, to) {
						return $author$project$NotificationsForm$Period$Custom(
							A2($author$project$BareTime$newRange, from, to));
					})))));
var $author$project$NotificationsForm$Period$Day = {$: 1};
var $author$project$NotificationsForm$Period$Hour = {$: 0};
var $author$project$NotificationsForm$Period$Month = {$: 2};
var $author$project$NotificationsForm$Period$Year = {$: 3};
var $author$project$NotificationsForm$Period$stringToPeriod = function (str) {
	switch (str) {
		case 'year':
			return $author$project$NotificationsForm$Period$Year;
		case 'month':
			return $author$project$NotificationsForm$Period$Month;
		case 'day':
			return $author$project$NotificationsForm$Period$Day;
		case 'hour':
			return $author$project$NotificationsForm$Period$Hour;
		default:
			return $author$project$NotificationsForm$Period$Month;
	}
};
var $author$project$NotificationsForm$Period$simpleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$NotificationsForm$Period$stringToPeriod, $elm$json$Json$Decode$succeed),
	A2($elm$json$Json$Decode$field, 'simple', $elm$json$Json$Decode$string));
var $author$project$NotificationsForm$Period$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$NotificationsForm$Period$simpleDecoder, $author$project$NotificationsForm$Period$customDecoder]));
var $author$project$NotificationsForm$Period$initSelectable = F2(
	function (allowCustom, period) {
		return {dZ: allowCustom, bQ: false, aE: period};
	});
var $author$project$NotificationForm$periodFieldDecoder = function (allowCustom) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$NotificationsForm$Period$initSelectable(allowCustom),
		A2($elm$json$Json$Decode$field, 'period', $author$project$NotificationsForm$Period$decoder));
};
var $author$project$NotificationsForm$SnoozePeriod$Hours = 1;
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm$regex$Regex$never = _Regex_never;
var $author$project$NotificationsForm$SnoozePeriod$regex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(\\d+)(\\w)$'));
var $author$project$NotificationsForm$SnoozePeriod$Days = 2;
var $author$project$NotificationsForm$SnoozePeriod$Minutes = 0;
var $author$project$NotificationsForm$SnoozePeriod$stringToUnit = function (str) {
	switch (str) {
		case 'm':
			return 0;
		case 'h':
			return 1;
		case 'd':
			return 2;
		default:
			return 1;
	}
};
var $author$project$Enectiva$Conversion$toInt = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(value));
};
var $author$project$NotificationsForm$SnoozePeriod$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		if (s === '') {
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(1, 0));
		} else {
			var submatches = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$head(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.hi;
						},
						A3($elm$regex$Regex$findAtMost, 1, $author$project$NotificationsForm$SnoozePeriod$regex, s))));
			if (submatches.b && submatches.b.b) {
				var nbr = submatches.a;
				var _v2 = submatches.b;
				var un = _v2.a;
				var u = A2(
					$elm$core$Maybe$withDefault,
					1,
					A2($elm$core$Maybe$map, $author$project$NotificationsForm$SnoozePeriod$stringToUnit, un));
				var n = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Maybe$map, $author$project$Enectiva$Conversion$toInt, nbr));
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(u, n));
			} else {
				return $elm$json$Json$Decode$fail('unknown snooze period ' + s);
			}
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationForm$snoozePeriodFieldDecoder = A2($elm$json$Json$Decode$field, 'snooze_period', $author$project$NotificationsForm$SnoozePeriod$decoder);
var $author$project$NotificationForm$consumptionExtensionDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$NotificationForm$directionFieldDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$NotificationForm$snoozePeriodFieldDecoder,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$NotificationForm$periodFieldDecoder(false),
			$elm$json$Json$Decode$succeed($author$project$NotificationForm$ConsumptionExtension))));
var $author$project$NotificationForm$DailyDataSeriesSpec = F4(
	function (a, b, c, d) {
		return {$: 7, a: a, b: b, c: c, d: d};
	});
var $author$project$NotificationForm$OnlyCrossedThreshold = 0;
var $author$project$NotificationForm$SustainsCrossedThreshold = 1;
var $author$project$NotificationForm$dailyDSModeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'only_crossed_threshold':
				return $elm$json$Json$Decode$succeed(0);
			case 'sustains_crossed_threshold':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('unsupported daily DS mode ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationForm$DataSeriesCore = F3(
	function (direction, threshold, source) {
		return {Z: direction, e: source, E: threshold};
	});
var $author$project$NotificationForm$dataSeriesCoreDecoder = function (sources) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$NotificationsForm$SourceSelection$decoder(sources),
		$author$project$NotificationForm$thresholdFieldDecoder(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'direction',
				$author$project$NotificationForm$directionDecoder,
				$elm$json$Json$Decode$succeed($author$project$NotificationForm$DataSeriesCore))));
};
var $author$project$Enectiva$ValidatedValue$intDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$ValidatedValue$init(v));
	},
	$elm$json$Json$Decode$int);
var $author$project$NotificationForm$repetitionFieldDecoder = A2($elm$json$Json$Decode$field, 'repetition', $author$project$Enectiva$ValidatedValue$intDecoder);
var $author$project$NotificationForm$dailyDataSeriesDecoder = F2(
	function (sources, m) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'daily_mode',
			$author$project$NotificationForm$dailyDSModeDecoder,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$NotificationForm$repetitionFieldDecoder,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$elm$json$Json$Decode$succeed(m),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$NotificationForm$dataSeriesCoreDecoder(sources),
						$elm$json$Json$Decode$succeed($author$project$NotificationForm$DailyDataSeriesSpec)))));
	});
var $author$project$NotificationForm$Daily = function (a) {
	return {$: 1, a: a};
};
var $author$project$NotificationForm$Instantaneous = {$: 0};
var $author$project$NotificationForm$Avg = 1;
var $author$project$NotificationForm$Max = 2;
var $author$project$NotificationForm$Min = 0;
var $author$project$NotificationForm$dataSeriesMeasureDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (m) {
		switch (m) {
			case 'daily_min':
				return $elm$json$Json$Decode$succeed(0);
			case 'daily_avg':
				return $elm$json$Json$Decode$succeed(1);
			case 'daily_max':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown data series measure ' + m);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationForm$dataSeriesSubtypeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (m) {
				return $elm$json$Json$Decode$succeed(
					$author$project$NotificationForm$Daily(m));
			},
			$author$project$NotificationForm$dataSeriesMeasureDecoder),
			A2(
			$elm$json$Json$Decode$andThen,
			function (tt) {
				if (tt === 'instantaneous') {
					return $elm$json$Json$Decode$succeed($author$project$NotificationForm$Instantaneous);
				} else {
					return $elm$json$Json$Decode$fail('Unknown data series subtype ' + tt);
				}
			},
			$elm$json$Json$Decode$string)
		]));
var $author$project$NotificationForm$InstantaneousDataSeriesSpec = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$NotificationForm$instantaneousDataSeriesDecoder = function (sources) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$NotificationForm$constraintsDecoder,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$NotificationForm$snoozePeriodFieldDecoder,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$NotificationForm$dataSeriesCoreDecoder(sources),
				$elm$json$Json$Decode$succeed($author$project$NotificationForm$InstantaneousDataSeriesSpec))));
};
var $author$project$NotificationForm$dataSeriesDecoder = function (sources) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (subtype) {
			if (!subtype.$) {
				return A2(
					$elm$json$Json$Decode$field,
					'data_series',
					$author$project$NotificationForm$instantaneousDataSeriesDecoder(sources));
			} else {
				var m = subtype.a;
				return A2(
					$elm$json$Json$Decode$field,
					'data_series',
					A2($author$project$NotificationForm$dailyDataSeriesDecoder, sources, m));
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data_series', 'measure']),
			$author$project$NotificationForm$dataSeriesSubtypeDecoder));
};
var $author$project$NotificationForm$divisorFieldDecoder = A2(
	$elm$json$Json$Decode$field,
	'divisor',
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Enectiva$ValidatedValue$init,
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Divisor$decoder)));
var $author$project$NotificationForm$Holiday = F3(
	function (dateRanges, advance, includeWeekendDays) {
		return {aZ: advance, aM: dateRanges, cN: includeWeekendDays};
	});
var $author$project$NotificationForm$HolidaySpec = function (a) {
	return {$: 2, a: a};
};
var $author$project$NotificationForm$holidayDecoder = function (object) {
	return A2(
		$elm$json$Json$Decode$field,
		object,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$NotificationForm$HolidaySpec,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'include_weekend_days',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'advance',
					$author$project$Enectiva$ValidatedValue$intDecoder,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$NotificationForm$dateRangesConstrainDecoder,
						$elm$json$Json$Decode$succeed($author$project$NotificationForm$Holiday))))));
};
var $author$project$NotificationForm$MeterErrorState = F2(
	function (notifyAboutResolution, externalRecipients) {
		return {dt: externalRecipients, dF: notifyAboutResolution};
	});
var $author$project$NotificationForm$MeterErrorStateSpec = function (a) {
	return {$: 9, a: a};
};
var $author$project$NotificationForm$meterErrorStateDecoder = function (object) {
	return A2(
		$elm$json$Json$Decode$field,
		object,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$NotificationForm$MeterErrorStateSpec,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'external_recipients',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'notify_about_resolution',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$NotificationForm$MeterErrorState)))));
};
var $author$project$NotificationForm$QExtreme = F4(
	function (source, threshold, constraints, snoozePeriod) {
		return {Y: constraints, p: snoozePeriod, e: source, E: threshold};
	});
var $author$project$NotificationForm$QExtremeSpec = function (a) {
	return {$: 8, a: a};
};
var $author$project$NotificationForm$qExtremeDecoder = F2(
	function (object, sources) {
		return A2(
			$elm$json$Json$Decode$field,
			object,
			A2(
				$elm$json$Json$Decode$map,
				$author$project$NotificationForm$QExtremeSpec,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$NotificationForm$snoozePeriodFieldDecoder,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$NotificationForm$constraintsDecoder,
						$author$project$NotificationForm$thresholdFieldDecoder(
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$author$project$NotificationsForm$SourceSelection$decoder(sources),
								$elm$json$Json$Decode$succeed($author$project$NotificationForm$QExtreme)))))));
	});
var $author$project$NotificationForm$unitFieldDecoder = A2($elm$json$Json$Decode$field, 'unit', $elm$json$Json$Decode$string);
var $author$project$NotificationForm$WastageDetection = function (source) {
	return {e: source};
};
var $author$project$NotificationForm$WastageDetectionSpec = function (a) {
	return {$: 11, a: a};
};
var $author$project$NotificationForm$onlyPhysicalWaterMeters = function (sources) {
	return A2(
		$elm$core$List$filterMap,
		function (s) {
			if (!s.$) {
				var energy = s.c.g;
				if (energy === 3) {
					return $elm$core$Maybe$Just(s);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		sources);
};
var $author$project$NotificationForm$wastageDetectionDecoder = F2(
	function (object, sources) {
		return A2(
			$elm$json$Json$Decode$field,
			object,
			A2(
				$elm$json$Json$Decode$map,
				$author$project$NotificationForm$WastageDetectionSpec,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$NotificationsForm$SourceSelection$decoder(
						$author$project$NotificationForm$onlyPhysicalWaterMeters(sources)),
					$elm$json$Json$Decode$succeed($author$project$NotificationForm$WastageDetection))));
	});
var $author$project$NotificationForm$specDecoder = function (sources) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (tp) {
			switch (tp) {
				case 'arbitrary_date':
					return $author$project$NotificationForm$arbitraryDateDecoder(tp);
				case 'holiday':
					return $author$project$NotificationForm$holidayDecoder(tp);
				case 'absolute_consumption':
					return A4(
						$author$project$NotificationForm$consumptionDecoder,
						tp,
						sources,
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (a, b) {
									return _Utils_Tuple2(a, b);
								}),
							$author$project$NotificationForm$unitFieldDecoder,
							$author$project$NotificationForm$consumptionExtensionDecoder),
						F2(
							function (core, _v1) {
								var u = _v1.a;
								var e = _v1.b;
								return A3($author$project$NotificationForm$AbsoluteConsumptionSpec, core, u, e);
							}));
				case 'relative_consumption':
					return A4(
						$author$project$NotificationForm$consumptionDecoder,
						tp,
						sources,
						$author$project$NotificationForm$consumptionExtensionDecoder,
						F2(
							function (core, e) {
								return A2($author$project$NotificationForm$RelativeConsumptionSpec, core, e);
							}));
				case 'consumption_limit':
					return A4(
						$author$project$NotificationForm$consumptionDecoder,
						tp,
						sources,
						A4(
							$elm$json$Json$Decode$map3,
							F3(
								function (a, b, c) {
									return _Utils_Tuple3(a, b, c);
								}),
							$author$project$NotificationForm$unitFieldDecoder,
							$author$project$NotificationForm$periodFieldDecoder(true),
							$author$project$NotificationForm$constraintsDecoder),
						F2(
							function (core, _v2) {
								var u = _v2.a;
								var p = _v2.b;
								var c = _v2.c;
								return A4($author$project$NotificationForm$ConsumptionLimitSpec, core, u, p, c);
							}));
				case 'specific_consumption':
					return A4(
						$author$project$NotificationForm$consumptionDecoder,
						tp,
						sources,
						A4(
							$elm$json$Json$Decode$map3,
							F3(
								function (a, b, c) {
									return _Utils_Tuple3(a, b, c);
								}),
							$author$project$NotificationForm$unitFieldDecoder,
							$author$project$NotificationForm$periodFieldDecoder(false),
							$author$project$NotificationForm$divisorFieldDecoder),
						F2(
							function (core, _v3) {
								var u = _v3.a;
								var p = _v3.b;
								var d = _v3.c;
								return A4($author$project$NotificationForm$SpecificConsumptionSpec, core, u, p, d);
							}));
				case 'data_series':
					return $author$project$NotificationForm$dataSeriesDecoder(sources);
				case 'q_extreme':
					return A2($author$project$NotificationForm$qExtremeDecoder, tp, sources);
				case 'meter_error_state':
					return $author$project$NotificationForm$meterErrorStateDecoder(tp);
				case 'wastage_detection':
					return A2($author$project$NotificationForm$wastageDetectionDecoder, tp, sources);
				default:
					return $elm$json$Json$Decode$fail('unsupported type ' + tp);
			}
		},
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
};
var $author$project$Enectiva$ValidatedValue$stringDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$ValidatedValue$init(s));
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationForm$notificationDecoder = F2(
	function (sources, smsRecipient) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			smsRecipient,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email_recipient_ids',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Set$fromList,
						$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						$author$project$NotificationForm$NotAsked,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$NotificationForm$specDecoder(sources),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'text',
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed('')
										])),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$author$project$Enectiva$ValidatedValue$stringDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$NotificationForm$Notification)))))))));
	});
var $author$project$NotificationForm$ConfiguredPhoneNumber = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$NotificationForm$Forbidden = {$: 0};
var $author$project$NotificationForm$UnconfirmedPhoneNumber = function (a) {
	return {$: 2, a: a};
};
var $author$project$SelectionState$NotSelected = 1;
var $author$project$SelectionState$Selected = 0;
var $author$project$SelectionState$fromBool = function (bool) {
	return bool ? 0 : 1;
};
var $author$project$SelectionState$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$SelectionState$fromBool, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$bool);
var $author$project$NotificationForm$smsRecipientDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'forbidden':
				return $elm$json$Json$Decode$succeed($author$project$NotificationForm$Forbidden);
			case 'unconfigured':
				return $elm$json$Json$Decode$succeed($author$project$NotificationForm$UnconfiguredPhoneNumber);
			case 'unconfirmed':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$NotificationForm$UnconfirmedPhoneNumber));
			case 'configured':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'selected',
					$author$project$SelectionState$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'number',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$NotificationForm$ConfiguredPhoneNumber)));
			default:
				return $elm$json$Json$Decode$fail('unknown SmsRecipient state ' + state);
		}
	},
	A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string));
var $author$project$NotificationForm$initNotification = F5(
	function (json, users, userId, smsRecipientJson, sources) {
		var smsRecipient = A2(
			$elm$core$Result$withDefault,
			$author$project$NotificationForm$UnconfiguredPhoneNumber,
			A2($elm$json$Json$Decode$decodeValue, $author$project$NotificationForm$smsRecipientDecoder, smsRecipientJson));
		var _v0 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($author$project$NotificationForm$notificationDecoder, sources, smsRecipient),
			json);
		if (!_v0.$) {
			var notification = _v0.a;
			return notification;
		} else {
			var err = _v0.a;
			return A2(
				$author$project$NotificationForm$newNotification,
				smsRecipient,
				A2(
					$elm$core$Set$intersect,
					$elm$core$Set$fromList(
						_List_fromArray(
							[userId])),
					$elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.K;
							},
							users))));
		}
	});
var $author$project$NotificationForm$meterDecoder = function (decoder) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'breadcrumbs',
			$elm$json$Json$Decode$list($author$project$Types$fullEntityDecoder),
			$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
};
var $author$project$Types$ConsumptionMeter = 1;
var $author$project$Types$PhysicalMeter = F5(
	function (id, entityId, name, energy, meterType) {
		return {g: energy, ig: entityId, K: id, gv: meterType, a8: name};
	});
var $author$project$Types$coreMeterDecoder = function (constructor) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'energy',
		$author$project$Types$energyDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'entity_id',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed(constructor)))));
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Types$ProductionMeter = 0;
var $author$project$Types$stringToMeterType = function (str) {
	switch (str) {
		case 'consumption':
			return $elm$core$Result$Ok(1);
		case 'production':
			return $elm$core$Result$Ok(0);
		default:
			return $elm$core$Result$Err('unknown meter type ' + str);
	}
};
var $author$project$Types$physicalMeterDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'meter_type',
	A2(
		$elm$json$Json$Decode$andThen,
		A2($elm$core$Basics$composeR, $author$project$Types$stringToMeterType, $author$project$Enectiva$Conversion$decodeResult),
		$elm$json$Json$Decode$string),
	1,
	$author$project$Types$coreMeterDecoder($author$project$Types$PhysicalMeter));
var $author$project$NotificationForm$initPhysicalMeters = function (json) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$list(
				$author$project$NotificationForm$meterDecoder($author$project$Types$physicalMeterDecoder)),
			json));
};
var $author$project$Types$VirtualMeter = F4(
	function (id, entityId, name, energy) {
		return {g: energy, ig: entityId, K: id, a8: name};
	});
var $author$project$Types$virtualMeterDecoder = $author$project$Types$coreMeterDecoder($author$project$Types$VirtualMeter);
var $author$project$NotificationForm$initVirtualMeters = function (json) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$list(
				$author$project$NotificationForm$meterDecoder($author$project$Types$virtualMeterDecoder)),
			json));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$NotificationForm$ServerRespondedToRecipientsRequest = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.hf));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {g_: reqs, hj: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.hq;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.g_));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.hj)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					hL: r.hL,
					fK: r.fK,
					f0: A2(_Http_mapExpect, func, r.f0),
					f9: r.f9,
					gw: r.gw,
					hm: r.hm,
					hq: r.hq,
					hv: r.hv
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{hL: false, fK: r.fK, f0: r.f0, f9: r.f9, gw: r.gw, hm: r.hm, hq: r.hq, hv: r.hv}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{fK: $elm$http$Http$emptyBody, f0: r.f0, f9: _List_Nil, gw: 'GET', hm: $elm$core$Maybe$Nothing, hq: $elm$core$Maybe$Nothing, hv: r.hv});
};
var $author$project$Enectiva$I18n$locale = function (_v0) {
	var l = _v0.a;
	return l;
};
var $author$project$View$localizeUrl = F2(
	function (url, locale) {
		return '/' + (locale + url);
	});
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $author$project$RecipientsFilter$recipientDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed(
				F3(
					function (id, name, email) {
						return {fY: email, K: id, a8: name};
					})))));
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Enectiva$ValidatedValue$value = function (v) {
	switch (v.$) {
		case 1:
			var s = v.a;
			return s;
		case 2:
			var s = v.a;
			return s;
		default:
			var s = v.a;
			return s;
	}
};
var $author$project$RecipientsFilter$selectedIds = function (_v0) {
	var selected = _v0.fe;
	return $author$project$Enectiva$ValidatedValue$value(selected);
};
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$NotificationsForm$SourceSelection$map = F5(
	function (meterFn, vmFn, entityFn, dsFn, source) {
		switch (source.$) {
			case 0:
				var matching = source.a;
				var breadcrumbs = source.b;
				var physicalMeter = source.c;
				return A3(meterFn, matching, breadcrumbs, physicalMeter);
			case 1:
				var matching = source.a;
				var breadcrumbs = source.b;
				var vm = source.c;
				return A3(vmFn, matching, breadcrumbs, vm);
			case 2:
				var matching = source.a;
				var breadcrumbs = source.b;
				var entity = source.c;
				return A3(entityFn, matching, breadcrumbs, entity);
			default:
				var matching = source.a;
				var breadcrumbs = source.b;
				var ds = source.c;
				return A3(dsFn, matching, breadcrumbs, ds);
		}
	});
var $author$project$NotificationsForm$SourceSelection$mapRealSource = F4(
	function (meterFn, vmFm, entityFn, dsFn) {
		return A4(
			$author$project$NotificationsForm$SourceSelection$map,
			$elm$core$Basics$always(meterFn),
			$elm$core$Basics$always(vmFm),
			$elm$core$Basics$always(entityFn),
			$elm$core$Basics$always(dsFn));
	});
var $author$project$SelectList$selected = function (_v0) {
	var sel = _v0.b;
	return sel;
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$NotificationsForm$SourceSelection$toQueryParams = function (_v0) {
	var list = _v0._;
	return $elm$core$List$singleton(
		A5(
			$author$project$NotificationsForm$SourceSelection$mapRealSource,
			F2(
				function (_v1, m) {
					return A2(
						$elm$url$Url$Builder$string,
						'physical_meter_id',
						$elm$core$String$fromInt(m.K));
				}),
			F2(
				function (_v2, vm) {
					return A2(
						$elm$url$Url$Builder$string,
						'virtual_meter_id',
						$elm$core$String$fromInt(vm.K));
				}),
			F2(
				function (_v3, e) {
					return A2(
						$elm$url$Url$Builder$string,
						'entity_id',
						$elm$core$String$fromInt(e.K));
				}),
			F2(
				function (_v4, ds) {
					return A2(
						$elm$url$Url$Builder$string,
						'data_series_id',
						$elm$core$String$fromInt(ds.K));
				}),
			$author$project$SelectList$selected(list)));
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$NotificationForm$unOnly = F2(
	function (model, changer) {
		var notification = model.h;
		return _Utils_update(
			model,
			{
				h: changer(notification)
			});
	});
var $author$project$NotificationForm$unCmd = F3(
	function (cmds, model, changer) {
		return _Utils_Tuple2(
			A2($author$project$NotificationForm$unOnly, model, changer),
			$elm$core$Platform$Cmd$batch(cmds));
	});
var $author$project$NotificationForm$loadRecipientCandidatesHelp = F2(
	function (_v0, sources) {
		var model = _v0.a;
		var cmd = _v0.b;
		var queryParams = $author$project$NotificationsForm$SourceSelection$toQueryParams(sources);
		var previouslySelectedIds = $krisajenkins$remotedata$RemoteData$toMaybe(
			A2($krisajenkins$remotedata$RemoteData$map, $author$project$RecipientsFilter$selectedIds, model.h.z));
		var locale = $author$project$Enectiva$I18n$locale(model.A);
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					A2($author$project$View$localizeUrl, '/notifications/candidate_recipients', locale)
				]),
			queryParams);
		var request = $elm$http$Http$get(
			{
				f0: A2(
					$elm$http$Http$expectJson,
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$NotificationForm$ServerRespondedToRecipientsRequest(previouslySelectedIds)),
					A2(
						$elm$json$Json$Decode$field,
						'candidate_recipients',
						$elm$json$Json$Decode$list($author$project$RecipientsFilter$recipientDecoder))),
				hv: url
			});
		return A3(
			$author$project$NotificationForm$unCmd,
			_List_fromArray(
				[cmd, request]),
			model,
			function (n) {
				return _Utils_update(
					n,
					{z: $krisajenkins$remotedata$RemoteData$Loading});
			});
	});
var $author$project$RecipientsFilter$new = function (_v0) {
	var recipients = _v0.i2;
	var selected = _v0.fe;
	return {
		c$: '',
		i2: recipients,
		fe: $author$project$Enectiva$ValidatedValue$init(selected)
	};
};
var $author$project$NotificationForm$initRecipientsModel = F2(
	function (selected, list) {
		return $author$project$RecipientsFilter$new(
			{
				i2: list,
				fe: A2(
					$elm$core$Set$intersect,
					selected,
					$elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.K;
							},
							list)))
			});
	});
var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;
var $author$project$NotificationForm$useAllRecipients = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var recipients = A2($author$project$NotificationForm$initRecipientsModel, model.h.dJ, model.z);
	return A3(
		$author$project$NotificationForm$unCmd,
		_List_fromArray(
			[cmd]),
		model,
		function (n) {
			return _Utils_update(
				n,
				{
					z: $krisajenkins$remotedata$RemoteData$succeed(recipients)
				});
		});
};
var $author$project$NotificationForm$loadRecipientCandidates = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = model.h.j;
	switch (_v1.$) {
		case 3:
			var cc = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				cc.e);
		case 4:
			var cc = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				cc.e);
		case 5:
			var cc = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				cc.e);
		case 6:
			var dsc = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				dsc.e);
		case 7:
			var dsc = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				dsc.e);
		case 8:
			var qextreme = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				qextreme.e);
		case 10:
			var cc = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				cc.e);
		case 11:
			var spec = _v1.a;
			return A2(
				$author$project$NotificationForm$loadRecipientCandidatesHelp,
				_Utils_Tuple2(model, cmd),
				spec.e);
		default:
			return $author$project$NotificationForm$useAllRecipients(
				_Utils_Tuple2(model, cmd));
	}
};
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Enectiva$I18n$Translations = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$newTranslations = $author$project$Enectiva$I18n$Translations;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Types$UnknownEnergy = 0;
var $author$project$NotificationForm$parseEnergies = function (ewus) {
	return A2(
		$elm$core$List$map,
		function (ewu) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$energyDecoder, ewu.g);
			if (!_v0.$) {
				var energy = _v0.a;
				return {g: energy, bb: ewu.bb};
			} else {
				return {
					g: 0,
					bb: _List_fromArray(
						[''])
				};
			}
		},
		ewus);
};
var $author$project$NotificationsForm$SourceSelection$DataSeries = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$NotificationsForm$SourceSelection$Entity = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$NotificationsForm$SourceSelection$PhysicalMeter = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$NotificationsForm$SourceSelection$VirtualMeter = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$NotificationsForm$SourceSelection$sourcesFromLists = F4(
	function (physicalMeters, virtualMeters, entities, dss) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var bc = _v0.a;
					var m = _v0.b;
					return A3($author$project$NotificationsForm$SourceSelection$PhysicalMeter, true, bc, m);
				},
				physicalMeters),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var bc = _v1.a;
						var vm = _v1.b;
						return A3($author$project$NotificationsForm$SourceSelection$VirtualMeter, true, bc, vm);
					},
					virtualMeters),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (_v2) {
							var bc = _v2.a;
							var e = _v2.b;
							return A3($author$project$NotificationsForm$SourceSelection$Entity, true, bc, e);
						},
						entities),
					A2(
						$elm$core$List$map,
						function (_v3) {
							var bc = _v3.a;
							var ds = _v3.b;
							return A3($author$project$NotificationsForm$SourceSelection$DataSeries, true, bc, ds);
						},
						dss))));
	});
var $author$project$NotificationForm$init = function (flags) {
	var virtualMeters = $author$project$NotificationForm$initVirtualMeters(flags.fx);
	var physicalMeters = $author$project$NotificationForm$initPhysicalMeters(flags.e4);
	var entities = A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$list($author$project$NotificationForm$entityDecoder),
			flags.ee));
	var energiesWithUnits = $author$project$NotificationForm$parseEnergies(flags.aB);
	var divisors = function (m) {
		if (m.$ === 1) {
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		} else {
			var ds = m.a;
			return $krisajenkins$remotedata$RemoteData$succeed(ds);
		}
	}(
		A2(
			$elm$core$Result$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$json$Json$Decode$decodeValue,
				$elm$json$Json$Decode$maybe(
					$elm$json$Json$Decode$list($author$project$Divisor$decoder)),
				flags.a2)));
	var dataSeries = A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$list($author$project$NotificationForm$dataSeriesWithBreadcrumbsDecoder),
			flags.d7));
	var sources = A4($author$project$NotificationsForm$SourceSelection$sourcesFromLists, physicalMeters, virtualMeters, entities, dataSeries);
	var notification = A5($author$project$NotificationForm$initNotification, flags.h, flags.z, flags.fw, flags.aI, sources);
	var atLeastOneMeter = !($elm$core$List$isEmpty(physicalMeters) && $elm$core$List$isEmpty(virtualMeters));
	var atLeastOneEntity = !$elm$core$List$isEmpty(entities);
	var atLeastOneElMeter = atLeastOneMeter && (A2(
		$elm$core$List$any,
		function (_v0) {
			var energy = _v0.b.g;
			return energy === 1;
		},
		physicalMeters) || A2(
		$elm$core$List$any,
		function (_v1) {
			var energy = _v1.b.g;
			return energy === 1;
		},
		virtualMeters));
	var atLeastOneDS = !$elm$core$List$isEmpty(dataSeries);
	var possibleTypes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(0),
				$elm$core$Maybe$Just(1),
				A2($author$project$NotificationForm$boolToMaybe, atLeastOneMeter || atLeastOneEntity, 2),
				A2($author$project$NotificationForm$boolToMaybe, atLeastOneMeter || atLeastOneEntity, 3),
				A2($author$project$NotificationForm$boolToMaybe, atLeastOneMeter || atLeastOneEntity, 4),
				A2($author$project$NotificationForm$boolToMaybe, atLeastOneMeter || atLeastOneEntity, 7),
				A2($author$project$NotificationForm$boolToMaybe, atLeastOneElMeter, 5),
				A2($author$project$NotificationForm$boolToMaybe, atLeastOneDS, 6)
			]));
	var model = {
		bG: flags.bG,
		bl: flags.bl,
		bm: flags.bm,
		a2: divisors,
		z: flags.z,
		aB: energiesWithUnits,
		h: notification,
		cf: $author$project$Enectiva$Conversion$parseStdDate(flags.cf),
		e5: possibleTypes,
		aT: sources,
		A: A2($author$project$Enectiva$I18n$newTranslations, flags.eE, flags.A)
	};
	return $author$project$NotificationForm$loadRecipientCandidates(
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
};
var $author$project$NotificationForm$Noop = {$: 0};
var $author$project$NotificationForm$appName = 'nf';
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Enectiva$I18n$matchNumber = F2(
	function (m, ms) {
		return _Utils_update(
			ms,
			{dG: m});
	});
var $author$project$Enectiva$I18n$emptyParsingMatcher = F2(
	function (_v0, _v1) {
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Enectiva$I18n$matchers = {dn: $author$project$Enectiva$I18n$emptyParsingMatcher, $7: $author$project$Enectiva$I18n$emptyParsingMatcher, dp: $author$project$Enectiva$I18n$emptyParsingMatcher, dG: $author$project$Enectiva$I18n$emptyParsingMatcher};
var $author$project$Enectiva$I18n$ParsedDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsedDateRange = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsedDateTime = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsedNumber = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsingError = function (a) {
	return {$: 4, a: a};
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 1:
			return 'expecting int';
		case 2:
			return 'expecting hex';
		case 3:
			return 'expecting octal';
		case 4:
			return 'expecting binary';
		case 5:
			return 'expecting float';
		case 6:
			return 'expecting number';
		case 7:
			return 'expecting variable';
		case 8:
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 9:
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 10:
			return 'expecting end';
		case 11:
			return 'unexpected char';
		case 12:
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.gT) + (' at row ' + ($elm$core$String$fromInt(deadend.g2) + (', col ' + $elm$core$String$fromInt(deadend.fO))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.d);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.iV, offset) < 0,
					0,
					{fO: col, l: s0.l, q: s0.q, iV: offset, g2: row, d: s0.d});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.iV, s.g2, s.fO, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Enectiva$DateRange$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Enectiva$Conversion$dateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Enectiva$Conversion$dateDecoder,
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $author$project$Enectiva$I18n$resultDateRangeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (err) {
				return $elm$json$Json$Decode$succeed(
					$elm$core$Result$Err(err));
			},
			A2($elm$json$Json$Decode$field, 'err', $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (range) {
				return $elm$json$Json$Decode$succeed(
					$elm$core$Result$Ok(range));
			},
			$author$project$Enectiva$DateRange$decoder)
		]));
var $author$project$Enectiva$I18n$parseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (tp) {
		switch (tp) {
			case 'number':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedNumber,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			case 'date':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$Enectiva$Conversion$dateDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedDate,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			case 'dateTime':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedDateTime,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			case 'dateRange':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$Enectiva$I18n$resultDateRangeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedDateRange,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			default:
				var anotherType = tp;
				return $elm$json$Json$Decode$succeed(
					$author$project$Enectiva$I18n$ParsingError('unrecognized type ' + anotherType));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Enectiva$I18n$parseResult = _Platform_incomingPort('parseResult', $elm$json$Json$Decode$value);
var $author$project$Enectiva$I18n$parsed = F3(
	function (noop, appName, _v0) {
		var number = _v0.dG;
		var date = _v0.dn;
		var dateTime = _v0.dp;
		var dateRange = _v0.$7;
		return $author$project$Enectiva$I18n$parseResult(
			function (pr) {
				var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Enectiva$I18n$parseDecoder, pr);
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 0:
							var _v2 = _v1.a;
							var _v3 = _v2.a;
							var an = _v3.a;
							var id = _v3.b;
							var n = _v2.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(number, id, n)) : noop;
						case 1:
							var _v4 = _v1.a;
							var _v5 = _v4.a;
							var an = _v5.a;
							var id = _v5.b;
							var d = _v4.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(date, id, d)) : noop;
						case 2:
							var _v6 = _v1.a;
							var _v7 = _v6.a;
							var an = _v7.a;
							var id = _v7.b;
							var dt = _v6.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(dateTime, id, dt)) : noop;
						case 3:
							var _v8 = _v1.a;
							var _v9 = _v8.a;
							var an = _v9.a;
							var id = _v9.b;
							var resultRange = _v8.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(dateRange, id, resultRange)) : noop;
						default:
							return noop;
					}
				} else {
					return noop;
				}
			});
	});
var $author$project$NotificationForm$ChangeThreshold = function (a) {
	return {$: 13, a: a};
};
var $author$project$NotificationForm$ThresholdParsingKey = 0;
var $author$project$NotificationForm$numberParsingKeyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (k) {
		if (k === 'thr') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('unrecognized parsing key ' + k);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationForm$parsedNumberMatcher = F2(
	function (id, val) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$NotificationForm$numberParsingKeyDecoder, id);
		if (!_v0.$) {
			var _v1 = _v0.a;
			return $elm$core$Maybe$Just(
				$author$project$NotificationForm$ChangeThreshold(val));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$NotificationForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A3(
				$author$project$Enectiva$I18n$parsed,
				$author$project$NotificationForm$Noop,
				$author$project$NotificationForm$appName,
				A2($author$project$Enectiva$I18n$matchNumber, $author$project$NotificationForm$parsedNumberMatcher, $author$project$Enectiva$I18n$matchers))
			]));
};
var $author$project$NotificationForm$DivisorSelected = function (a) {
	return {$: 39, a: a};
};
var $author$project$BareDate$wholeYear = _Utils_Tuple2(
	_Utils_Tuple2(1, 1),
	_Utils_Tuple2(12, 31));
var $author$project$NotificationForm$addDateRangeConstraintHelp = function (_v0) {
	var dow = _v0.a;
	var hod = _v0.b;
	var drs = _v0.c;
	return _Utils_Tuple3(
		dow,
		hod,
		_Utils_ap(
			drs,
			_List_fromArray(
				[$author$project$BareDate$wholeYear])));
};
var $author$project$NotificationForm$un = $author$project$NotificationForm$unCmd(_List_Nil);
var $author$project$NotificationForm$us = F2(
	function (model, changer) {
		return A2(
			$author$project$NotificationForm$un,
			model,
			function (n) {
				return _Utils_update(
					n,
					{
						j: changer(n.j)
					});
			});
	});
var $author$project$NotificationForm$addDateRangeConstraint = function (model) {
	return A2(
		$author$project$NotificationForm$us,
		model,
		function (s) {
			switch (s.$) {
				case 5:
					var spec = s.a;
					var unit = s.b;
					var period = s.c;
					var constraints = s.d;
					return A4(
						$author$project$NotificationForm$ConsumptionLimitSpec,
						spec,
						unit,
						period,
						$author$project$NotificationForm$addDateRangeConstraintHelp(constraints));
				case 6:
					var spec = s.a;
					var snooze = s.b;
					var constraints = s.c;
					return A3(
						$author$project$NotificationForm$InstantaneousDataSeriesSpec,
						spec,
						snooze,
						$author$project$NotificationForm$addDateRangeConstraintHelp(constraints));
				case 8:
					var spec = s.a;
					var constraints = $author$project$NotificationForm$addDateRangeConstraintHelp(spec.Y);
					return $author$project$NotificationForm$QExtremeSpec(
						_Utils_update(
							spec,
							{Y: constraints}));
				case 2:
					var spec = s.a;
					return $author$project$NotificationForm$HolidaySpec(
						_Utils_update(
							spec,
							{
								aM: _Utils_ap(
									spec.aM,
									_List_fromArray(
										[$author$project$BareDate$wholeYear]))
							}));
				default:
					return s;
			}
		});
};
var $author$project$Enectiva$I18n$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$ValidatedValue$Invalid = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Enectiva$ValidatedValue$Valid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Enectiva$ValidatedValue$toValidation = F2(
	function (val, result) {
		if (!result.$) {
			var v = result.a;
			return $author$project$Enectiva$ValidatedValue$Valid(v);
		} else {
			var err = result.a;
			return A2(
				$author$project$Enectiva$ValidatedValue$Invalid,
				$author$project$Enectiva$ValidatedValue$value(val),
				err);
		}
	});
var $author$project$Enectiva$ValidatedValue$validateInner = F2(
	function (str, validator) {
		switch (str.$) {
			case 2:
				return str;
			case 1:
				var s = str.a;
				return validator(s);
			default:
				var s = str.a;
				return validator(s);
		}
	});
var $author$project$Enectiva$ValidatedValue$customValidation = F2(
	function (rule, val) {
		return A2(
			$author$project$Enectiva$ValidatedValue$validateInner,
			val,
			A2(
				$elm$core$Basics$composeR,
				rule,
				$author$project$Enectiva$ValidatedValue$toValidation(val)));
	});
var $author$project$Enectiva$I18n$applyOption = function (option) {
	if (!option.$) {
		var placeholder = option.a;
		var value = option.b;
		return A2(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('%{' + (placeholder + '}'))),
			$elm$core$Basics$always(value));
	} else {
		return $elm$core$Basics$identity;
	}
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Enectiva$I18n$one = 'one';
var $author$project$Enectiva$I18n$other = 'other';
var $author$project$Enectiva$I18n$fallbackPluralizationFn = function (cnt) {
	if (cnt === 1) {
		return $author$project$Enectiva$I18n$one;
	} else {
		return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$few = 'few';
var $author$project$Enectiva$I18n$czechPluralizationFn = function (cnt) {
	switch (cnt) {
		case 1:
			return $author$project$Enectiva$I18n$one;
		case 2:
			return $author$project$Enectiva$I18n$few;
		case 3:
			return $author$project$Enectiva$I18n$few;
		case 4:
			return $author$project$Enectiva$I18n$few;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$frenchPluralizationFn = function (cnt) {
	switch (cnt) {
		case 0:
			return $author$project$Enectiva$I18n$one;
		case 1:
			return $author$project$Enectiva$I18n$one;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Enectiva$I18n$slovakPluralizationFn = $author$project$Enectiva$I18n$czechPluralizationFn;
var $author$project$Enectiva$I18n$pluralizationFns = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('cs', $author$project$Enectiva$I18n$czechPluralizationFn),
			_Utils_Tuple2('sk', $author$project$Enectiva$I18n$slovakPluralizationFn),
			_Utils_Tuple2('fr', $author$project$Enectiva$I18n$frenchPluralizationFn),
			_Utils_Tuple2(
			'hu',
			$elm$core$Basics$always($author$project$Enectiva$I18n$other))
		]));
var $author$project$Enectiva$I18n$countToKeyPathSegment = F2(
	function (_v0, cnt) {
		var l = _v0.a;
		return A3(
			$elm$core$Basics$apR,
			A2($elm$core$Dict$get, l, $author$project$Enectiva$I18n$pluralizationFns),
			$elm$core$Maybe$withDefault($author$project$Enectiva$I18n$fallbackPluralizationFn),
			$elm$core$Basics$abs(cnt));
	});
var $author$project$Enectiva$I18n$keyToKeyPath = $elm$core$String$split('.');
var $author$project$Enectiva$I18n$providedCount = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (o) {
					if (o.$ === 1) {
						var cnt = o.a;
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$Just(cnt));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				options)));
};
var $author$project$Enectiva$I18n$tHelp = F2(
	function (_v0, keyPath) {
		var translations = _v0.b;
		return A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$at, keyPath, $elm$json$Json$Decode$string),
			translations);
	});
var $author$project$Enectiva$I18n$t = F2(
	function (translations, key) {
		return A2(
			$elm$core$Result$withDefault,
			key,
			A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				$author$project$Enectiva$I18n$keyToKeyPath(key)));
	});
var $author$project$Enectiva$I18n$tt = F3(
	function (translations, key, options) {
		var _v0 = $author$project$Enectiva$I18n$providedCount(options);
		if (!_v0.$) {
			var cnt = _v0.a;
			var _v1 = A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				_Utils_ap(
					$author$project$Enectiva$I18n$keyToKeyPath(key),
					_List_fromArray(
						[
							A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, cnt)
						])));
			if (_v1.$ === 1) {
				var _v2 = A2(
					$author$project$Enectiva$I18n$tHelp,
					translations,
					_Utils_ap(
						$author$project$Enectiva$I18n$keyToKeyPath(key),
						_List_fromArray(
							[
								A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, 1)
							])));
				if (_v2.$ === 1) {
					return A2($author$project$Enectiva$I18n$t, translations, key);
				} else {
					var localized = _v2.a;
					return localized;
				}
			} else {
				var localized = _v1.a;
				return A2(
					$author$project$Enectiva$I18n$applyOption,
					A2(
						$author$project$Enectiva$I18n$Placeholder,
						'count',
						$elm$core$String$fromInt(cnt)),
					localized);
			}
		} else {
			return A3(
				$elm$core$List$foldl,
				$author$project$Enectiva$I18n$applyOption,
				A2($author$project$Enectiva$I18n$t, translations, key),
				options);
		}
	});
var $author$project$NotificationForm$atLeastOneValidation = function (translations) {
	return $author$project$Enectiva$ValidatedValue$customValidation(
		function (_int) {
			return (_int >= 1) ? $elm$core$Result$Ok(_int) : $elm$core$Result$Err(
				A3(
					$author$project$Enectiva$I18n$tt,
					translations,
					'errors.messages.greater_than_or_equal_to',
					_List_fromArray(
						[
							A2($author$project$Enectiva$I18n$Placeholder, 'count', '1')
						])));
		});
};
var $author$project$NotificationForm$advanceValidation = F2(
	function (translations, advance) {
		return A2(
			$author$project$NotificationForm$atLeastOneValidation,
			translations,
			$author$project$Enectiva$ValidatedValue$init(advance));
	});
var $author$project$NotificationForm$changeAdvance = F2(
	function (model, advance) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				if (s.$ === 2) {
					var spec = s.a;
					return $author$project$NotificationForm$HolidaySpec(
						_Utils_update(
							spec,
							{
								aZ: A2($author$project$NotificationForm$advanceValidation, model.A, advance)
							}));
				} else {
					return s;
				}
			});
	});
var $author$project$NotificationForm$newArbitraryDate = function (date) {
	return $author$project$NotificationForm$ArbitraryDateSpec(
		{dn: date});
};
var $author$project$NotificationForm$changeArbitraryDate = F2(
	function (model, date) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				if (s.$ === 1) {
					return $author$project$NotificationForm$newArbitraryDate(date);
				} else {
					return s;
				}
			});
	});
var $author$project$NotificationForm$changeConsumptionHelp = F2(
	function (fn, s) {
		switch (s.$) {
			case 3:
				var spec = s.a;
				var unit = s.b;
				var extension = s.c;
				return A3(
					$author$project$NotificationForm$AbsoluteConsumptionSpec,
					fn(spec),
					unit,
					extension);
			case 4:
				var spec = s.a;
				var extension = s.b;
				return A2(
					$author$project$NotificationForm$RelativeConsumptionSpec,
					fn(spec),
					extension);
			case 5:
				var spec = s.a;
				var unit = s.b;
				var period = s.c;
				var constraint = s.d;
				return A4(
					$author$project$NotificationForm$ConsumptionLimitSpec,
					fn(spec),
					unit,
					period,
					constraint);
			case 10:
				var spec = s.a;
				var unit = s.b;
				var period = s.c;
				var divisor = s.d;
				return A4(
					$author$project$NotificationForm$SpecificConsumptionSpec,
					fn(spec),
					unit,
					period,
					divisor);
			default:
				return s;
		}
	});
var $author$project$NotificationForm$changeConsumption = F2(
	function (fn, model) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			$author$project$NotificationForm$changeConsumptionHelp(fn));
	});
var $author$project$NotificationsForm$SourceSelection$consumptionBasedMeasure = function (measure) {
	return (measure === 1) || (!measure);
};
var $author$project$SelectList$selectHelp = F4(
	function (isSelectable, beforeList, selectedElem, afterList) {
		var _v0 = _Utils_Tuple2(beforeList, afterList);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v1 = _v0.b;
				var first = _v1.a;
				var rest = _v1.b;
				if (isSelectable(selectedElem)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(beforeList, selectedElem, afterList));
				} else {
					if (isSelectable(first)) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								_Utils_ap(
									beforeList,
									_List_fromArray(
										[selectedElem])),
								first,
								rest));
					} else {
						var _v2 = A4($author$project$SelectList$selectHelp, isSelectable, _List_Nil, first, rest);
						if (_v2.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v3 = _v2.a;
							var newBefore = _v3.a;
							var newSelected = _v3.b;
							var newAfter = _v3.c;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($elm$core$List$cons, selectedElem, newBefore),
									newSelected,
									newAfter));
						}
					}
				}
			}
		} else {
			var _v4 = _v0.a;
			var first = _v4.a;
			var rest = _v4.b;
			if (isSelectable(first)) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						_List_Nil,
						first,
						_Utils_ap(
							rest,
							A2($elm$core$List$cons, selectedElem, afterList))));
			} else {
				var _v5 = A4($author$project$SelectList$selectHelp, isSelectable, rest, selectedElem, afterList);
				if (_v5.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v6 = _v5.a;
					var newBefore = _v6.a;
					var newSelected = _v6.b;
					var newAfter = _v6.c;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							A2($elm$core$List$cons, first, newBefore),
							newSelected,
							newAfter));
				}
			}
		}
	});
var $author$project$SelectList$select = F2(
	function (isSelectable, original) {
		var beforeSel = original.a;
		var sel = original.b;
		var afterSel = original.c;
		var _v0 = A4($author$project$SelectList$selectHelp, isSelectable, beforeSel, sel, afterSel);
		if (_v0.$ === 1) {
			return original;
		} else {
			var _v1 = _v0.a;
			var newBefore = _v1.a;
			var newSel = _v1.b;
			var newAfter = _v1.c;
			return A3($author$project$SelectList$SelectList, newBefore, newSel, newAfter);
		}
	});
var $author$project$NotificationsForm$SourceSelection$productionBasedMeasure = function (measure) {
	return (measure === 3) || (measure === 2);
};
var $author$project$NotificationsForm$SourceSelection$sourceMeterOfNeededType = F2(
	function (meter, measure) {
		var _v0 = meter.gv;
		if (!_v0) {
			return $author$project$NotificationsForm$SourceSelection$productionBasedMeasure(measure);
		} else {
			return $author$project$NotificationsForm$SourceSelection$consumptionBasedMeasure(measure);
		}
	});
var $author$project$NotificationsForm$SourceSelection$selectFirstMeterOrEntityWithMeasureAndEnergy = F3(
	function (measure, energy, selection) {
		var selector = A4(
			$author$project$NotificationsForm$SourceSelection$mapRealSource,
			F2(
				function (_v0, meter) {
					return A2($author$project$NotificationsForm$SourceSelection$sourceMeterOfNeededType, meter, measure) && _Utils_eq(meter.g, energy);
				}),
			F2(
				function (_v1, vm) {
					return $author$project$NotificationsForm$SourceSelection$consumptionBasedMeasure(measure) && _Utils_eq(vm.g, energy);
				}),
			$elm$core$Basics$always(
				$elm$core$Basics$always(true)),
			$elm$core$Basics$always(
				$elm$core$Basics$always(true)));
		return _Utils_update(
			selection,
			{
				_: A2($author$project$SelectList$select, selector, selection._)
			});
	});
var $author$project$NotificationsForm$SourceSelection$ensureMeasureAndEnergyConsistency = F3(
	function (measure, energy, selection) {
		return A5(
			$author$project$NotificationsForm$SourceSelection$mapRealSource,
			F2(
				function (_v0, meter) {
					return (A2($author$project$NotificationsForm$SourceSelection$sourceMeterOfNeededType, meter, measure) && _Utils_eq(meter.g, energy)) ? selection : A3($author$project$NotificationsForm$SourceSelection$selectFirstMeterOrEntityWithMeasureAndEnergy, measure, energy, selection);
				}),
			F2(
				function (_v1, vm) {
					return (_Utils_eq(vm.g, energy) && $author$project$NotificationsForm$SourceSelection$consumptionBasedMeasure(measure)) ? selection : A3($author$project$NotificationsForm$SourceSelection$selectFirstMeterOrEntityWithMeasureAndEnergy, measure, energy, selection);
				}),
			$elm$core$Basics$always(
				$elm$core$Basics$always(selection)),
			$elm$core$Basics$always(
				$elm$core$Basics$always(selection)),
			$author$project$SelectList$selected(selection._));
	});
var $author$project$NotificationForm$invalidatePreview = function (spec) {
	var preview = function () {
		var _v0 = spec.u;
		switch (_v0.$) {
			case 2:
				return $author$project$NotificationForm$NotAsked;
			case 1:
				return $author$project$NotificationForm$NotAsked;
			default:
				return spec.u;
		}
	}();
	return _Utils_update(
		spec,
		{u: preview});
};
var $author$project$NotificationForm$ServerRespondedWithDivisors = function (a) {
	return {$: 40, a: a};
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$http$Http$stringBody = _Http_pair;
var $author$project$Enectiva$HttpExtra$emptyBody = A2(
	$elm$http$Http$stringBody,
	'',
	A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$int(0)));
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Enectiva$HttpExtra$request = F6(
	function (token, verb, decoder, url, body, tagger) {
		return $elm$http$Http$request(
			{
				fK: body,
				f0: A2($elm$http$Http$expectJson, tagger, decoder),
				f9: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-Token', token),
						A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
					]),
				gw: verb,
				hm: $elm$core$Maybe$Nothing,
				hq: $elm$core$Maybe$Nothing,
				hv: url
			});
	});
var $author$project$NotificationsForm$SourceSelection$sourceEncoder = function (source) {
	return A5(
		$author$project$NotificationsForm$SourceSelection$mapRealSource,
		F2(
			function (_v0, meter) {
				return _Utils_Tuple2(
					'physical_meter_id',
					$elm$json$Json$Encode$int(meter.K));
			}),
		F2(
			function (_v1, vm) {
				return _Utils_Tuple2(
					'virtual_meter_id',
					$elm$json$Json$Encode$int(vm.K));
			}),
		F2(
			function (_v2, entity) {
				return _Utils_Tuple2(
					'entity_id',
					$elm$json$Json$Encode$int(entity.K));
			}),
		F2(
			function (_v3, ds) {
				return _Utils_Tuple2(
					'data_series_id',
					$elm$json$Json$Encode$int(ds.K));
			}),
		source);
};
var $author$project$NotificationForm$loadDivisors = F2(
	function (model, source) {
		var sourceQueryParam = function (_v0) {
			var key = _v0.a;
			var val = _v0.b;
			return key + ('=' + A2($elm$json$Json$Encode$encode, 0, val));
		}(
			$author$project$NotificationsForm$SourceSelection$sourceEncoder(source));
		var url = A2(
			$author$project$View$localizeUrl,
			'/notifications/divisors?' + sourceQueryParam,
			$author$project$Enectiva$I18n$locale(model.A));
		return A6(
			$author$project$Enectiva$HttpExtra$request,
			model.bl,
			'GET',
			$elm$json$Json$Decode$list($author$project$Divisor$decoder),
			url,
			$author$project$Enectiva$HttpExtra$emptyBody,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$NotificationForm$ServerRespondedWithDivisors));
	});
var $author$project$NotificationsForm$SourceSelection$selected = function (selection) {
	return $author$project$SelectList$selected(selection._);
};
var $author$project$NotificationForm$reloadDivisors = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var loadDivisorsCmd = function () {
		var _v1 = model.h.j;
		if (_v1.$ === 10) {
			var sc = _v1.a;
			return A2(
				$author$project$NotificationForm$loadDivisors,
				model,
				$author$project$NotificationsForm$SourceSelection$selected(sc.e));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	}();
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{a2: $krisajenkins$remotedata$RemoteData$Loading}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmd, loadDivisorsCmd])));
};
var $author$project$NotificationForm$changeUnitHelp = F2(
	function (model, unit) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 3:
						var spec = s.a;
						var extension = s.c;
						return A3($author$project$NotificationForm$AbsoluteConsumptionSpec, spec, unit, extension);
					case 5:
						var spec = s.a;
						var period = s.c;
						var constraints = s.d;
						return A4($author$project$NotificationForm$ConsumptionLimitSpec, spec, unit, period, constraints);
					case 10:
						var spec = s.a;
						var period = s.c;
						var divisor = s.d;
						return A4($author$project$NotificationForm$SpecificConsumptionSpec, spec, unit, period, divisor);
					default:
						return s;
				}
			});
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$NotificationForm$defaultUnitForEnergy = F2(
	function (model, energy) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.bb;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (e) {
									return _Utils_eq(e.g, energy);
								},
								model.aB))))));
	});
var $author$project$NotificationForm$resetUnit = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var energy = function () {
		var _v2 = model.h.j;
		switch (_v2.$) {
			case 3:
				var spec = _v2.a;
				return spec.g;
			case 5:
				var spec = _v2.a;
				return spec.g;
			case 10:
				var spec = _v2.a;
				return spec.g;
			default:
				return 0;
		}
	}();
	var _v1 = A2(
		$author$project$NotificationForm$changeUnitHelp,
		model,
		A2($author$project$NotificationForm$defaultUnitForEnergy, model, energy));
	var updated = _v1.a;
	return _Utils_Tuple2(updated, cmd);
};
var $author$project$NotificationForm$changeConsumptionEnergy = F3(
	function (model, energy, measure) {
		return $author$project$NotificationForm$loadRecipientCandidates(
			$author$project$NotificationForm$reloadDivisors(
				$author$project$NotificationForm$resetUnit(
					A2(
						$author$project$NotificationForm$changeConsumption,
						A2(
							$elm$core$Basics$composeR,
							function (s) {
								return _Utils_update(
									s,
									{
										g: energy,
										e: A3($author$project$NotificationsForm$SourceSelection$ensureMeasureAndEnergyConsistency, measure, energy, s.e)
									});
							},
							$author$project$NotificationForm$invalidatePreview),
						model))));
	});
var $author$project$NotificationForm$changeConsumptionMeasure = F3(
	function (model, energy, measure) {
		return A2(
			$author$project$NotificationForm$changeConsumption,
			A2(
				$elm$core$Basics$composeR,
				function (s) {
					return _Utils_update(
						s,
						{
							aa: measure,
							e: A3($author$project$NotificationsForm$SourceSelection$ensureMeasureAndEnergyConsistency, measure, energy, s.e)
						});
				},
				$author$project$NotificationForm$invalidatePreview),
			model);
	});
var $author$project$NotificationForm$Loading = {$: 1};
var $author$project$NotificationForm$PreviewResponse = function (a) {
	return {$: 37, a: a};
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$NotificationForm$PreviewValue = F3(
	function (value, from, to) {
		return {f5: from, ho: to, hw: value};
	});
var $author$project$NotificationForm$previewDecoder = A2(
	$elm$json$Json$Decode$field,
	'preview',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'to',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'from',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
					$elm$json$Json$Decode$succeed($author$project$NotificationForm$PreviewValue))))));
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {fR: d, gz: m, hG: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		eO: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		hG: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.hG, 0, date.eO);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.fR;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.gz;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.eO;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		hA: 1 + (((rd - week1Day1) / 7) | 0),
		hB: wy,
		jD: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hA;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hB;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.dE(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.eJ(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.dE(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.d8(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.b_(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.b_(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.b_(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.fy(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.b_(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.b_(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.iV, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	d8: $justinmimbs$date$Date$withOrdinalSuffix,
	eJ: $justinmimbs$date$Date$monthToName,
	dE: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	fy: $justinmimbs$date$Date$weekdayToName,
	b_: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Enectiva$Conversion$stdFormatDate = $justinmimbs$date$Date$toIsoString;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Enectiva$DateRange$dateEncoder = A2($elm$core$Basics$composeR, $author$project$Enectiva$Conversion$stdFormatDate, $elm$json$Json$Encode$string);
var $author$project$NotificationForm$arbitraryDateEncoder = function (spec) {
	return function (b) {
		return _Utils_Tuple2('arbitrary_date', b);
	}(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					$author$project$Enectiva$DateRange$dateEncoder(spec.dn))
				])));
};
var $author$project$NotificationForm$bareDateEncoder = function (_v0) {
	var month = _v0.a;
	var day = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'month',
				$elm$json$Json$Encode$int(month)),
				_Utils_Tuple2(
				'day',
				$elm$json$Json$Encode$int(day))
			]));
};
var $author$project$NotificationForm$bareDateRangeEncoder = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$author$project$NotificationForm$bareDateEncoder(from)),
				_Utils_Tuple2(
				'to',
				$author$project$NotificationForm$bareDateEncoder(to))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$NotificationForm$dateRangesEncoder = function (constraint) {
	var data = A2($elm$json$Json$Encode$list, $author$project$NotificationForm$bareDateRangeEncoder, constraint);
	return _Utils_Tuple2('days_of_year', data);
};
var $author$project$NotificationForm$daysOfWeekEncoder = function (constraint) {
	var dow = A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$int,
		$elm$core$Set$toList(
			$author$project$Enectiva$ValidatedValue$value(constraint)));
	return _Utils_Tuple2('days_of_week', dow);
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$NotificationForm$hoursOfDayEncoder = function (constraint) {
	var to = $elm$json$Json$Encode$int(constraint.b);
	var from = $elm$json$Json$Encode$int(constraint.a);
	return _Utils_Tuple2(
		'hours_of_day',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('from', from),
					_Utils_Tuple2('to', to)
				])));
};
var $author$project$NotificationForm$constraintsEncoder = function (_v0) {
	var dow = _v0.a;
	var hod = _v0.b;
	var dr = _v0.c;
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'constraints',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						$author$project$NotificationForm$daysOfWeekEncoder(dow),
						$author$project$NotificationForm$hoursOfDayEncoder(hod),
						$author$project$NotificationForm$dateRangesEncoder(dr)
					])))
		]);
};
var $author$project$NotificationsForm$SourceSelection$encoder = function (selection) {
	return $author$project$NotificationsForm$SourceSelection$sourceEncoder(
		$author$project$SelectList$selected(selection._));
};
var $author$project$Types$energyToString = function (energy) {
	switch (energy) {
		case 1:
			return 'el';
		case 2:
			return 'ga';
		case 3:
			return 'wa';
		case 4:
			return 'he';
		case 5:
			return 'co';
		case 6:
			return 'hca';
		case 7:
			return 'lf';
		default:
			return '';
	}
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$NotificationForm$thresholdEncoder = function (spec) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'threshold',
			$elm$json$Json$Encode$float(
				$author$project$Enectiva$ValidatedValue$value(spec.E)))
		]);
};
var $author$project$NotificationsForm$Measure$toString = function (m) {
	switch (m) {
		case 0:
			return 'consumption';
		case 1:
			return 'cost';
		case 2:
			return 'production';
		default:
			return 'production_cost';
	}
};
var $author$project$NotificationForm$consumptionEncoder = F3(
	function (objectName, spec, extra) {
		return function (b) {
			return _Utils_Tuple2(objectName, b);
		}(
			$elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'energy',
							$elm$json$Json$Encode$string(
								$author$project$Types$energyToString(spec.g))),
							_Utils_Tuple2(
							'measure',
							$elm$json$Json$Encode$string(
								$author$project$NotificationsForm$Measure$toString(spec.aa)))
						]),
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$NotificationsForm$SourceSelection$encoder(spec.e)
							]),
						_Utils_ap(
							$author$project$NotificationForm$thresholdEncoder(spec),
							extra)))));
	});
var $author$project$NotificationForm$directionToString = function (direction) {
	if (!direction) {
		return 'greater_than';
	} else {
		return 'less_than';
	}
};
var $author$project$NotificationForm$directionItemEncoder = function (direction) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'direction',
			$elm$json$Json$Encode$string(
				$author$project$NotificationForm$directionToString(direction)))
		]);
};
var $author$project$NotificationsForm$Period$toString = function (period) {
	switch (period.$) {
		case 3:
			return 'year';
		case 2:
			return 'month';
		case 1:
			return 'day';
		case 0:
			return 'hour';
		default:
			return 'custom';
	}
};
var $author$project$NotificationsForm$Period$encoder = function (period) {
	if (period.$ === 4) {
		var _v1 = period.a;
		var from = _v1.a;
		var to = _v1.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'custom',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'from',
								$elm$json$Json$Encode$int(from)),
								_Utils_Tuple2(
								'to',
								$elm$json$Json$Encode$int(to))
							])))
				]));
	} else {
		var encoded = $elm$json$Json$Encode$string(
			$author$project$NotificationsForm$Period$toString(period));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('simple', encoded)
				]));
	}
};
var $author$project$NotificationForm$periodFieldEncoder = function (period) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'period',
			$author$project$NotificationsForm$Period$encoder(period.aE))
		]);
};
var $author$project$NotificationsForm$SnoozePeriod$number = function (snoozePeriod) {
	return snoozePeriod.b;
};
var $author$project$NotificationsForm$SnoozePeriod$unit = function (snoozePeriod) {
	var _v0 = snoozePeriod.a;
	switch (_v0) {
		case 0:
			return 'm';
		case 1:
			return 'h';
		default:
			return 'd';
	}
};
var $author$project$NotificationsForm$SnoozePeriod$toStr = function (snoozePeriod) {
	return _Utils_ap(
		$elm$core$String$fromInt(
			$author$project$NotificationsForm$SnoozePeriod$number(snoozePeriod)),
		$author$project$NotificationsForm$SnoozePeriod$unit(snoozePeriod));
};
var $author$project$NotificationsForm$SnoozePeriod$encoder = function (snoozePeriod) {
	return $elm$json$Json$Encode$string(
		$author$project$NotificationsForm$SnoozePeriod$toStr(snoozePeriod));
};
var $author$project$NotificationForm$snoozePeriodItemEncoder = function (snoozePeriod) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'snooze_period',
			$author$project$NotificationsForm$SnoozePeriod$encoder(snoozePeriod))
		]);
};
var $author$project$NotificationForm$consumptionExtensionEncoder = function (_v0) {
	var period = _v0.aE;
	var snoozePeriod = _v0.p;
	var direction = _v0.Z;
	return _Utils_ap(
		$author$project$NotificationForm$periodFieldEncoder(period),
		_Utils_ap(
			$author$project$NotificationForm$directionItemEncoder(direction),
			$author$project$NotificationForm$snoozePeriodItemEncoder(snoozePeriod)));
};
var $author$project$NotificationForm$dataSeriesEncoder = F2(
	function (spec, extra) {
		return function (b) {
			return _Utils_Tuple2('data_series', b);
		}(
			$elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'direction',
							$elm$json$Json$Encode$string(
								$author$project$NotificationForm$directionToString(spec.Z)))
						]),
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$NotificationsForm$SourceSelection$encoder(spec.e)
							]),
						_Utils_ap(
							$author$project$NotificationForm$thresholdEncoder(spec),
							extra)))));
	});
var $author$project$Divisor$toString = function (d) {
	switch (d.$) {
		case 0:
			var id = d.a.K;
			var unit = d.a.ad;
			return 'ds#' + (id + ('#' + unit));
		case 1:
			var id = d.a.K;
			return 'prop#' + id;
		case 2:
			var id = d.a.K;
			return 'aat#' + id;
		default:
			var id = d.a.K;
			return 'iat#' + id;
	}
};
var $author$project$Divisor$encoder = A2($elm$core$Basics$composeR, $author$project$Divisor$toString, $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$NotificationForm$divisorEncoder = function (divisor) {
	var value = function () {
		var _v0 = $author$project$Enectiva$ValidatedValue$value(divisor);
		if (_v0.$ === 1) {
			return $elm$json$Json$Encode$null;
		} else {
			var d = _v0.a;
			return $author$project$Divisor$encoder(d);
		}
	}();
	return _List_fromArray(
		[
			_Utils_Tuple2('divisor', value)
		]);
};
var $author$project$NotificationForm$dailyDSModeToString = function (mode) {
	if (!mode) {
		return 'only_crossed_threshold';
	} else {
		return 'sustains_crossed_threshold';
	}
};
var $author$project$NotificationForm$dsModeItemEncoder = function (mode) {
	return _Utils_Tuple2(
		'daily_mode',
		$elm$json$Json$Encode$string(
			$author$project$NotificationForm$dailyDSModeToString(mode)));
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$NotificationForm$holidayEncoder = function (spec) {
	return function (v) {
		return _Utils_Tuple2('holiday', v);
	}(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'constraints',
					$elm$json$Json$Encode$object(
						$elm$core$List$singleton(
							$author$project$NotificationForm$dateRangesEncoder(spec.aM)))),
					_Utils_Tuple2(
					'advance',
					$elm$json$Json$Encode$int(
						$author$project$Enectiva$ValidatedValue$value(spec.aZ))),
					_Utils_Tuple2(
					'include_weekend_days',
					$elm$json$Json$Encode$bool(spec.cN))
				])));
};
var $author$project$NotificationForm$dataSeriesMeasureToString = function (m) {
	switch (m) {
		case 0:
			return 'daily_min';
		case 1:
			return 'daily_avg';
		default:
			return 'daily_max';
	}
};
var $author$project$NotificationForm$measureItemEncoder = function (measure) {
	return _Utils_Tuple2(
		'measure',
		$elm$json$Json$Encode$string(
			$author$project$NotificationForm$dataSeriesMeasureToString(measure)));
};
var $author$project$NotificationForm$meterErrorSpecEncoder = function (spec) {
	return function (b) {
		return _Utils_Tuple2('meter_error_state', b);
	}(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notify_about_resolution',
					$elm$json$Json$Encode$bool(spec.dF)),
					_Utils_Tuple2(
					'external_recipients',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, spec.dt))
				])));
};
var $author$project$NotificationForm$qExtremeEncoder = function (spec) {
	return function (b) {
		return _Utils_Tuple2('q_extreme', b);
	}(
		$elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$NotificationsForm$SourceSelection$encoder(spec.e)
					]),
				_Utils_ap(
					$author$project$NotificationForm$snoozePeriodItemEncoder(spec.p),
					_Utils_ap(
						$author$project$NotificationForm$thresholdEncoder(spec),
						$author$project$NotificationForm$constraintsEncoder(spec.Y))))));
};
var $author$project$NotificationForm$repetitionItemEncoder = function (repetition) {
	return _Utils_Tuple2(
		'repetition',
		$elm$json$Json$Encode$int(
			$author$project$Enectiva$ValidatedValue$value(repetition)));
};
var $author$project$NotificationForm$unitItemEncoder = function (unit) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'unit',
			$elm$json$Json$Encode$string(unit))
		]);
};
var $author$project$NotificationForm$wastageDetectionSpecEncoder = function (spec) {
	return function (b) {
		return _Utils_Tuple2('wastage_detection', b);
	}(
		$elm$json$Json$Encode$object(
			$elm$core$List$singleton(
				$author$project$NotificationsForm$SourceSelection$encoder(spec.e))));
};
var $author$project$NotificationForm$specEncoder = F2(
	function (spec, rest) {
		switch (spec.$) {
			case 1:
				var ad = spec.a;
				return A2(
					$elm$core$List$cons,
					$author$project$NotificationForm$arbitraryDateEncoder(ad),
					rest);
			case 2:
				var h = spec.a;
				return A2(
					$elm$core$List$cons,
					$author$project$NotificationForm$holidayEncoder(h),
					rest);
			case 4:
				var rc = spec.a;
				var extension = spec.b;
				return A2(
					$elm$core$List$cons,
					A3(
						$author$project$NotificationForm$consumptionEncoder,
						'relative_consumption',
						rc,
						$author$project$NotificationForm$consumptionExtensionEncoder(extension)),
					rest);
			case 3:
				var ac = spec.a;
				var unit = spec.b;
				var extension = spec.c;
				return A2(
					$elm$core$List$cons,
					A3(
						$author$project$NotificationForm$consumptionEncoder,
						'absolute_consumption',
						ac,
						_Utils_ap(
							$author$project$NotificationForm$unitItemEncoder(unit),
							$author$project$NotificationForm$consumptionExtensionEncoder(extension))),
					rest);
			case 5:
				var cl = spec.a;
				var unit = spec.b;
				var period = spec.c;
				var constraints = spec.d;
				return A2(
					$elm$core$List$cons,
					A3(
						$author$project$NotificationForm$consumptionEncoder,
						'consumption_limit',
						cl,
						_Utils_ap(
							$author$project$NotificationForm$unitItemEncoder(unit),
							_Utils_ap(
								$author$project$NotificationForm$periodFieldEncoder(period),
								$author$project$NotificationForm$constraintsEncoder(constraints)))),
					rest);
			case 10:
				var sc = spec.a;
				var unit = spec.b;
				var period = spec.c;
				var divisor = spec.d;
				return A2(
					$elm$core$List$cons,
					A3(
						$author$project$NotificationForm$consumptionEncoder,
						'specific_consumption',
						sc,
						_Utils_ap(
							$author$project$NotificationForm$unitItemEncoder(unit),
							_Utils_ap(
								$author$project$NotificationForm$periodFieldEncoder(period),
								$author$project$NotificationForm$divisorEncoder(divisor)))),
					rest);
			case 6:
				var it = spec.a;
				var snoozePeriod = spec.b;
				var constraints = spec.c;
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$NotificationForm$dataSeriesEncoder,
						it,
						_Utils_ap(
							$author$project$NotificationForm$snoozePeriodItemEncoder(snoozePeriod),
							_Utils_ap(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'measure',
										$elm$json$Json$Encode$string('instantaneous'))
									]),
								$author$project$NotificationForm$constraintsEncoder(constraints)))),
					rest);
			case 7:
				var dt = spec.a;
				var measure = spec.b;
				var repetition = spec.c;
				var mode = spec.d;
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$NotificationForm$dataSeriesEncoder,
						dt,
						_List_fromArray(
							[
								$author$project$NotificationForm$measureItemEncoder(measure),
								$author$project$NotificationForm$repetitionItemEncoder(repetition),
								$author$project$NotificationForm$dsModeItemEncoder(mode)
							])),
					rest);
			case 8:
				var qe = spec.a;
				return A2(
					$elm$core$List$cons,
					$author$project$NotificationForm$qExtremeEncoder(qe),
					rest);
			case 9:
				var mes = spec.a;
				return A2(
					$elm$core$List$cons,
					$author$project$NotificationForm$meterErrorSpecEncoder(mes),
					rest);
			case 11:
				var wd = spec.a;
				return A2(
					$elm$core$List$cons,
					$author$project$NotificationForm$wastageDetectionSpecEncoder(wd),
					rest);
			default:
				return rest;
		}
	});
var $author$project$NotificationForm$previewRequest = function (model) {
	var url = A2(
		$author$project$View$localizeUrl,
		'/notifications/preview',
		$author$project$Enectiva$I18n$locale(model.A));
	var body = $elm$http$Http$jsonBody(
		$elm$json$Json$Encode$object(
			A2(
				$author$project$NotificationForm$specEncoder,
				model.h.j,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'count',
						$elm$json$Json$Encode$int(7))
					]))));
	return A6($author$project$Enectiva$HttpExtra$request, model.bl, 'POST', $author$project$NotificationForm$previewDecoder, url, body, $author$project$NotificationForm$PreviewResponse);
};
var $author$project$NotificationForm$updateConsumptionPreview = F2(
	function (requestState, n) {
		return _Utils_update(
			n,
			{
				j: A2(
					$author$project$NotificationForm$changeConsumptionHelp,
					function (s) {
						return _Utils_update(
							s,
							{u: requestState});
					},
					n.j)
			});
	});
var $author$project$NotificationForm$changeConsumptionPreview = function (model) {
	return A3(
		$author$project$NotificationForm$unCmd,
		_List_fromArray(
			[
				$author$project$NotificationForm$previewRequest(model)
			]),
		model,
		$author$project$NotificationForm$updateConsumptionPreview($author$project$NotificationForm$Loading));
};
var $author$project$NotificationForm$changeConsumptionUnit = F2(
	function (model, unit) {
		var _v0 = A2($author$project$NotificationForm$changeConsumption, $author$project$NotificationForm$invalidatePreview, model);
		var invalidated = _v0.a;
		return A2($author$project$NotificationForm$changeUnitHelp, invalidated, unit);
	});
var $author$project$NotificationForm$changeDailyDSMode = F2(
	function (model, mode) {
		var translations = model.A;
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				if (s.$ === 7) {
					var spec = s.a;
					var measure = s.b;
					var repetition = s.c;
					return A4($author$project$NotificationForm$DailyDataSeriesSpec, spec, measure, repetition, mode);
				} else {
					return s;
				}
			});
	});
var $author$project$Enectiva$Entity$emptyEntity = {K: 0, a8: ''};
var $author$project$Types$emptyFullEntity = {hN: _List_Nil, gd: '', K: $author$project$Enectiva$Entity$emptyEntity.K, a8: $author$project$Enectiva$Entity$emptyEntity.a8, hu: ''};
var $author$project$SelectList$singleton = function (sel) {
	return A3($author$project$SelectList$SelectList, _List_Nil, sel, _List_Nil);
};
var $author$project$NotificationsForm$SourceSelection$fromSources = function (sources) {
	if (sources.b) {
		var head = sources.a;
		var rest = sources.b;
		return $author$project$NotificationsForm$SourceSelection$new(
			A3($author$project$SelectList$fromLists, _List_Nil, head, rest));
	} else {
		return $author$project$NotificationsForm$SourceSelection$new(
			$author$project$SelectList$singleton(
				A3($author$project$NotificationsForm$SourceSelection$Entity, false, _List_Nil, $author$project$Types$emptyFullEntity)));
	}
};
var $author$project$NotificationForm$onlyEntities = function (sources) {
	return A2(
		$elm$core$List$filterMap,
		function (s) {
			if (s.$ === 2) {
				return $elm$core$Maybe$Just(s);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		sources);
};
var $author$project$NotificationForm$newDailyDataSeries = F3(
	function (model, m, changer) {
		var _v0 = model.h.j;
		switch (_v0.$) {
			case 7:
				var spec = _v0.a;
				var repetition = _v0.c;
				var mode = _v0.d;
				return A4(
					$author$project$NotificationForm$DailyDataSeriesSpec,
					changer(spec),
					m,
					repetition,
					mode);
			case 6:
				var spec = _v0.a;
				return A4(
					$author$project$NotificationForm$DailyDataSeriesSpec,
					changer(spec),
					m,
					$author$project$Enectiva$ValidatedValue$init(2),
					0);
			default:
				return A4(
					$author$project$NotificationForm$DailyDataSeriesSpec,
					changer(
						{
							Z: 1,
							e: $author$project$NotificationsForm$SourceSelection$fromSources(
								$author$project$NotificationForm$onlyEntities(model.aT)),
							E: $author$project$Enectiva$ValidatedValue$init(13.0)
						}),
					m,
					$author$project$Enectiva$ValidatedValue$init(2),
					0);
		}
	});
var $author$project$NotificationsForm$SnoozePeriod$default = _Utils_Tuple2(1, 4);
var $author$project$NotificationForm$everyDay = $elm$core$Set$fromList(
	_List_fromArray(
		[1, 2, 3, 4, 5, 6, 7]));
var $author$project$BareTime$wholeDay = A2($author$project$BareTime$newRange, 0, 2359);
var $author$project$NotificationForm$newConstraints = _Utils_Tuple3(
	$author$project$Enectiva$ValidatedValue$init($author$project$NotificationForm$everyDay),
	$author$project$BareTime$wholeDay,
	_List_fromArray(
		[$author$project$BareDate$wholeYear]));
var $author$project$NotificationForm$onlyDataSeries = function (sources) {
	return A2(
		$elm$core$List$filterMap,
		function (s) {
			if (s.$ === 3) {
				return $elm$core$Maybe$Just(s);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		sources);
};
var $author$project$NotificationForm$newInstantaneousDataSeries = function (model) {
	var _v0 = model.h.j;
	switch (_v0.$) {
		case 6:
			return model.h.j;
		case 7:
			var spec = _v0.a;
			return A3($author$project$NotificationForm$InstantaneousDataSeriesSpec, spec, $author$project$NotificationsForm$SnoozePeriod$default, $author$project$NotificationForm$newConstraints);
		default:
			return A3(
				$author$project$NotificationForm$InstantaneousDataSeriesSpec,
				{
					Z: 0,
					e: $author$project$NotificationsForm$SourceSelection$fromSources(
						$author$project$NotificationForm$onlyDataSeries(model.aT)),
					E: $author$project$Enectiva$ValidatedValue$init(25.0)
				},
				$author$project$NotificationsForm$SnoozePeriod$default,
				$author$project$NotificationForm$newConstraints);
	}
};
var $author$project$NotificationForm$changeDataSeriesSubtype = F2(
	function (model, tt) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (_v0) {
				if (!tt.$) {
					return $author$project$NotificationForm$newInstantaneousDataSeries(model);
				} else {
					var m = tt.a;
					return A3($author$project$NotificationForm$newDailyDataSeries, model, m, $elm$core$Basics$identity);
				}
			});
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$BareDate$lastDayOfMonth = function (month) {
	switch (month) {
		case 2:
			return 28;
		case 4:
			return 30;
		case 6:
			return 30;
		case 9:
			return 30;
		case 11:
			return 30;
		default:
			return 31;
	}
};
var $author$project$BareDate$update = F2(
	function (msg, _v0) {
		var month = _v0.a;
		var day = _v0.b;
		if (!msg.$) {
			var m = msg.a;
			var lastDay = $author$project$BareDate$lastDayOfMonth(m);
			var newDay = (_Utils_cmp(lastDay, day) < 0) ? lastDay : day;
			return _Utils_Tuple2(m, newDay);
		} else {
			var d = msg.a;
			return _Utils_Tuple2(month, d);
		}
	});
var $author$project$NotificationForm$changeDateRange = F3(
	function (idx, msg, drs) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, range) {
					if (_Utils_eq(i, idx)) {
						if (!msg.$) {
							var m = msg.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$author$project$BareDate$update(m),
								range);
						} else {
							var m = msg.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$author$project$BareDate$update(m),
								range);
						}
					} else {
						return range;
					}
				}),
			drs);
	});
var $author$project$NotificationForm$changeDateRangeConstraintHelp = F3(
	function (idx, msg, _v0) {
		var dow = _v0.a;
		var hod = _v0.b;
		var drs = _v0.c;
		return _Utils_Tuple3(
			dow,
			hod,
			A3($author$project$NotificationForm$changeDateRange, idx, msg, drs));
	});
var $author$project$NotificationForm$changeDateRangeConstraint = F3(
	function (model, idx, msg) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 5:
						var spec = s.a;
						var unit = s.b;
						var period = s.c;
						var constraints = s.d;
						return A4(
							$author$project$NotificationForm$ConsumptionLimitSpec,
							spec,
							unit,
							period,
							A3($author$project$NotificationForm$changeDateRangeConstraintHelp, idx, msg, constraints));
					case 6:
						var spec = s.a;
						var snooze = s.b;
						var constraints = s.c;
						return A3(
							$author$project$NotificationForm$InstantaneousDataSeriesSpec,
							spec,
							snooze,
							A3($author$project$NotificationForm$changeDateRangeConstraintHelp, idx, msg, constraints));
					case 8:
						var spec = s.a;
						var constraints = A3($author$project$NotificationForm$changeDateRangeConstraintHelp, idx, msg, spec.Y);
						return $author$project$NotificationForm$QExtremeSpec(
							_Utils_update(
								spec,
								{Y: constraints}));
					case 2:
						var spec = s.a;
						return $author$project$NotificationForm$HolidaySpec(
							_Utils_update(
								spec,
								{
									aM: A3($author$project$NotificationForm$changeDateRange, idx, msg, spec.aM)
								}));
					default:
						return s;
				}
			});
	});
var $author$project$NotificationForm$changeDirection = F2(
	function (model, direction) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 3:
						var spec = s.a;
						var unit = s.b;
						var extension = s.c;
						return A3(
							$author$project$NotificationForm$AbsoluteConsumptionSpec,
							spec,
							unit,
							_Utils_update(
								extension,
								{Z: direction}));
					case 4:
						var spec = s.a;
						var extension = s.b;
						return A2(
							$author$project$NotificationForm$RelativeConsumptionSpec,
							spec,
							_Utils_update(
								extension,
								{Z: direction}));
					case 6:
						var spec = s.a;
						var snoozePeriod = s.b;
						var constraints = s.c;
						return A3(
							$author$project$NotificationForm$InstantaneousDataSeriesSpec,
							_Utils_update(
								spec,
								{Z: direction}),
							snoozePeriod,
							constraints);
					case 7:
						var spec = s.a;
						var measure = s.b;
						var repetition = s.c;
						var mode = s.d;
						return A4(
							$author$project$NotificationForm$DailyDataSeriesSpec,
							_Utils_update(
								spec,
								{Z: direction}),
							measure,
							repetition,
							mode);
					default:
						return s;
				}
			});
	});
var $elm$core$String$trim = _String_trim;
var $author$project$NotificationForm$updateMeterErrorState = F2(
	function (model, fn) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				if (s.$ === 9) {
					var spec = s.a;
					return $author$project$NotificationForm$MeterErrorStateSpec(
						fn(spec));
				} else {
					return s;
				}
			});
	});
var $author$project$NotificationForm$changeExternalRecipients = F2(
	function (model, content) {
		var recipients = A2(
			$elm$core$List$filterMap,
			function (r) {
				if (r === '') {
					return $elm$core$Maybe$Nothing;
				} else {
					var s = r;
					return $elm$core$Maybe$Just(s);
				}
			},
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$String$split, '\n', content)));
		return A2(
			$author$project$NotificationForm$updateMeterErrorState,
			model,
			function (spec) {
				return _Utils_update(
					spec,
					{dt: recipients});
			});
	});
var $author$project$BareTime$clean = function (input) {
	var _v0 = $elm$regex$Regex$fromString('\\D');
	if (!_v0.$) {
		var regex = _v0.a;
		return A3(
			$elm$regex$Regex$replace,
			regex,
			function (_v1) {
				return '';
			},
			input);
	} else {
		return '';
	}
};
var $author$project$BareTime$parse = function (input) {
	var _v0 = $author$project$BareTime$clean(input);
	if (_v0 === '') {
		return $elm$core$Result$Err('empty input');
	} else {
		var cleaned = _v0;
		var n = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(cleaned));
		return (n <= 24) ? $elm$core$Result$Ok(n * 100) : $elm$core$Result$Ok(
			$author$project$BareTime$normalize(n));
	}
};
var $author$project$BareTime$previousMinute = function (time) {
	var _v0 = $author$project$BareTime$toComponents(time);
	var hours = _v0.a;
	var minutes = _v0.b;
	return (!minutes) ? ((!hours) ? A2($author$project$BareTime$fromComponents, 23, 59) : A2($author$project$BareTime$fromComponents, hours - 1, 59)) : A2(
		$author$project$BareTime$fromComponents,
		A2($elm$core$Basics$modBy, 24, hours),
		minutes - 1);
};
var $author$project$BareTime$parseRange = function (string) {
	var parts = A2(
		$elm$core$List$map,
		$author$project$BareTime$parse,
		A2(
			$elm$core$List$map,
			$elm$core$String$trim,
			A2($elm$core$String$split, '-', string)));
	if (((parts.b && (!parts.a.$)) && parts.b.b) && (!parts.b.a.$)) {
		var from = parts.a.a;
		var _v1 = parts.b;
		var to = _v1.a.a;
		return _Utils_Tuple2(
			from,
			$author$project$BareTime$previousMinute(to));
	} else {
		return $author$project$BareTime$wholeDay;
	}
};
var $author$project$BareTime$roundTo = F2(
	function (rounding, time) {
		var _v0 = $author$project$BareTime$toComponents(time);
		var hours = _v0.a;
		var minutes = _v0.b;
		var roundedMinutes = ((minutes / rounding) | 0) * rounding;
		return A2($author$project$BareTime$fromComponents, hours, roundedMinutes);
	});
var $author$project$BareTime$roundRangeTo = F2(
	function (rounding, _v0) {
		var from = _v0.a;
		var to = _v0.b;
		return _Utils_Tuple2(
			A2($author$project$BareTime$roundTo, rounding, from),
			A2($author$project$BareTime$roundTo, rounding, to + rounding) - 1);
	});
var $author$project$NotificationForm$changeHoursOfDayHelp = F2(
	function (string, constraints) {
		return function (_v0) {
			var dows = _v0.a;
			var dr = _v0.c;
			return _Utils_Tuple3(
				dows,
				A2(
					$author$project$BareTime$roundRangeTo,
					5,
					$author$project$BareTime$parseRange(string)),
				dr);
		}(constraints);
	});
var $author$project$NotificationForm$changeHoursOfDay = F2(
	function (model, string) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 5:
						var spec = s.a;
						var unit = s.b;
						var period = s.c;
						var constraints = s.d;
						return A4(
							$author$project$NotificationForm$ConsumptionLimitSpec,
							spec,
							unit,
							period,
							A2($author$project$NotificationForm$changeHoursOfDayHelp, string, constraints));
					case 6:
						var spec = s.a;
						var snooze = s.b;
						var constraints = s.c;
						return A3(
							$author$project$NotificationForm$InstantaneousDataSeriesSpec,
							spec,
							snooze,
							A2($author$project$NotificationForm$changeHoursOfDayHelp, string, constraints));
					case 8:
						var spec = s.a;
						var constraints = A2($author$project$NotificationForm$changeHoursOfDayHelp, string, spec.Y);
						return $author$project$NotificationForm$QExtremeSpec(
							_Utils_update(
								spec,
								{Y: constraints}));
					default:
						return s;
				}
			});
	});
var $author$project$NotificationForm$changeIncludeWeekendDays = F2(
	function (model, include) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				if (s.$ === 2) {
					var spec = s.a;
					return $author$project$NotificationForm$HolidaySpec(
						_Utils_update(
							spec,
							{cN: include}));
				} else {
					return s;
				}
			});
	});
var $author$project$Enectiva$ValidatedValue$requireString = F2(
	function (msg, str) {
		return A2(
			$author$project$Enectiva$ValidatedValue$validateInner,
			str,
			function (s) {
				return ($elm$core$String$trim(s) === '') ? A2($author$project$Enectiva$ValidatedValue$Invalid, s, msg) : $author$project$Enectiva$ValidatedValue$Valid(s);
			});
	});
var $author$project$NotificationForm$nameValidation = F2(
	function (translations, n) {
		return A2(
			$author$project$Enectiva$ValidatedValue$requireString,
			A2($author$project$Enectiva$I18n$t, translations, 'errors.messages.blank'),
			$author$project$Enectiva$ValidatedValue$init(n));
	});
var $author$project$NotificationForm$changeName = F2(
	function (model, n) {
		var translations = model.A;
		return A2(
			$author$project$NotificationForm$un,
			model,
			function (notif) {
				return _Utils_update(
					notif,
					{
						a8: A2($author$project$NotificationForm$nameValidation, translations, n)
					});
			});
	});
var $author$project$NotificationForm$changeNotifyAboutResolution = F2(
	function (model, checked) {
		return A2(
			$author$project$NotificationForm$updateMeterErrorState,
			model,
			function (spec) {
				return _Utils_update(
					spec,
					{dF: checked});
			});
	});
var $author$project$NotificationsForm$Period$update = F2(
	function (period, msg) {
		switch (msg.$) {
			case 0:
				var _new = msg.a;
				return _Utils_update(
					period,
					{bQ: false, aE: _new});
			case 1:
				var range = msg.a;
				return _Utils_update(
					period,
					{
						aE: $author$project$NotificationsForm$Period$Custom(
							$author$project$BareTime$parseRange(range))
					});
			case 2:
				var newPeriod = function () {
					var _v1 = period.aE;
					if (_v1.$ === 4) {
						return period.aE;
					} else {
						return $author$project$NotificationsForm$Period$Custom($author$project$BareTime$wholeDay);
					}
				}();
				return _Utils_update(
					period,
					{bQ: false, aE: newPeriod});
			case 4:
				return _Utils_update(
					period,
					{bQ: false});
			default:
				return _Utils_update(
					period,
					{bQ: true});
		}
	});
var $author$project$NotificationForm$changePeriod = F2(
	function (model, msg) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 3:
						var spec = s.a;
						var unit = s.b;
						var extension = s.c;
						return A3(
							$author$project$NotificationForm$AbsoluteConsumptionSpec,
							$author$project$NotificationForm$invalidatePreview(spec),
							unit,
							_Utils_update(
								extension,
								{
									aE: A2($author$project$NotificationsForm$Period$update, extension.aE, msg)
								}));
					case 4:
						var spec = s.a;
						var extension = s.b;
						return A2(
							$author$project$NotificationForm$RelativeConsumptionSpec,
							$author$project$NotificationForm$invalidatePreview(spec),
							_Utils_update(
								extension,
								{
									aE: A2($author$project$NotificationsForm$Period$update, extension.aE, msg)
								}));
					case 5:
						var spec = s.a;
						var unit = s.b;
						var period = s.c;
						var constraints = s.d;
						return A4(
							$author$project$NotificationForm$ConsumptionLimitSpec,
							$author$project$NotificationForm$invalidatePreview(spec),
							unit,
							A2($author$project$NotificationsForm$Period$update, period, msg),
							constraints);
					case 10:
						var spec = s.a;
						var unit = s.b;
						var period = s.c;
						var divisor = s.d;
						return A4(
							$author$project$NotificationForm$SpecificConsumptionSpec,
							$author$project$NotificationForm$invalidatePreview(spec),
							unit,
							A2($author$project$NotificationsForm$Period$update, period, msg),
							divisor);
					default:
						return s;
				}
			});
	});
var $author$project$Enectiva$ValidatedValue$nonNegative = F2(
	function (msg, val) {
		return A2(
			$author$project$Enectiva$ValidatedValue$validateInner,
			val,
			function (n) {
				return (n < 0) ? A2($author$project$Enectiva$ValidatedValue$Invalid, n, msg) : $author$project$Enectiva$ValidatedValue$Valid(n);
			});
	});
var $author$project$NotificationForm$nonNegativeMsg = function (translations) {
	return A3(
		$author$project$Enectiva$I18n$tt,
		translations,
		'errors.messages.greater_than_or_equal_to',
		_List_fromArray(
			[
				A2($author$project$Enectiva$I18n$Placeholder, 'count', '0')
			]));
};
var $author$project$NotificationForm$repetitionValidation = F2(
	function (translations, repetition) {
		return A2(
			$author$project$Enectiva$ValidatedValue$nonNegative,
			$author$project$NotificationForm$nonNegativeMsg(translations),
			$author$project$Enectiva$ValidatedValue$init(repetition));
	});
var $author$project$NotificationForm$changeRepetition = F2(
	function (model, repetition) {
		var translations = model.A;
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				if (s.$ === 7) {
					var spec = s.a;
					var measure = s.b;
					var mode = s.d;
					return A4(
						$author$project$NotificationForm$DailyDataSeriesSpec,
						spec,
						measure,
						A2($author$project$NotificationForm$repetitionValidation, translations, repetition),
						mode);
				} else {
					return s;
				}
			});
	});
var $author$project$NotificationForm$changeSmsRecipientSelection = F2(
	function (model, checked) {
		return A2(
			$author$project$NotificationForm$un,
			model,
			function (n) {
				return _Utils_update(
					n,
					{
						aI: function () {
							var _v0 = n.aI;
							if (_v0.$ === 3) {
								var number = _v0.a;
								return A2(
									$author$project$NotificationForm$ConfiguredPhoneNumber,
									number,
									$author$project$SelectionState$fromBool(checked));
							} else {
								return n.aI;
							}
						}()
					});
			});
	});
var $author$project$NotificationForm$changeSnoozePeriod = F2(
	function (fn, model) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 3:
						var spec = s.a;
						var unit = s.b;
						var extension = s.c;
						return A3(
							$author$project$NotificationForm$AbsoluteConsumptionSpec,
							spec,
							unit,
							_Utils_update(
								extension,
								{
									p: fn(extension.p)
								}));
					case 4:
						var spec = s.a;
						var extension = s.b;
						return A2(
							$author$project$NotificationForm$RelativeConsumptionSpec,
							spec,
							_Utils_update(
								extension,
								{
									p: fn(extension.p)
								}));
					case 6:
						var spec = s.a;
						var snoozePeriod = s.b;
						var constraints = s.c;
						return A3(
							$author$project$NotificationForm$InstantaneousDataSeriesSpec,
							spec,
							fn(snoozePeriod),
							constraints);
					case 8:
						var spec = s.a;
						return $author$project$NotificationForm$QExtremeSpec(
							_Utils_update(
								spec,
								{
									p: fn(spec.p)
								}));
					default:
						return s;
				}
			});
	});
var $author$project$NotificationsForm$SnoozePeriod$updateNumber = F2(
	function (nbr, snoozePeriod) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Basics$always(nbr),
			snoozePeriod);
	});
var $author$project$NotificationForm$changeSnoozePeriodNumber = F2(
	function (model, number) {
		return A2(
			$author$project$NotificationForm$changeSnoozePeriod,
			$author$project$NotificationsForm$SnoozePeriod$updateNumber(number),
			model);
	});
var $author$project$NotificationsForm$SnoozePeriod$updateUnit = F2(
	function (un, snoozePeriod) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Basics$always(
				$author$project$NotificationsForm$SnoozePeriod$stringToUnit(un)),
			snoozePeriod);
	});
var $author$project$NotificationForm$changeSnoozePeriodUnit = F2(
	function (model, unit) {
		return A2(
			$author$project$NotificationForm$changeSnoozePeriod,
			$author$project$NotificationsForm$SnoozePeriod$updateUnit(unit),
			model);
	});
var $author$project$NotificationForm$changeText = F2(
	function (model, text) {
		return A2(
			$author$project$NotificationForm$un,
			model,
			function (n) {
				return _Utils_update(
					n,
					{c7: text});
			});
	});
var $author$project$NotificationForm$consumptionThresholdValidation = F2(
	function (translations, threshold) {
		return A2(
			$author$project$Enectiva$ValidatedValue$nonNegative,
			$author$project$NotificationForm$nonNegativeMsg(translations),
			$author$project$Enectiva$ValidatedValue$init(threshold));
	});
var $author$project$NotificationForm$changeThreshold = F2(
	function (model, threshold) {
		var translations = model.A;
		var _v0 = model.h.j;
		switch (_v0.$) {
			case 6:
				var spec = _v0.a;
				var snoozePeriod = _v0.b;
				var constraints = _v0.c;
				return A2(
					$author$project$NotificationForm$us,
					model,
					function (_v1) {
						return A3(
							$author$project$NotificationForm$InstantaneousDataSeriesSpec,
							_Utils_update(
								spec,
								{
									E: $author$project$Enectiva$ValidatedValue$init(threshold)
								}),
							snoozePeriod,
							constraints);
					});
			case 7:
				var spec = _v0.a;
				var measure = _v0.b;
				var repetition = _v0.c;
				var mode = _v0.d;
				return A2(
					$author$project$NotificationForm$us,
					model,
					function (_v2) {
						return A4(
							$author$project$NotificationForm$DailyDataSeriesSpec,
							_Utils_update(
								spec,
								{
									E: $author$project$Enectiva$ValidatedValue$init(threshold)
								}),
							measure,
							repetition,
							mode);
					});
			case 8:
				var spec = _v0.a;
				return A2(
					$author$project$NotificationForm$us,
					model,
					function (_v3) {
						return $author$project$NotificationForm$QExtremeSpec(
							_Utils_update(
								spec,
								{
									E: A2($author$project$NotificationForm$consumptionThresholdValidation, translations, threshold)
								}));
					});
			default:
				return A2(
					$author$project$NotificationForm$changeConsumption,
					function (s) {
						return _Utils_update(
							s,
							{
								E: A2($author$project$NotificationForm$consumptionThresholdValidation, translations, threshold)
							});
					},
					model);
		}
	});
var $author$project$NotificationForm$changeSourceHelp = F5(
	function (fnCons, fnDS, fnQExtreme, fnWastage, s) {
		switch (s.$) {
			case 3:
				var spec = s.a;
				var unit = s.b;
				var extension = s.c;
				return A3(
					$author$project$NotificationForm$AbsoluteConsumptionSpec,
					fnCons(spec),
					unit,
					extension);
			case 4:
				var spec = s.a;
				var extension = s.b;
				return A2(
					$author$project$NotificationForm$RelativeConsumptionSpec,
					fnCons(spec),
					extension);
			case 5:
				var spec = s.a;
				var unit = s.b;
				var period = s.c;
				var constraints = s.d;
				return A4(
					$author$project$NotificationForm$ConsumptionLimitSpec,
					fnCons(spec),
					unit,
					period,
					constraints);
			case 10:
				var spec = s.a;
				var unit = s.b;
				var period = s.c;
				var divisor = s.d;
				return A4(
					$author$project$NotificationForm$SpecificConsumptionSpec,
					fnCons(spec),
					unit,
					period,
					divisor);
			case 6:
				var spec = s.a;
				var snoozePeriod = s.b;
				var constraints = s.c;
				return A3(
					$author$project$NotificationForm$InstantaneousDataSeriesSpec,
					fnDS(spec),
					snoozePeriod,
					constraints);
			case 7:
				var spec = s.a;
				var measure = s.b;
				var repetition = s.c;
				var mode = s.d;
				return A4(
					$author$project$NotificationForm$DailyDataSeriesSpec,
					fnDS(spec),
					measure,
					repetition,
					mode);
			case 8:
				var spec = s.a;
				return $author$project$NotificationForm$QExtremeSpec(
					fnQExtreme(spec));
			case 11:
				var spec = s.a;
				return $author$project$NotificationForm$WastageDetectionSpec(
					fnWastage(spec));
			default:
				return s;
		}
	});
var $author$project$NotificationForm$changeSource = F2(
	function (model, fn) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			A4(
				$author$project$NotificationForm$changeSourceHelp,
				function (s) {
					return _Utils_update(
						s,
						{
							e: fn(s.e)
						});
				},
				function (s) {
					return _Utils_update(
						s,
						{
							e: fn(s.e)
						});
				},
				function (s) {
					return _Utils_update(
						s,
						{
							e: fn(s.e)
						});
				},
				function (s) {
					return _Utils_update(
						s,
						{
							e: fn(s.e)
						});
				}));
	});
var $author$project$NotificationsForm$SourceSelection$close = function (selection) {
	return _Utils_update(
		selection,
		{a6: $elm$core$Maybe$Nothing, c5: 1});
};
var $author$project$NotificationForm$closeSourceSelection = function (model) {
	return A2($author$project$NotificationForm$changeSource, model, $author$project$NotificationsForm$SourceSelection$close);
};
var $author$project$NotificationForm$divisorSelected = F2(
	function (model, divisor) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (spec) {
				if (spec.$ === 10) {
					var sc = spec.a;
					var unit = spec.b;
					var period = spec.c;
					return A4(
						$author$project$NotificationForm$SpecificConsumptionSpec,
						sc,
						unit,
						period,
						$author$project$Enectiva$ValidatedValue$init(divisor));
				} else {
					return spec;
				}
			});
	});
var $author$project$Divisor$fromString = function (str) {
	var _v0 = A2($elm$core$String$split, '#', str);
	_v0$4:
	while (true) {
		if (_v0.b && _v0.b.b) {
			if (_v0.b.b.b) {
				if ((_v0.a === 'ds') && (!_v0.b.b.b.b)) {
					var _v1 = _v0.b;
					var template = _v1.a;
					var _v2 = _v1.b;
					var unit = _v2.a;
					return $elm$core$Maybe$Just(
						$author$project$Divisor$DataSourceDivisor(
							{K: template, a8: '', ad: unit}));
				} else {
					break _v0$4;
				}
			} else {
				switch (_v0.a) {
					case 'prop':
						var _v3 = _v0.b;
						var id = _v3.a;
						return $elm$core$Maybe$Just(
							$author$project$Divisor$PropertyDivisor(
								{K: id, a8: '', ad: ''}));
					case 'aat':
						var _v4 = _v0.b;
						var id = _v4.a;
						return $elm$core$Maybe$Just(
							$author$project$Divisor$AggregateAreaTypeDivisor(
								{K: id, a8: '', ad: ''}));
					case 'iat':
						var _v5 = _v0.b;
						var id = _v5.a;
						return $elm$core$Maybe$Just(
							$author$project$Divisor$IndividualAreaTypeDivisor(
								{K: id, a8: '', ad: ''}));
					default:
						break _v0$4;
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$NotificationsForm$SourceSelection$breadcrumbsSortHelp = function (breadcrumbs) {
	return A2(
		$elm$core$String$join,
		'>',
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.K;
				},
				$elm$core$String$fromInt),
			breadcrumbs));
};
var $author$project$NotificationsForm$SourceSelection$breadcrumbsSort = function (source) {
	switch (source.$) {
		case 0:
			var breadcrumbs = source.b;
			var name = source.c.a8;
			return $author$project$NotificationsForm$SourceSelection$breadcrumbsSortHelp(breadcrumbs) + ('-' + name);
		case 1:
			var breadcrumbs = source.b;
			var name = source.c.a8;
			return $author$project$NotificationsForm$SourceSelection$breadcrumbsSortHelp(breadcrumbs) + ('-' + name);
		case 2:
			var breadcrumbs = source.b;
			var name = source.c.a8;
			return $elm$core$List$isEmpty(breadcrumbs) ? ('!' + name) : ($author$project$NotificationsForm$SourceSelection$breadcrumbsSortHelp(breadcrumbs) + ('=' + name));
		default:
			var breadcrumbs = source.b;
			var name = source.c.a8;
			return $author$project$NotificationsForm$SourceSelection$breadcrumbsSortHelp(breadcrumbs) + ('.' + name);
	}
};
var $author$project$NotificationsForm$SourceSelection$mapMatching = F3(
	function (matchingFn, notMatchingFn, source) {
		var fn = function (matching) {
			return matching ? matchingFn(source) : notMatchingFn(source);
		};
		switch (source.$) {
			case 0:
				var matching = source.a;
				return fn(matching);
			case 1:
				var matching = source.a;
				return fn(matching);
			case 2:
				var matching = source.a;
				return fn(matching);
			default:
				var matching = source.a;
				return fn(matching);
		}
	});
var $author$project$NotificationsForm$SourceSelection$onlyMatching = function (source) {
	return A3(
		$author$project$NotificationsForm$SourceSelection$mapMatching,
		$elm$core$Basics$always(
			$elm$core$Maybe$Just(source)),
		$elm$core$Basics$always($elm$core$Maybe$Nothing),
		source);
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$SelectList$toList = function (_v0) {
	var beforeSel = _v0.a;
	var sel = _v0.b;
	var afterSel = _v0.c;
	return _Utils_ap(
		beforeSel,
		A2($elm$core$List$cons, sel, afterSel));
};
var $author$project$NotificationsForm$SourceSelection$matchingSources = function (selection) {
	return A2(
		$elm$core$List$sortBy,
		$author$project$NotificationsForm$SourceSelection$breadcrumbsSort,
		A2(
			$elm$core$List$filterMap,
			$author$project$NotificationsForm$SourceSelection$onlyMatching,
			$author$project$SelectList$toList(selection._)));
};
var $author$project$NotificationsForm$SourceSelection$highlightNext = function (selection) {
	var matching = $elm$core$List$length(
		$author$project$NotificationsForm$SourceSelection$matchingSources(selection));
	var candidate = 1 + A2($elm$core$Maybe$withDefault, -1, selection.a6);
	var newIndex = (_Utils_cmp(candidate, matching) > -1) ? $elm$core$Maybe$Just(matching - 1) : $elm$core$Maybe$Just(candidate);
	return _Utils_update(
		selection,
		{a6: newIndex});
};
var $author$project$NotificationForm$highlightNextSource = function (model) {
	return A2($author$project$NotificationForm$changeSource, model, $author$project$NotificationsForm$SourceSelection$highlightNext);
};
var $author$project$NotificationsForm$SourceSelection$highlightPrevious = function (selection) {
	var candidate = function (a) {
		return a - 1;
	}(
		A2($elm$core$Maybe$withDefault, 0, selection.a6));
	var newIndex = (candidate < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(candidate);
	return _Utils_update(
		selection,
		{a6: newIndex});
};
var $author$project$NotificationForm$highlightPreviousSource = function (model) {
	return A2($author$project$NotificationForm$changeSource, model, $author$project$NotificationsForm$SourceSelection$highlightPrevious);
};
var $author$project$NotificationForm$numberParsingKeyToString = function (key) {
	return 'thr';
};
var $author$project$NotificationForm$numberParsingKeyEncoder = function (key) {
	return $elm$json$Json$Encode$string(
		$author$project$NotificationForm$numberParsingKeyToString(key));
};
var $author$project$NotificationForm$mapSpec = F7(
	function (consumption, date, dataSeries, qextreme, wastage, fallback, spec) {
		switch (spec.$) {
			case 3:
				var ac = spec.a;
				return consumption(ac);
			case 4:
				var rc = spec.a;
				return consumption(rc);
			case 5:
				var cl = spec.a;
				return consumption(cl);
			case 10:
				var sc = spec.a;
				return consumption(sc);
			case 1:
				var ad = spec.a;
				return date(ad);
			case 7:
				var dt = spec.a;
				return dataSeries(dt);
			case 6:
				var it = spec.a;
				return dataSeries(it);
			case 8:
				var qe = spec.a;
				return qextreme(qe);
			case 11:
				var wd = spec.a;
				return wastage(wd);
			default:
				return fallback;
		}
	});
var $author$project$NotificationForm$measureIsConsumptionBased = function (measure) {
	return (!measure) || (measure === 1);
};
var $author$project$NotificationForm$customSearch = F2(
	function (spec, source) {
		return A7(
			$author$project$NotificationForm$mapSpec,
			function (consumption) {
				switch (source.$) {
					case 2:
						return true;
					case 0:
						var meter = source.c;
						return _Utils_eq(meter.g, consumption.g) && A2($author$project$NotificationsForm$SourceSelection$sourceMeterOfNeededType, meter, consumption.aa);
					case 1:
						var vm = source.c;
						return _Utils_eq(vm.g, consumption.g) && $author$project$NotificationForm$measureIsConsumptionBased(consumption.aa);
					default:
						return false;
				}
			},
			$elm$core$Basics$always(false),
			function (_v1) {
				if (source.$ === 3) {
					return true;
				} else {
					return false;
				}
			},
			function (_v3) {
				if (!source.$) {
					var energy = source.c.g;
					return energy === 1;
				} else {
					return false;
				}
			},
			function (_v5) {
				switch (source.$) {
					case 0:
						var energy = source.c.g;
						return energy === 3;
					case 2:
						return true;
					default:
						return false;
				}
			},
			false,
			spec);
	});
var $author$project$NotificationsForm$SourceSelection$Opened = 0;
var $author$project$SelectList$map = F2(
	function (transform, _v0) {
		var beforeSel = _v0.a;
		var sel = _v0.b;
		var afterSel = _v0.c;
		return A3(
			$author$project$SelectList$SelectList,
			A2($elm$core$List$map, transform, beforeSel),
			transform(sel),
			A2($elm$core$List$map, transform, afterSel));
	});
var $elm$core$String$toLower = _String_toLower;
var $author$project$Search$looseString = F2(
	function (needle, haystack) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(needle),
			$elm$core$String$toLower(haystack));
	});
var $author$project$NotificationsForm$SourceSelection$sourceAsString = function (source) {
	return A5(
		$author$project$NotificationsForm$SourceSelection$mapRealSource,
		$elm$core$Basics$always(
			function ($) {
				return $.a8;
			}),
		$elm$core$Basics$always(
			function ($) {
				return $.a8;
			}),
		$elm$core$Basics$always(
			function ($) {
				return $.a8;
			}),
		$elm$core$Basics$always(
			function ($) {
				return $.a8;
			}),
		source);
};
var $author$project$NotificationsForm$SourceSelection$matchingQuery = F2(
	function (query, source) {
		return A2(
			$author$project$Search$looseString,
			query,
			$author$project$NotificationsForm$SourceSelection$sourceAsString(source));
	});
var $author$project$NotificationsForm$SourceSelection$updateMatching = F2(
	function (predicate, source) {
		return A5(
			$author$project$NotificationsForm$SourceSelection$mapRealSource,
			function (m) {
				return A2(
					$author$project$NotificationsForm$SourceSelection$PhysicalMeter,
					predicate(source),
					m);
			},
			function (vm) {
				return A2(
					$author$project$NotificationsForm$SourceSelection$VirtualMeter,
					predicate(source),
					vm);
			},
			function (e) {
				return A2(
					$author$project$NotificationsForm$SourceSelection$Entity,
					predicate(source),
					e);
			},
			function (ds) {
				return A2(
					$author$project$NotificationsForm$SourceSelection$DataSeries,
					predicate(source),
					ds);
			},
			source);
	});
var $author$project$NotificationsForm$SourceSelection$match = F2(
	function (customFilter, selection) {
		var predicate = function (source) {
			return A2($author$project$NotificationsForm$SourceSelection$matchingQuery, selection.c$, source) && customFilter(source);
		};
		var list = A2(
			$author$project$SelectList$map,
			$author$project$NotificationsForm$SourceSelection$updateMatching(predicate),
			selection._);
		return _Utils_update(
			selection,
			{_: list});
	});
var $author$project$NotificationsForm$SourceSelection$open = F2(
	function (filter, selection) {
		return A2(
			$author$project$NotificationsForm$SourceSelection$match,
			filter,
			_Utils_update(
				selection,
				{c5: 0}));
	});
var $author$project$NotificationForm$openSourceSelection = function (model) {
	return A2(
		$author$project$NotificationForm$changeSource,
		model,
		$author$project$NotificationsForm$SourceSelection$open(
			$author$project$NotificationForm$customSearch(model.h.j)));
};
var $author$project$Enectiva$I18n$ParseNumberArgs = function (a) {
	return {$: 1, a: a};
};
var $author$project$Enectiva$I18n$parse = _Platform_outgoingPort('parse', $elm$core$Basics$identity);
var $author$project$Enectiva$I18n$parseEncoder = F2(
	function (_v0, args) {
		var appName = _v0.a;
		var id = _v0.b;
		var _v1 = function () {
			if (args.$ === 1) {
				var str = args.a;
				return _Utils_Tuple2(
					'number',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(str))
						]));
			} else {
				var format = args.a;
				var str = args.b;
				return _Utils_Tuple2(
					'dateTime',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'format',
							$elm$json$Json$Encode$string(format)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(str))
						]));
			}
		}();
		var tp = _v1.a;
		var kvPairs = _v1.b;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(tp)),
						_Utils_Tuple2(
						'appName',
						$elm$json$Json$Encode$string(appName)),
						_Utils_Tuple2('id', id)
					]),
				kvPairs));
	});
var $author$project$Enectiva$I18n$parseNumber = F3(
	function (appName, id, str) {
		return $author$project$Enectiva$I18n$parse(
			A2(
				$author$project$Enectiva$I18n$parseEncoder,
				_Utils_Tuple2(appName, id),
				$author$project$Enectiva$I18n$ParseNumberArgs(str)));
	});
var $author$project$NotificationForm$Success = function (a) {
	return {$: 2, a: a};
};
var $author$project$NotificationForm$previewSuccessful = F2(
	function (model, preview) {
		return A3(
			$author$project$NotificationForm$unCmd,
			_List_Nil,
			model,
			$author$project$NotificationForm$updateConsumptionPreview(
				$author$project$NotificationForm$Success(preview)));
	});
var $author$project$NotificationForm$Failure = function (a) {
	return {$: 3, a: a};
};
var $author$project$NotificationForm$previewWithError = F2(
	function (model, err) {
		return A3(
			$author$project$NotificationForm$unCmd,
			_List_Nil,
			model,
			$author$project$NotificationForm$updateConsumptionPreview(
				$author$project$NotificationForm$Failure(
					_List_fromArray(
						[err]))));
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Enectiva$ValidatedValue$nonEmpty = F2(
	function (msg, val) {
		return A2(
			$author$project$Enectiva$ValidatedValue$validateInner,
			val,
			function (s) {
				return $elm$core$Set$isEmpty(s) ? A2($author$project$Enectiva$ValidatedValue$Invalid, s, msg) : $author$project$Enectiva$ValidatedValue$Valid(s);
			});
	});
var $author$project$NotificationForm$setValidation = F3(
	function (translations, msg, set) {
		var err = A2($author$project$Enectiva$I18n$t, translations, 'errors.messages.notification.' + msg);
		return A2(
			$author$project$Enectiva$ValidatedValue$nonEmpty,
			err,
			$author$project$Enectiva$ValidatedValue$init(set));
	});
var $author$project$NotificationForm$recipientsValidation = function (translations) {
	return A2($author$project$NotificationForm$setValidation, translations, 'recipients_required');
};
var $author$project$NotificationForm$removeDateRangeConstraintHelp = F2(
	function (idx, _v0) {
		var dow = _v0.a;
		var hod = _v0.b;
		var drs = _v0.c;
		var newDrs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, dr) {
						return _Utils_eq(i, idx) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(dr);
					}),
				drs));
		return _Utils_Tuple3(dow, hod, newDrs);
	});
var $author$project$NotificationForm$removeDateRangeConstraint = F2(
	function (model, idx) {
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 5:
						var spec = s.a;
						var unit = s.b;
						var period = s.c;
						var constraints = s.d;
						return A4(
							$author$project$NotificationForm$ConsumptionLimitSpec,
							spec,
							unit,
							period,
							A2($author$project$NotificationForm$removeDateRangeConstraintHelp, idx, constraints));
					case 6:
						var spec = s.a;
						var snooze = s.b;
						var constraints = s.c;
						return A3(
							$author$project$NotificationForm$InstantaneousDataSeriesSpec,
							spec,
							snooze,
							A2($author$project$NotificationForm$removeDateRangeConstraintHelp, idx, constraints));
					case 8:
						var spec = s.a;
						var constraints = A2($author$project$NotificationForm$removeDateRangeConstraintHelp, idx, spec.Y);
						return $author$project$NotificationForm$QExtremeSpec(
							_Utils_update(
								spec,
								{Y: constraints}));
					case 2:
						var spec = s.a;
						var filteredRanges = A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (i, dr) {
										return _Utils_eq(i, idx) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(dr);
									}),
								spec.aM));
						return $author$project$NotificationForm$HolidaySpec(
							_Utils_update(
								spec,
								{aM: filteredRanges}));
					default:
						return s;
				}
			});
	});
var $author$project$Enectiva$ValidatedValue$isValid = function (str) {
	if (str.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$NotificationForm$coreIsValid = function (notification) {
	if ($author$project$Enectiva$ValidatedValue$isValid(notification.a8)) {
		var _v0 = notification.z;
		if (_v0.$ === 3) {
			var recipients = _v0.a;
			return $author$project$Enectiva$ValidatedValue$isValid(recipients.fe);
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$NotificationForm$thresholdFieldIsValid = function (_v0) {
	var threshold = _v0.E;
	return $author$project$Enectiva$ValidatedValue$isValid(threshold);
};
var $author$project$NotificationForm$detailIsValid = function (spec) {
	switch (spec.$) {
		case 3:
			var ac = spec.a;
			return $author$project$NotificationForm$thresholdFieldIsValid(ac);
		case 2:
			var advance = spec.a.aZ;
			return $author$project$Enectiva$ValidatedValue$isValid(advance);
		case 4:
			var rc = spec.a;
			return $author$project$NotificationForm$thresholdFieldIsValid(rc);
		case 5:
			var cl = spec.a;
			return $author$project$NotificationForm$thresholdFieldIsValid(cl);
		case 10:
			var sc = spec.a;
			var divisor = spec.d;
			return $author$project$NotificationForm$thresholdFieldIsValid(sc) && $author$project$Enectiva$ValidatedValue$isValid(divisor);
		case 1:
			return true;
		case 6:
			return true;
		case 7:
			var repetition = spec.c;
			return $author$project$Enectiva$ValidatedValue$isValid(repetition);
		case 8:
			var qe = spec.a;
			return $author$project$NotificationForm$thresholdFieldIsValid(qe);
		case 9:
			return true;
		case 0:
			return false;
		default:
			return true;
	}
};
var $author$project$NotificationForm$canSave = function (notification) {
	return $author$project$NotificationForm$coreIsValid(notification) ? $author$project$NotificationForm$detailIsValid(notification.j) : false;
};
var $author$project$ServerErrors$NoContent = function (a) {
	return {$: 1, a: a};
};
var $author$project$NotificationForm$SaveResponse = function (a) {
	return {$: 29, a: a};
};
var $author$project$ServerErrors$General = function (a) {
	return {$: 0, a: a};
};
var $author$project$ServerErrors$PerField = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$ServerErrors$errorsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['errors', 'validation']),
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Enectiva$HttpExtra$errorToString = function (err) {
	switch (err.$) {
		case 0:
			var str = err.a;
			return 'Bad URL ' + str;
		case 1:
			return 'Timeout';
		case 2:
			return 'Network error';
		case 3:
			return 'Bad status';
		default:
			var str = err.a;
			return 'Bad body ' + str;
	}
};
var $author$project$ServerErrors$generalError = A2(
	$elm$core$Basics$composeR,
	$author$project$Enectiva$HttpExtra$errorToString,
	A2($elm$core$Basics$composeR, $author$project$ServerErrors$General, $elm$core$Result$Err));
var $author$project$ServerErrors$httpClientSideError = function (code) {
	return (400 <= code) && (code < 500);
};
var $author$project$ServerErrors$expectResponse = F2(
	function (tagger, expectation) {
		return A2(
			$elm$http$Http$expectStringResponse,
			tagger,
			function (response) {
				switch (response.$) {
					case 0:
						var u = response.a;
						return $author$project$ServerErrors$generalError(
							$elm$http$Http$BadUrl(u));
					case 1:
						return $author$project$ServerErrors$generalError($elm$http$Http$Timeout);
					case 2:
						return $author$project$ServerErrors$generalError($elm$http$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						if ($author$project$ServerErrors$httpClientSideError(metadata.hf)) {
							var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$ServerErrors$errorsDecoder, body);
							if (!_v1.$) {
								var se = _v1.a;
								return $elm$core$Result$Err(
									$author$project$ServerErrors$PerField(se));
							} else {
								var de = _v1.a;
								return $elm$core$Result$Err(
									$author$project$ServerErrors$General(
										$elm$json$Json$Decode$errorToString(de)));
							}
						} else {
							return $author$project$ServerErrors$generalError(
								$elm$http$Http$BadStatus(metadata.hf));
						}
					default:
						var body = response.b;
						if (expectation.$ === 1) {
							var v = expectation.a;
							return $elm$core$Result$Ok(v);
						} else {
							var decoder = expectation.a;
							var _v3 = A2($elm$json$Json$Decode$decodeString, decoder, body);
							if (!_v3.$) {
								var value = _v3.a;
								return $elm$core$Result$Ok(value);
							} else {
								var err = _v3.a;
								return $author$project$ServerErrors$generalError(
									$elm$http$Http$BadBody(
										$elm$json$Json$Decode$errorToString(err)));
							}
						}
				}
			});
	});
var $author$project$SelectionState$isSelected = function (os) {
	if (!os) {
		return true;
	} else {
		return false;
	}
};
var $author$project$NotificationForm$notificationEncoder = function (notification) {
	var smsRecipient = function () {
		var _v1 = notification.aI;
		if (_v1.$ === 3) {
			var selected = _v1.b;
			return $author$project$SelectionState$isSelected(selected);
		} else {
			return false;
		}
	}();
	var emailRecipients = A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$int,
		A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			_List_Nil,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fe;
					},
					A2($elm$core$Basics$composeR, $author$project$Enectiva$ValidatedValue$value, $elm$core$Set$toList)),
				notification.z)));
	var addId = F2(
		function (maybeId, rest) {
			if (!maybeId.$) {
				var id = maybeId.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(id)),
					rest);
			} else {
				return rest;
			}
		});
	return $elm$json$Json$Encode$object(
		A2(
			$author$project$NotificationForm$specEncoder,
			notification.j,
			A2(
				addId,
				notification.K,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(
							$author$project$Enectiva$ValidatedValue$value(notification.a8))),
						_Utils_Tuple2(
						'text',
						$elm$json$Json$Encode$string(notification.c7)),
						_Utils_Tuple2('email_recipient_ids', emailRecipients),
						_Utils_Tuple2(
						'sms_recipient',
						$elm$json$Json$Encode$bool(smsRecipient))
					]))));
};
var $author$project$NotificationForm$saveRequest = function (model) {
	var baseUrl = A2(
		$author$project$View$localizeUrl,
		'/notifications',
		$author$project$Enectiva$I18n$locale(model.A));
	var _v0 = function () {
		var _v1 = model.h.K;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(baseUrl, 'POST');
		} else {
			var id = _v1.a;
			return _Utils_Tuple2(
				baseUrl + ('/' + $elm$core$String$fromInt(id)),
				'PUT');
		}
	}();
	var url = _v0.a;
	var method = _v0.b;
	return $elm$http$Http$request(
		{
			fK: $elm$http$Http$jsonBody(
				$author$project$NotificationForm$notificationEncoder(model.h)),
			f0: A2(
				$author$project$ServerErrors$expectResponse,
				$author$project$NotificationForm$SaveResponse,
				$author$project$ServerErrors$NoContent(0)),
			f9: _List_fromArray(
				[
					A2($elm$http$Http$header, 'X-CSRF-Token', model.bl),
					A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
				]),
			gw: method,
			hm: $elm$core$Maybe$Nothing,
			hq: $elm$core$Maybe$Nothing,
			hv: url
		});
};
var $author$project$RecipientsFilter$updateSelected = F3(
	function (fn, rule, model) {
		return _Utils_update(
			model,
			{
				fe: rule(
					fn(
						$author$project$Enectiva$ValidatedValue$value(model.fe)))
			});
	});
var $author$project$RecipientsFilter$validate = $author$project$RecipientsFilter$updateSelected($elm$core$Basics$identity);
var $author$project$NotificationForm$daysOfWeekValidation = function (translations) {
	return A2($author$project$NotificationForm$setValidation, translations, 'at_least_one_day_of_week');
};
var $author$project$NotificationForm$validateConstraints = F2(
	function (translations, constraints) {
		return function (_v0) {
			var dow = _v0.a;
			var hod = _v0.b;
			var dr = _v0.c;
			return _Utils_Tuple3(
				A2(
					$author$project$NotificationForm$daysOfWeekValidation,
					translations,
					$author$project$Enectiva$ValidatedValue$value(dow)),
				hod,
				dr);
		}(constraints);
	});
var $author$project$Enectiva$ValidatedValue$notNothing = F2(
	function (msg, val) {
		return A2(
			$author$project$Enectiva$ValidatedValue$validateInner,
			val,
			function (m) {
				if (m.$ === 1) {
					return A2($author$project$Enectiva$ValidatedValue$Invalid, m, msg);
				} else {
					return $author$project$Enectiva$ValidatedValue$Valid(m);
				}
			});
	});
var $author$project$NotificationForm$validateDivisor = F2(
	function (translations, divisor) {
		return A2(
			$author$project$Enectiva$ValidatedValue$notNothing,
			A2($author$project$Enectiva$I18n$t, translations, 'errors.messages.blank'),
			$author$project$Enectiva$ValidatedValue$init(
				$author$project$Enectiva$ValidatedValue$value(divisor)));
	});
var $author$project$NotificationForm$validateThresholdField = F2(
	function (translations, spec) {
		return _Utils_update(
			spec,
			{
				E: A2(
					$author$project$NotificationForm$consumptionThresholdValidation,
					translations,
					$author$project$Enectiva$ValidatedValue$value(spec.E))
			});
	});
var $author$project$NotificationForm$validateSpec = F2(
	function (translations, spec) {
		switch (spec.$) {
			case 3:
				var ac = spec.a;
				var unit = spec.b;
				var extension = spec.c;
				return A3(
					$author$project$NotificationForm$AbsoluteConsumptionSpec,
					A2($author$project$NotificationForm$validateThresholdField, translations, ac),
					unit,
					extension);
			case 4:
				var rc = spec.a;
				var extension = spec.b;
				return A2(
					$author$project$NotificationForm$RelativeConsumptionSpec,
					A2($author$project$NotificationForm$validateThresholdField, translations, rc),
					extension);
			case 2:
				var h = spec.a;
				return $author$project$NotificationForm$HolidaySpec(
					_Utils_update(
						h,
						{
							aZ: A2(
								$author$project$NotificationForm$advanceValidation,
								translations,
								$author$project$Enectiva$ValidatedValue$value(h.aZ))
						}));
			case 5:
				var cl = spec.a;
				var unit = spec.b;
				var period = spec.c;
				var constraints = spec.d;
				return A4(
					$author$project$NotificationForm$ConsumptionLimitSpec,
					A2($author$project$NotificationForm$validateThresholdField, translations, cl),
					unit,
					period,
					A2($author$project$NotificationForm$validateConstraints, translations, constraints));
			case 10:
				var sc = spec.a;
				var unit = spec.b;
				var period = spec.c;
				var divisor = spec.d;
				return A4(
					$author$project$NotificationForm$SpecificConsumptionSpec,
					A2($author$project$NotificationForm$validateThresholdField, translations, sc),
					unit,
					period,
					A2($author$project$NotificationForm$validateDivisor, translations, divisor));
			case 7:
				var dt = spec.a;
				var m = spec.b;
				var repetition = spec.c;
				var mode = spec.d;
				return A4(
					$author$project$NotificationForm$DailyDataSeriesSpec,
					dt,
					m,
					A2(
						$author$project$NotificationForm$repetitionValidation,
						translations,
						$author$project$Enectiva$ValidatedValue$value(repetition)),
					mode);
			case 8:
				var qe = spec.a;
				return $author$project$NotificationForm$QExtremeSpec(
					A2($author$project$NotificationForm$validateThresholdField, translations, qe));
			default:
				return spec;
		}
	});
var $author$project$NotificationForm$validateNotification = F2(
	function (translations, notification) {
		var spec = A2($author$project$NotificationForm$validateSpec, translations, notification.j);
		var recipients = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$RecipientsFilter$validate(
				$author$project$NotificationForm$recipientsValidation(translations)),
			notification.z);
		var n = A2(
			$author$project$NotificationForm$nameValidation,
			translations,
			$author$project$Enectiva$ValidatedValue$value(notification.a8));
		return _Utils_update(
			notification,
			{z: recipients, a8: n, j: spec});
	});
var $author$project$NotificationForm$save = function (model) {
	var validated = A2(
		$author$project$NotificationForm$unOnly,
		model,
		$author$project$NotificationForm$validateNotification(model.A));
	return $author$project$NotificationForm$canSave(validated.h) ? A3(
		$author$project$NotificationForm$unCmd,
		_List_fromArray(
			[
				$author$project$NotificationForm$saveRequest(model)
			]),
		validated,
		function (n) {
			return _Utils_update(
				n,
				{bU: $author$project$NotificationForm$Loading});
		}) : _Utils_Tuple2(validated, $elm$core$Platform$Cmd$none);
};
var $author$project$NotificationForm$saveFailed = F2(
	function (model, errors) {
		return A2(
			$author$project$NotificationForm$un,
			model,
			function (n) {
				return _Utils_update(
					n,
					{
						bU: $author$project$NotificationForm$Failure(errors)
					});
			});
	});
var $author$project$NotificationForm$saveWithGeneralError = F2(
	function (model, err) {
		return A2(
			$author$project$NotificationForm$saveFailed,
			model,
			_List_fromArray(
				[err]));
	});
var $author$project$NotificationsForm$SourceSelection$search = F3(
	function (customFilter, query, selection) {
		return A2(
			$author$project$NotificationsForm$SourceSelection$match,
			customFilter,
			_Utils_update(
				selection,
				{c$: query}));
	});
var $author$project$NotificationForm$searchSourceSelection = F2(
	function (model, query) {
		return A2(
			$author$project$NotificationForm$changeSource,
			model,
			A2(
				$author$project$NotificationsForm$SourceSelection$search,
				$author$project$NotificationForm$customSearch(model.h.j),
				query));
	});
var $author$project$NotificationsForm$SourceSelection$clearMatching = $author$project$NotificationsForm$SourceSelection$updateMatching(
	$elm$core$Basics$always(true));
var $author$project$NotificationsForm$SourceSelection$select = F2(
	function (source, selection) {
		return $author$project$NotificationsForm$SourceSelection$new(
			A2(
				$author$project$SelectList$map,
				$author$project$NotificationsForm$SourceSelection$clearMatching,
				A2(
					$author$project$SelectList$select,
					$elm$core$Basics$eq(source),
					selection._)));
	});
var $author$project$NotificationForm$changeConsumptionSource = F2(
	function (model, source) {
		return A2(
			$author$project$NotificationForm$changeConsumption,
			A2(
				$elm$core$Basics$composeR,
				function (s) {
					return _Utils_update(
						s,
						{
							e: A2($author$project$NotificationsForm$SourceSelection$select, source, s.e)
						});
				},
				$author$project$NotificationForm$invalidatePreview),
			model);
	});
var $author$project$NotificationForm$selectSource = F2(
	function (model, source) {
		var notification = model.h;
		var _v0 = notification.j;
		switch (_v0.$) {
			case 7:
				return $author$project$NotificationForm$loadRecipientCandidates(
					A2(
						$author$project$NotificationForm$changeSource,
						model,
						function (s) {
							return A2($author$project$NotificationsForm$SourceSelection$select, source, s);
						}));
			case 6:
				return $author$project$NotificationForm$loadRecipientCandidates(
					A2(
						$author$project$NotificationForm$changeSource,
						model,
						function (s) {
							return A2($author$project$NotificationsForm$SourceSelection$select, source, s);
						}));
			case 8:
				return $author$project$NotificationForm$loadRecipientCandidates(
					A2(
						$author$project$NotificationForm$changeSource,
						model,
						function (s) {
							return A2($author$project$NotificationsForm$SourceSelection$select, source, s);
						}));
			case 3:
				return $author$project$NotificationForm$loadRecipientCandidates(
					A2($author$project$NotificationForm$changeConsumptionSource, model, source));
			case 4:
				return $author$project$NotificationForm$loadRecipientCandidates(
					A2($author$project$NotificationForm$changeConsumptionSource, model, source));
			case 5:
				return $author$project$NotificationForm$loadRecipientCandidates(
					A2($author$project$NotificationForm$changeConsumptionSource, model, source));
			case 10:
				var core = _v0.a;
				var unit = _v0.b;
				var period = _v0.c;
				var divisor = _v0.d;
				return $author$project$NotificationForm$loadRecipientCandidates(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								a2: $krisajenkins$remotedata$RemoteData$Loading,
								h: _Utils_update(
									notification,
									{
										j: A4(
											$author$project$NotificationForm$SpecificConsumptionSpec,
											$author$project$NotificationForm$invalidatePreview(
												_Utils_update(
													core,
													{
														e: A2($author$project$NotificationsForm$SourceSelection$select, source, core.e)
													})),
											unit,
											period,
											divisor)
									})
							}),
						A2($author$project$NotificationForm$loadDivisors, model, source)));
			case 11:
				var spec = _v0.a;
				return $author$project$NotificationForm$loadRecipientCandidates(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: _Utils_update(
									notification,
									{
										j: $author$project$NotificationForm$WastageDetectionSpec(
											_Utils_update(
												spec,
												{
													e: A2($author$project$NotificationsForm$SourceSelection$select, source, spec.e)
												}))
									})
							}),
						$elm$core$Platform$Cmd$none));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$NotificationForm$defaultEnergyAndUnit = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(1, ''),
		A2(
			$elm$core$Maybe$map,
			function (e) {
				return _Utils_Tuple2(
					e.g,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(e.bb)));
			},
			$elm$core$List$head(model.aB)));
};
var $author$project$NotificationsForm$Period$newSelectable = function (allowCustom) {
	return A2($author$project$NotificationsForm$Period$initSelectable, allowCustom, $author$project$NotificationsForm$Period$Day);
};
var $author$project$NotificationForm$newConsumptionExtension = {
	Z: 0,
	aE: $author$project$NotificationsForm$Period$newSelectable(false),
	p: $author$project$NotificationsForm$SnoozePeriod$default
};
var $author$project$NotificationForm$newAbsoluteConsumption = function (model) {
	var measure = 0;
	var _v0 = $author$project$NotificationForm$defaultEnergyAndUnit(model);
	var energy = _v0.a;
	var unit = _v0.b;
	var source = A3(
		$author$project$NotificationsForm$SourceSelection$ensureMeasureAndEnergyConsistency,
		measure,
		energy,
		$author$project$NotificationsForm$SourceSelection$fromSources(model.aT));
	return A3(
		$author$project$NotificationForm$AbsoluteConsumptionSpec,
		{
			g: energy,
			aa: 0,
			u: $author$project$NotificationForm$NotAsked,
			e: source,
			E: $author$project$Enectiva$ValidatedValue$init(100)
		},
		unit,
		$author$project$NotificationForm$newConsumptionExtension);
};
var $author$project$NotificationForm$newConsumptionLimit = function (model) {
	var measure = 0;
	var _v0 = $author$project$NotificationForm$defaultEnergyAndUnit(model);
	var energy = _v0.a;
	var unit = _v0.b;
	var source = A3(
		$author$project$NotificationsForm$SourceSelection$ensureMeasureAndEnergyConsistency,
		measure,
		energy,
		$author$project$NotificationsForm$SourceSelection$fromSources(model.aT));
	return A4(
		$author$project$NotificationForm$ConsumptionLimitSpec,
		{
			g: energy,
			aa: 0,
			u: $author$project$NotificationForm$NotAsked,
			e: source,
			E: $author$project$Enectiva$ValidatedValue$init(100)
		},
		unit,
		$author$project$NotificationsForm$Period$newSelectable(true),
		$author$project$NotificationForm$newConstraints);
};
var $author$project$NotificationForm$newDataSeries = $author$project$NotificationForm$newInstantaneousDataSeries;
var $author$project$NotificationForm$newHoliday = $author$project$NotificationForm$HolidaySpec(
	{
		aZ: $author$project$Enectiva$ValidatedValue$init(1),
		aM: _List_fromArray(
			[$author$project$BareDate$wholeYear]),
		cN: true
	});
var $author$project$NotificationForm$onlyElectricityMeters = function (sources) {
	return A2(
		$elm$core$List$filterMap,
		function (s) {
			if (!s.$) {
				var energy = s.c.g;
				if (energy === 1) {
					return $elm$core$Maybe$Just(s);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		sources);
};
var $author$project$NotificationForm$newQExtreme = function (model) {
	return $author$project$NotificationForm$QExtremeSpec(
		{
			Y: $author$project$NotificationForm$newConstraints,
			p: $author$project$NotificationsForm$SnoozePeriod$default,
			e: $author$project$NotificationsForm$SourceSelection$fromSources(
				$author$project$NotificationForm$onlyElectricityMeters(model.aT)),
			E: $author$project$Enectiva$ValidatedValue$init(15)
		});
};
var $author$project$NotificationForm$newRelativeConsumption = function (model) {
	var measure = 0;
	var _v0 = $author$project$NotificationForm$defaultEnergyAndUnit(model);
	var energy = _v0.a;
	var source = A3(
		$author$project$NotificationsForm$SourceSelection$ensureMeasureAndEnergyConsistency,
		measure,
		energy,
		$author$project$NotificationsForm$SourceSelection$fromSources(model.aT));
	return A2(
		$author$project$NotificationForm$RelativeConsumptionSpec,
		{
			g: energy,
			aa: 0,
			u: $author$project$NotificationForm$NotAsked,
			e: source,
			E: $author$project$Enectiva$ValidatedValue$init(10)
		},
		$author$project$NotificationForm$newConsumptionExtension);
};
var $author$project$NotificationForm$newSpecificConsumption = function (model) {
	var measure = 0;
	var _v0 = $author$project$NotificationForm$defaultEnergyAndUnit(model);
	var energy = _v0.a;
	var unit = _v0.b;
	var source = A3(
		$author$project$NotificationsForm$SourceSelection$ensureMeasureAndEnergyConsistency,
		measure,
		energy,
		$author$project$NotificationsForm$SourceSelection$fromSources(model.aT));
	return A4(
		$author$project$NotificationForm$SpecificConsumptionSpec,
		{
			g: energy,
			aa: 0,
			u: $author$project$NotificationForm$NotAsked,
			e: source,
			E: $author$project$Enectiva$ValidatedValue$init(100)
		},
		unit,
		$author$project$NotificationsForm$Period$newSelectable(false),
		$author$project$Enectiva$ValidatedValue$NotValidated($elm$core$Maybe$Nothing));
};
var $author$project$NotificationForm$newWastageDetection = function (model) {
	return $author$project$NotificationForm$WastageDetectionSpec(
		{
			e: $author$project$NotificationsForm$SourceSelection$fromSources(
				$author$project$NotificationForm$onlyPhysicalWaterMeters(model.aT))
		});
};
var $author$project$NotificationForm$selectType = F2(
	function (model, selection) {
		var newSpec = function () {
			switch (selection) {
				case 0:
					return $author$project$NotificationForm$newArbitraryDate(model.cf);
				case 1:
					return $author$project$NotificationForm$newHoliday;
				case 2:
					return $author$project$NotificationForm$newAbsoluteConsumption(model);
				case 3:
					return $author$project$NotificationForm$newRelativeConsumption(model);
				case 4:
					return $author$project$NotificationForm$newConsumptionLimit(model);
				case 5:
					return $author$project$NotificationForm$newQExtreme(model);
				case 6:
					return $author$project$NotificationForm$newDataSeries(model);
				case 7:
					return $author$project$NotificationForm$newSpecificConsumption(model);
				default:
					return $author$project$NotificationForm$newWastageDetection(model);
			}
		}();
		return $author$project$NotificationForm$loadRecipientCandidates(
			$author$project$NotificationForm$reloadDivisors(
				A2(
					$author$project$NotificationForm$us,
					model,
					function (_v0) {
						return newSpec;
					})));
	});
var $author$project$NotificationForm$serverRespondedToRecipientsRequest = F3(
	function (model, previouslySelectedIds, response) {
		var selected = A2($elm$core$Maybe$withDefault, model.h.dJ, previouslySelectedIds);
		var recipients = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$NotificationForm$initRecipientsModel(selected),
			response);
		return A2(
			$author$project$NotificationForm$un,
			model,
			function (n) {
				return _Utils_update(
					n,
					{z: recipients});
			});
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$NotificationForm$ensureCompatibleDivisor = F2(
	function (notification, divisors) {
		var updatedSpec = function () {
			var _v0 = notification.j;
			if (_v0.$ === 10) {
				var sc = _v0.a;
				var unit = _v0.b;
				var period = _v0.c;
				var current = _v0.d;
				var _v1 = $author$project$Enectiva$ValidatedValue$value(current);
				if (!_v1.$) {
					var divisor = _v1.a;
					return A2($elm$core$List$member, divisor, divisors) ? notification.j : A4(
						$author$project$NotificationForm$SpecificConsumptionSpec,
						sc,
						unit,
						period,
						$author$project$Enectiva$ValidatedValue$init($elm$core$Maybe$Nothing));
				} else {
					return notification.j;
				}
			} else {
				return notification.j;
			}
		}();
		return _Utils_update(
			notification,
			{j: updatedSpec});
	});
var $author$project$NotificationForm$serverRespondedWithDivisors = F2(
	function (model, response) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					a2: response,
					h: A2(
						$author$project$NotificationForm$ensureCompatibleDivisor,
						model.h,
						A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, response))
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Ports$redirectTo = _Platform_outgoingPort('redirectTo', $elm$json$Json$Encode$string);
var $author$project$NotificationForm$successfulSave = function (model) {
	var translations = model.A;
	return A3(
		$author$project$NotificationForm$unCmd,
		_List_fromArray(
			[
				$author$project$Ports$redirectTo(
				A2(
					$author$project$View$localizeUrl,
					'/notifications',
					$author$project$Enectiva$I18n$locale(translations)))
			]),
		model,
		function (n) {
			return _Utils_update(
				n,
				{
					bU: $author$project$NotificationForm$Success(0)
				});
		});
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$ServerErrors$toList = A2($elm$core$Basics$composeR, $elm$core$Dict$values, $elm$core$List$concat);
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$NotificationForm$toggleDayOfWeekHelp = F4(
	function (translations, dow, checked, constraints) {
		var op = checked ? $elm$core$Set$insert : $elm$core$Set$remove;
		return function (_v0) {
			var dows = _v0.a;
			var hod = _v0.b;
			var dr = _v0.c;
			return _Utils_Tuple3(
				A2(
					$author$project$NotificationForm$daysOfWeekValidation,
					translations,
					A2(
						op,
						dow,
						$author$project$Enectiva$ValidatedValue$value(dows))),
				hod,
				dr);
		}(constraints);
	});
var $author$project$NotificationForm$toggleDayOfWeek = F3(
	function (model, dow, checked) {
		var translations = model.A;
		return A2(
			$author$project$NotificationForm$us,
			model,
			function (s) {
				switch (s.$) {
					case 5:
						var spec = s.a;
						var unit = s.b;
						var period = s.c;
						var constraints = s.d;
						return A4(
							$author$project$NotificationForm$ConsumptionLimitSpec,
							spec,
							unit,
							period,
							A4($author$project$NotificationForm$toggleDayOfWeekHelp, translations, dow, checked, constraints));
					case 6:
						var spec = s.a;
						var snooze = s.b;
						var constraints = s.c;
						return A3(
							$author$project$NotificationForm$InstantaneousDataSeriesSpec,
							spec,
							snooze,
							A4($author$project$NotificationForm$toggleDayOfWeekHelp, translations, dow, checked, constraints));
					case 8:
						var spec = s.a;
						var constraints = A4($author$project$NotificationForm$toggleDayOfWeekHelp, translations, dow, checked, spec.Y);
						return $author$project$NotificationForm$QExtremeSpec(
							_Utils_update(
								spec,
								{Y: constraints}));
					default:
						return s;
				}
			});
	});
var $author$project$RecipientsFilter$update = F3(
	function (rule, msg, model) {
		switch (msg.$) {
			case 1:
				var query = msg.a;
				return _Utils_update(
					model,
					{c$: query});
			case 2:
				return _Utils_update(
					model,
					{c$: ''});
			case 3:
				return A3(
					$author$project$RecipientsFilter$updateSelected,
					$elm$core$Basics$always($elm$core$Set$empty),
					rule,
					model);
			default:
				var id = msg.a;
				var checked = msg.b;
				var operation = checked ? $elm$core$Set$insert : $elm$core$Set$remove;
				return A3(
					$author$project$RecipientsFilter$updateSelected,
					operation(id),
					rule,
					model);
		}
	});
var $author$project$NotificationForm$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 42:
					var checked = msg.a;
					return A2($author$project$NotificationForm$changeSmsRecipientSelection, model, checked);
				case 1:
					var selection = msg.a;
					return A2($author$project$NotificationForm$selectType, model, selection);
				case 2:
					var text = msg.a;
					return A2($author$project$NotificationForm$changeText, model, text);
				case 3:
					var newName = msg.a;
					return A2($author$project$NotificationForm$changeName, model, newName);
				case 8:
					var date = msg.a;
					return A2($author$project$NotificationForm$changeArbitraryDate, model, date);
				case 4:
					var str = msg.a;
					var _v1 = $elm$core$String$toInt(str);
					if (_v1.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var advance = _v1.a;
						return A2($author$project$NotificationForm$changeAdvance, model, advance);
					}
				case 5:
					var val = msg.a;
					return A2($author$project$NotificationForm$changeIncludeWeekendDays, model, val);
				case 9:
					var date = msg.a;
					return A2($author$project$NotificationForm$changeArbitraryDate, model, date);
				case 14:
					var direction = msg.a;
					return A2($author$project$NotificationForm$changeDirection, model, direction);
				case 22:
					var periodMsg = msg.a;
					return A2($author$project$NotificationForm$changePeriod, model, periodMsg);
				case 16:
					var energy = msg.a;
					var measure = msg.b;
					return A3($author$project$NotificationForm$changeConsumptionMeasure, model, energy, measure);
				case 10:
					var measure = msg.a;
					var energy = msg.b;
					return A3($author$project$NotificationForm$changeConsumptionEnergy, model, energy, measure);
				case 11:
					var unit = msg.a;
					return A2($author$project$NotificationForm$changeConsumptionUnit, model, unit);
				case 15:
					var source = msg.a;
					return A2($author$project$NotificationForm$selectSource, model, source);
				case 12:
					var str = msg.a;
					return _Utils_Tuple2(
						model,
						A3(
							$author$project$Enectiva$I18n$parseNumber,
							$author$project$NotificationForm$appName,
							$author$project$NotificationForm$numberParsingKeyEncoder(0),
							str));
				case 13:
					var threshold = msg.a;
					return A2($author$project$NotificationForm$changeThreshold, model, threshold);
				case 6:
					var number = msg.a;
					return A2($author$project$NotificationForm$changeSnoozePeriodNumber, model, number);
				case 7:
					var unit = msg.a;
					return A2($author$project$NotificationForm$changeSnoozePeriodUnit, model, unit);
				case 23:
					var subtype = msg.a;
					return A2($author$project$NotificationForm$changeDataSeriesSubtype, model, subtype);
				case 24:
					var repetition = msg.a;
					return A2($author$project$NotificationForm$changeRepetition, model, repetition);
				case 25:
					var mode = msg.a;
					return A2($author$project$NotificationForm$changeDailyDSMode, model, mode);
				case 17:
					var dow = msg.a;
					var checked = msg.b;
					return A3($author$project$NotificationForm$toggleDayOfWeek, model, dow, checked);
				case 18:
					var string = msg.a;
					return A2($author$project$NotificationForm$changeHoursOfDay, model, string);
				case 19:
					var idx = msg.a;
					var dateRangeMsg = msg.b;
					return A3($author$project$NotificationForm$changeDateRangeConstraint, model, idx, dateRangeMsg);
				case 20:
					return $author$project$NotificationForm$addDateRangeConstraint(model);
				case 21:
					var idx = msg.a;
					return A2($author$project$NotificationForm$removeDateRangeConstraint, model, idx);
				case 26:
					var checked = msg.a;
					return A2($author$project$NotificationForm$changeNotifyAboutResolution, model, checked);
				case 27:
					var string = msg.a;
					return A2($author$project$NotificationForm$changeExternalRecipients, model, string);
				case 28:
					return $author$project$NotificationForm$save(model);
				case 29:
					if (!msg.a.$) {
						return $author$project$NotificationForm$successfulSave(model);
					} else {
						if (!msg.a.a.$) {
							var err = msg.a.a.a;
							return A2($author$project$NotificationForm$saveWithGeneralError, model, err);
						} else {
							var perField = msg.a.a.a;
							return A2(
								$author$project$NotificationForm$saveFailed,
								model,
								$author$project$ServerErrors$toList(perField));
						}
					}
				case 30:
					return $author$project$NotificationForm$openSourceSelection(model);
				case 31:
					return $author$project$NotificationForm$closeSourceSelection(model);
				case 32:
					var query = msg.a;
					return A2($author$project$NotificationForm$searchSourceSelection, model, query);
				case 33:
					var rMsg = msg.a;
					return A2(
						$author$project$NotificationForm$un,
						model,
						function (n) {
							return _Utils_update(
								n,
								{
									z: A2(
										$krisajenkins$remotedata$RemoteData$map,
										A2(
											$author$project$RecipientsFilter$update,
											$author$project$NotificationForm$recipientsValidation(model.A),
											rMsg),
										n.z)
								});
						});
				case 35:
					return $author$project$NotificationForm$highlightPreviousSource(model);
				case 34:
					return $author$project$NotificationForm$highlightNextSource(model);
				case 36:
					return $author$project$NotificationForm$changeConsumptionPreview(model);
				case 37:
					if (!msg.a.$) {
						var preview = msg.a.a;
						return A2($author$project$NotificationForm$previewSuccessful, model, preview);
					} else {
						return A2($author$project$NotificationForm$previewWithError, model, 'general error');
					}
				case 38:
					var str = msg.a;
					var $temp$msg = $author$project$NotificationForm$DivisorSelected(
						$author$project$Divisor$fromString(str)),
						$temp$model = model;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 39:
					var divisor = msg.a;
					return A2($author$project$NotificationForm$divisorSelected, model, divisor);
				case 40:
					var response = msg.a;
					return A2($author$project$NotificationForm$serverRespondedWithDivisors, model, response);
				default:
					var previouslySelectedIds = msg.a;
					var response = msg.b;
					return A3($author$project$NotificationForm$serverRespondedToRecipientsRequest, model, previouslySelectedIds, response);
			}
		}
	});
var $author$project$NotificationForm$Save = {$: 28};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Spinner$container = $elm$html$Html$Attributes$class('relative');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$NotificationForm$anyTypeIsSelected = function (notification) {
	var _v0 = notification.j;
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$NotificationForm$saveButton = F3(
	function (translations, notification, enabled) {
		var isDisabled = function () {
			var _v0 = notification.bU;
			if (_v0.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-end')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('submit'),
							$elm$html$Html$Attributes$disabled((!enabled) || isDisabled),
							$elm$html$Html$Attributes$value(
							A2($author$project$Enectiva$I18n$t, translations, 'notification.builder.save')),
							$elm$html$Html$Attributes$class('submit-button')
						]),
					_List_Nil)
				]));
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Enectiva$View$nothing = $elm$html$Html$text('');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$Enectiva$Spinner$colours = {
	eb: 2100,
	dK: A3($avh4$elm_color$Color$rgb255, 0, 90, 171),
	dQ: A3($avh4$elm_color$Color$rgb255, 244, 122, 55),
	fB: A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(_List_Nil))
};
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $author$project$Enectiva$Spinner$cssColorString = F2(
	function (kind, values) {
		return kind + ('(' + (A2($elm$core$String$join, ', ', values) + ')'));
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {hM: a, hS: b, io: g, i3: r};
};
var $author$project$Enectiva$Spinner$colorToCssRgba = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var red = _v0.i3;
	var green = _v0.io;
	var blue = _v0.hS;
	var alpha = _v0.hM;
	return A2(
		$author$project$Enectiva$Spinner$cssColorString,
		'rgba',
		_List_fromArray(
			[
				$elm$core$String$fromFloat(red * 255),
				$elm$core$String$fromFloat(green * 255),
				$elm$core$String$fromFloat(blue * 255),
				$elm$core$String$fromFloat(alpha)
			]));
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$style = $elm$svg$Svg$trustedNode('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Enectiva$Spinner$style = function (settings) {
	return A2(
		$elm$svg$Svg$style,
		_List_Nil,
		_List_fromArray(
			[
				$elm$svg$Svg$text(
				'path.spinner-punk{fill:' + ($author$project$Enectiva$Spinner$colorToCssRgba(settings.dQ) + ';opacity:0}'))
			]));
};
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$Enectiva$Spinner$letterE = function (settings) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('m19.315,27.286194c0,-7.673 -4.763,-10.848 -9.525,-10.848 -5.557,0 -9.79,4.233 -9.79,9.525 0,6.879 5.027,10.054 9.79,10.054 5.027,0 8.995,-4.498 8.995,-6.615H16.14c0,1.323 -2.911,4.234 -6.35,4.234 -2.911,0 -7.144,-1.588 -7.144,-6.35h16.669m-2.646,-2.382c0,-3.175 -2.646,-6.085 -6.879,-6.085 -3.44,0 -7.144,2.646 -7.144,6.085h14.023'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Enectiva$Spinner$colorToCssRgba(settings.dK)),
				$elm$svg$Svg$Attributes$class('e')
			]),
		_List_Nil);
};
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$begin = _VirtualDom_attribute('begin');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$keyTimes = _VirtualDom_attribute('keyTimes');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Enectiva$Spinner$punk = F4(
	function (settings, index, path, begin) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(path),
					$elm$svg$Svg$Attributes$class('spinner-punk')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$animate,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$attributeName('opacity'),
							$elm$svg$Svg$Attributes$values('0;1;0;0'),
							$elm$svg$Svg$Attributes$keyTimes('0;0.2;0.4;1'),
							$elm$svg$Svg$Attributes$dur(
							$elm$core$String$fromFloat(settings.eb) + 'ms'),
							$elm$svg$Svg$Attributes$repeatCount('indefinite'),
							$elm$svg$Svg$Attributes$begin(begin)
						]),
					_List_Nil)
				]));
	});
var $author$project$Enectiva$Spinner$svgElements = function (settings) {
	return _List_fromArray(
		[
			$author$project$Enectiva$Spinner$letterE(settings),
			A4($author$project$Enectiva$Spinner$punk, settings, 0, 'm2.5 8.6c0 2.4 0 4.9 0 7.3 0.3-0.3 2.2-1.3 2.8-1.3 0-2 0-4 0-6z', '0s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 1, 'm8.5 4.5c0 3.2 0 6.4 0 9.5 1.3-0.1 1.6-0.1 2.8 0 0-3.2 0-6.4 0-9.5z', '0.35s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 2, 'm14.5 0c0 4.9 0 9.7 0 14.6 0.6 0 2.5 1 2.8 1.3 0-5.3 0-10.6 0-15.9z', '0.7s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 5, 'm2.9 36.4c0 2.1 0 4.3 0 6.4h2.7v-5.1c-0.3 0-2.4-1.1-2.7-1.3z', '1.75s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 4, 'm8.6 38.2c0 1.6 0 3 0 4.5h2.7c0-1.6 0-3.1 0-4.5-0.9 0.2-1.8 0.2-2.7 0z', '1.4s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 3, 'm16.9 36.4c-0.3 0.3-2.4 1.3-2.7 1.3 0 1.8 0 3.5 0 5.1h2.7c0-2.2 0-4.4 0-6.4z', '1.05s')
		]);
};
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Enectiva$Spinner$full = F2(
	function (settings, show) {
		return show ? settings.fB(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 20 43')
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Enectiva$Spinner$style(settings),
					$author$project$Enectiva$Spinner$svgElements(settings)))) : $elm$svg$Svg$text('');
	});
var $author$project$Enectiva$View$viewIf = F2(
	function (view, condition) {
		return condition ? view(0) : $elm$html$Html$text('');
	});
var $author$project$Spinner$overlay = $author$project$Enectiva$View$viewIf(
	function (_v0) {
		var _default = $author$project$Enectiva$Spinner$colours;
		var opts = _Utils_update(
			_default,
			{
				fB: function (svg) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white opacity-70 absolute top-0 left-0 w-full h-full z-50'),
								A2($elm$html$Html$Attributes$attribute, 'data-spinner-target', 'overlay')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute left-1/2 top-1/10 h-8/10 max-h-12')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-full relative -left-1/2')
											]),
										_List_fromArray(
											[svg]))
									]))
							]));
				}
			});
		return A2($author$project$Enectiva$Spinner$full, opts, true);
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$NotificationForm$errorEntry = function (err) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-red-600 font-bold pl-2 inline-block')
			]),
		$elm$core$List$singleton(
			$elm$html$Html$text(err)));
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$NotificationForm$serverErrors = function (errors) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('space-y-1')
			]),
		A2(
			$elm$core$List$map,
			$elm$html$Html$li(_List_Nil),
			A2(
				$elm$core$List$map,
				$elm$core$List$singleton,
				A2($elm$core$List$map, $author$project$NotificationForm$errorEntry, errors))));
};
var $author$project$View$tt = F2(
	function (translations, path) {
		return $elm$html$Html$text(
			A2($author$project$Enectiva$I18n$t, translations, path));
	});
var $author$project$NotificationForm$serverRequestState = F2(
	function (translations, state) {
		switch (state.$) {
			case 3:
				var errors = state.a;
				return $author$project$NotificationForm$serverErrors(errors);
			case 1:
				return $author$project$Spinner$overlay(true);
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'notice.saved')
						]));
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$NotificationForm$ChangeDirection = function (a) {
	return {$: 14, a: a};
};
var $author$project$NotificationForm$directionToLocalizedString = F2(
	function (translations, direction) {
		return A2(
			$author$project$Enectiva$I18n$t,
			translations,
			'notification.directions.' + $author$project$NotificationForm$directionToString(direction));
	});
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$NotificationForm$directionOption = F3(
	function (translations, current, direction) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$NotificationForm$directionToString(direction)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(direction, current))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$NotificationForm$directionToLocalizedString, translations, direction))
				]));
	});
var $author$project$NotificationForm$directions = _List_fromArray(
	[0, 1]);
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $author$project$NotificationForm$onChangeAs = F2(
	function (decoder, tagger) {
		return A2(
			$elm$html$Html$Events$on,
			'change',
			A2(
				$elm$json$Json$Decode$map,
				tagger,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					decoder)));
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$NotificationForm$directionSelect = F2(
	function (translations, direction) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A2($author$project$NotificationForm$onChangeAs, $author$project$NotificationForm$directionDecoder, $author$project$NotificationForm$ChangeDirection),
					$elm$html$Html$Attributes$class('textfield w-max-content px-2')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$NotificationForm$directionOption, translations, direction),
				$author$project$NotificationForm$directions));
	});
var $author$project$NotificationForm$ChangeConsumptionEnergy = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Types$energyToLocalizedString = F2(
	function (translations, energy) {
		switch (energy) {
			case 1:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_el');
			case 2:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_ga');
			case 3:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_wa');
			case 4:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_he');
			case 5:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_co');
			case 6:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_hca');
			case 7:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_lf');
			default:
				return '';
		}
	});
var $author$project$NotificationForm$energyOption = F3(
	function (translations, spec, energy) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Types$energyToString(energy)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(energy, spec.g))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Types$energyToLocalizedString, translations, energy))
				]));
	});
var $author$project$NotificationForm$energySelect = F3(
	function (translations, energiesWithUnits, spec) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A2(
					$author$project$NotificationForm$onChangeAs,
					$author$project$Types$energyDecoder,
					$author$project$NotificationForm$ChangeConsumptionEnergy(spec.aa)),
					$elm$html$Html$Attributes$class('textfield w-max-content px-2')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$NotificationForm$energyOption, translations, spec),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.g;
					},
					energiesWithUnits)));
	});
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$NotificationForm$legend = F2(
	function (translations, key) {
		return A2(
			$elm$html$Html$legend,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('legend')
				]),
			_List_fromArray(
				[
					A2($author$project$View$tt, translations, key)
				]));
	});
var $author$project$NotificationForm$RequestPreview = {$: 36};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$NotificationForm$previewButton = function (translations) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$NotificationForm$RequestPreview),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('neutral-button')
			]),
		_List_fromArray(
			[
				A2($author$project$View$tt, translations, 'notification.builder.preview.load')
			]));
};
var $author$project$Enectiva$I18n$AsFloat = function (a) {
	return {$: 1, a: a};
};
var $author$project$Enectiva$I18n$escapeDelimiter = function (delimiter) {
	if (delimiter === '.') {
		return '\\.';
	} else {
		return delimiter;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm$core$String$reverse = _String_reverse;
var $elm$core$Basics$truncate = _Basics_truncate;
var $author$project$Enectiva$I18n$formatIntegerPartOfNumber = F2(
	function (delimiter, number) {
		var escapedDelimiter = $author$project$Enectiva$I18n$escapeDelimiter(delimiter);
		return A3(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^' + (escapedDelimiter + ('?(.+?)' + (escapedDelimiter + '?$'))))),
			function (_v0) {
				var submatches = _v0.hi;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						$elm$core$List$head(submatches)));
			},
			A3(
				$elm$core$List$foldl,
				F2(
					function (group, acc) {
						var segment = $elm$core$String$fromList(
							$elm$core$List$reverse(group));
						return _Utils_ap(
							segment,
							_Utils_ap(delimiter, acc));
					}),
				'',
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					3,
					$elm$core$String$toList(
						$elm$core$String$reverse(
							$elm$core$String$fromInt(
								$elm$core$Basics$abs(number) | 0))))));
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Enectiva$I18n$formatNumberWithPrecision = F3(
	function (translations, precision, number) {
		var sign = (number < 0) ? '-' : '';
		var delimiter = A2($author$project$Enectiva$I18n$t, translations, 'number.format.delimiter');
		if (!precision.$) {
			return _Utils_ap(
				sign,
				A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, number));
		} else {
			var decimalPlaces = precision.a;
			var shift = A2($elm$core$Basics$pow, 10, decimalPlaces);
			var shiftedNumber = $elm$core$Basics$round(
				$elm$core$Basics$abs(number * shift));
			var decimalPart = A3(
				$elm$core$String$padRight,
				decimalPlaces,
				'0',
				A3(
					$elm$core$String$padLeft,
					decimalPlaces,
					'0',
					$elm$core$String$fromInt(
						function (n) {
							return A2($elm$core$Basics$modBy, shift, n);
						}(shiftedNumber))));
			return _Utils_ap(
				sign,
				_Utils_ap(
					A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, (shiftedNumber / shift) | 0),
					_Utils_ap(
						A2($author$project$Enectiva$I18n$t, translations, 'number.format.separator'),
						decimalPart)));
		}
	});
var $author$project$Enectiva$I18n$formatNumber = function (translations) {
	return A2(
		$author$project$Enectiva$I18n$formatNumberWithPrecision,
		translations,
		$author$project$Enectiva$I18n$AsFloat(2));
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$View$nbsp = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(160));
var $author$project$View$spaceRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString(' '));
var $author$project$View$replaceSpacesByNbsp = function (str) {
	return A3(
		$elm$regex$Regex$replace,
		$author$project$View$spaceRegex,
		function (_v0) {
			return $author$project$View$nbsp;
		},
		str);
};
var $author$project$View$formatNumberWithNbsp = function (translations) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$formatNumber(translations),
		$author$project$View$replaceSpacesByNbsp);
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Enectiva$View$viewMaybe = F3(
	function (viewValue, viewError, maybe) {
		if (!maybe.$) {
			var whatever = maybe.a;
			return viewValue(whatever);
		} else {
			return viewError(0);
		}
	});
var $author$project$NotificationForm$previewValues = F2(
	function (translations, values) {
		var headerClass = $elm$html$Html$Attributes$class('bg-grey-200 py-2 px-1 text-grey-700 font-semibold whitespace-normal text-center');
		var head = A2(
			$elm$html$Html$thead,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$elm$html$Html$th(
							_List_fromArray(
								[headerClass])),
						A2(
							$elm$core$List$map,
							$elm$core$List$singleton,
							A2(
								$elm$core$List$map,
								$elm$html$Html$text,
								A2(
									$elm$core$List$cons,
									A2($author$project$Enectiva$I18n$t, translations, 'notification.builder.preview.date'),
									A2(
										$elm$core$List$map,
										function (v) {
											return $author$project$View$replaceSpacesByNbsp(v.f5) + (' - ' + $author$project$View$replaceSpacesByNbsp(v.ho));
										},
										values))))))));
		var bodyValues = A2(
			$elm$core$List$map,
			$elm$html$Html$td(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-right tabular-nums bg-grey-100 py-2 px-1')
					])),
			A2(
				$elm$core$List$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$List$map,
					A2(
						$author$project$Enectiva$View$viewMaybe,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$formatNumberWithNbsp(translations),
							$elm$html$Html$text),
						$elm$core$Basics$always($author$project$Enectiva$View$nothing)),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.hw;
						},
						values))));
		var bodyHeader = A2(
			$elm$html$Html$th,
			_List_fromArray(
				[headerClass]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Enectiva$I18n$t, translations, 'notification.builder.preview.value'))
				]));
		var body = A2(
			$elm$html$Html$tbody,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2($elm$core$List$cons, bodyHeader, bodyValues))));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-grey-700')
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'notification.builder.preview.values')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-0')
						]),
					_List_fromArray(
						[head, body]))
				]));
	});
var $author$project$NotificationForm$previewView = F2(
	function (translations, request) {
		switch (request.$) {
			case 3:
				var errors = request.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$NotificationForm$serverErrors(errors),
							$author$project$NotificationForm$previewButton(translations)
						]));
			case 1:
				return $author$project$Spinner$overlay(true);
			case 2:
				var values = request.a;
				return A2($author$project$NotificationForm$previewValues, translations, values);
			default:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					$elm$core$List$singleton(
						$author$project$NotificationForm$previewButton(translations)));
		}
	});
var $author$project$Enectiva$View$viewJust = F2(
	function (view, maybe) {
		if (!maybe.$) {
			var whatever = maybe.a;
			return view(whatever);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$NotificationForm$builderFieldset = F2(
	function (translations, _v0) {
		var between = _v0.a;
		var mp = _v0.b;
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1.5')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$legend, translations, 'notification.builder.rule'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('space-y-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-flex items-center gap-1 flex-wrap')
								]),
							between),
							A2(
							$author$project$Enectiva$View$viewJust,
							$author$project$NotificationForm$previewView(translations),
							mp)
						]))
				]));
	});
var $author$project$NotificationForm$ChangeName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Enectiva$ValidatedValue$mapError = F3(
	function (success, error, str) {
		if (str.$ === 2) {
			var err = str.b;
			return error(err);
		} else {
			return success(0);
		}
	});
var $author$project$NotificationForm$errorMessage = A2(
	$author$project$Enectiva$ValidatedValue$mapError,
	function (_v0) {
		return $author$project$Enectiva$View$nothing;
	},
	$author$project$NotificationForm$errorEntry);
var $author$project$Enectiva$ValidatedValue$isValidOrUntouched = function (str) {
	switch (str.$) {
		case 1:
			return true;
		case 0:
			return true;
		default:
			return false;
	}
};
var $elm$html$Html$Attributes$size = function (n) {
	return A2(
		_VirtualDom_attribute,
		'size',
		$elm$core$String$fromInt(n));
};
var $author$project$NotificationForm$inputWithError = F3(
	function (attrs, formatter, val) {
		var formatted = formatter(
			$author$project$Enectiva$ValidatedValue$value(val));
		var s = $elm$core$String$length(formatted);
		var cls = $author$project$Enectiva$ValidatedValue$isValidOrUntouched(val) ? 'textfield' : 'textfield border-red-800 text-red-800 bg-red-100';
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$value(formatted),
							$elm$html$Html$Attributes$size(s),
							$elm$html$Html$Attributes$class(cls)
						]),
					attrs),
				_List_Nil),
				$author$project$NotificationForm$errorMessage(val)
			]);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$View$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $author$project$NotificationForm$name = function (notification) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A3(
			$author$project$NotificationForm$inputWithError,
			_List_fromArray(
				[
					$author$project$View$onChange($author$project$NotificationForm$ChangeName)
				]),
			$elm$core$Basics$identity,
			notification.a8));
};
var $author$project$NotificationForm$nameFieldset = F2(
	function (translations, notification) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1.5')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$legend, translations, 'notification.builder.enter_name'),
					$author$project$NotificationForm$name(notification)
				]));
	});
var $author$project$NotificationForm$RecipientMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$View$basicUserIdentification = function (user) {
	return user.a8 + (' (' + (user.fY + ')'));
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$RecipientsFilter$errorMessage = A2(
	$author$project$Enectiva$ValidatedValue$mapError,
	function (_v0) {
		return $author$project$Enectiva$View$nothing;
	},
	function (err) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2 text-red-600')
				]),
			$elm$core$List$singleton(
				$elm$html$Html$text(err)));
	});
var $author$project$RecipientsFilter$ClearFilter = {$: 2};
var $author$project$Enectiva$Key$Escape = 2;
var $author$project$RecipientsFilter$Filter = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Enectiva$Key$ArrowDown = 1;
var $author$project$Enectiva$Key$ArrowUp = 0;
var $author$project$Enectiva$Key$Enter = 3;
var $author$project$Enectiva$Key$keyDecoderHelp = function (expectedKeys) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			var filter = function (k) {
				return A2($elm$core$List$member, k, expectedKeys) ? $elm$json$Json$Decode$succeed(k) : $elm$json$Json$Decode$fail('Unexpected key');
			};
			switch (key) {
				case 'ArrowUp':
					return filter(0);
				case 'ArrowDown':
					return filter(1);
				case 'Escape':
					return filter(2);
				case 'Enter':
					return filter(3);
				default:
					return $elm$json$Json$Decode$fail('Unsupported key' + key);
			}
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Enectiva$Key$keyDecoder = function (expectedKeys) {
	return A2(
		$elm$json$Json$Decode$field,
		'key',
		$author$project$Enectiva$Key$keyDecoderHelp(expectedKeys));
};
var $author$project$Enectiva$Key$onKeyUp = F2(
	function (expectedKeys, tagger) {
		return A2(
			$elm$html$Html$Events$on,
			'keyup',
			A2(
				$elm$json$Json$Decode$map,
				tagger,
				$author$project$Enectiva$Key$keyDecoder(expectedKeys)));
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$SvgIcons$search = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$x('0px'),
			$elm$svg$Svg$Attributes$y('0px'),
			$elm$svg$Svg$Attributes$width('16px'),
			$elm$svg$Svg$Attributes$height('16px'),
			$elm$svg$Svg$Attributes$viewBox('3 3 16 16'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18.316,17.435l-3.606-3.606c0.895-1.089,1.433-2.485,1.433-4.006c0-3.49-2.832-6.322-6.321-6.322 C6.329,3.5,3.5,6.332,3.5,9.822c0,3.489,2.829,6.321,6.322,6.321c1.521,0,2.915-0.535,4.003-1.43l3.606,3.604 c0.244,0.245,0.64,0.245,0.885,0C18.562,18.074,18.562,17.676,18.316,17.435z M9.822,14.885c-2.795,0-5.066-2.271-5.066-5.063 c0-2.792,2.271-5.066,5.066-5.066c2.792,0,5.066,2.274,5.066,5.066C14.888,12.613,12.613,14.885,9.822,14.885z')
				]),
			_List_Nil)
		]));
var $author$project$RecipientsFilter$filterRecipients = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white p-0 pr-2 mb-2 w-auto border border-solid border-grey-300 overflow-hidden flex items-center rounded-sm hover:border-grey-700 focus-within:border-grey-700')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(model.c$),
							$elm$html$Html$Events$onInput($author$project$RecipientsFilter$Filter),
							$elm$html$Html$Attributes$placeholder(
							A2($author$project$Enectiva$I18n$t, translations, 'search.placeholder')),
							A2(
							$author$project$Enectiva$Key$onKeyUp,
							_List_fromArray(
								[2]),
							$elm$core$Basics$always($author$project$RecipientsFilter$ClearFilter)),
							$elm$html$Html$Attributes$class('px-2 py-1 w-4/5 grow')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-4 h-4 inline-block line-icon'),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[$author$project$SvgIcons$search]))
						]))
				]));
	});
var $author$project$RecipientsFilter$Checked = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $author$project$SvgIcons$checkmark = function (svgClasses) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x('0px'),
				$elm$svg$Svg$Attributes$y('0px'),
				$elm$svg$Svg$Attributes$width('14px'),
				$elm$svg$Svg$Attributes$height('11.09px'),
				$elm$svg$Svg$Attributes$viewBox('3.977 5.146 14 11.09'),
				$elm$svg$Svg$Attributes$class(svgClasses),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.477,11.08l1.787-1.771l2.882,2.881l6.547-6.544l1.785,1.785l-8.332,8.306L4.477,11.08z')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$View$checkboxChip = F4(
	function (msg, lbl, value, checked) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 pr-2 ' + ('fast-colors-transition rounded-lg cursor-pointer overflow-hidden ' + ('border border-solid border-grey-400 ' + ('text-grey-700 bg-white ' + ('group ' + ('hover:border-blue-800 hover:text-black ' + ('focus-within:border-blue-800 focus-within:text-black ' + 'current:bg-blue-100 current:border-blue-500 current:text-grey-800')))))))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex w-6 shrink-0 bg-grey-100 fast-colors-transition ' + ('current:bg-blue-500 ' + 'group-hover:bg-blue-800 focus-within:bg-blue-800'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$value(value),
									$elm$html$Html$Attributes$checked(checked),
									$elm$html$Html$Events$onCheck(msg),
									$elm$html$Html$Attributes$class('w-0 h-6')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full h-full items-center p-1 hidden flex-next-to-checked')
								]),
							_List_fromArray(
								[
									$author$project$SvgIcons$checkmark('text-white')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' py-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(lbl)
						]))
				]));
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$RecipientsFilter$isRecipient = F2(
	function (_v0, id) {
		var selected = _v0.fe;
		return A2(
			$elm$core$Set$member,
			id,
			$author$project$Enectiva$ValidatedValue$value(selected));
	});
var $author$project$RecipientsFilter$recipient = F4(
	function (translations, model, fullUserIdentification, user) {
		var isSelected = A2($author$project$RecipientsFilter$isRecipient, model, user.K);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('current', isSelected)
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$View$checkboxChip,
					$author$project$RecipientsFilter$Checked(user.K),
					fullUserIdentification(user),
					$elm$core$String$fromInt(user.K),
					isSelected)));
	});
var $author$project$Enectiva$Search$looseString = F2(
	function (needle, haystack) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(needle),
			$elm$core$String$toLower(haystack));
	});
var $author$project$RecipientsFilter$searchedRecipients = F4(
	function (translations, query, fullUserIdentification, user) {
		return (query === '') ? true : A2(
			$author$project$Enectiva$Search$looseString,
			query,
			fullUserIdentification(user));
	});
var $author$project$RecipientsFilter$recipientsList = F3(
	function (translations, model, fullUserIdentification) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-emails gap-2')
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$RecipientsFilter$recipient, translations, model, fullUserIdentification),
				A2(
					$elm$core$List$filter,
					A3($author$project$RecipientsFilter$searchedRecipients, translations, model.c$, fullUserIdentification),
					model.i2)));
	});
var $author$project$RecipientsFilter$view = F4(
	function (translations, model, children, fullUserIdentification) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-2')
				]),
			_Utils_ap(
				children,
				_List_fromArray(
					[
						A2($author$project$RecipientsFilter$filterRecipients, translations, model),
						$author$project$RecipientsFilter$errorMessage(model.fe),
						A3($author$project$RecipientsFilter$recipientsList, translations, model, fullUserIdentification)
					])));
	});
var $author$project$NotificationForm$recipientsFieldset = F2(
	function (translations, recipients) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1.5')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$legend, translations, 'notification.builder.recipients'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-160'),
							$author$project$Spinner$container
						]),
					_List_fromArray(
						[
							function () {
							switch (recipients.$) {
								case 3:
									var recps = recipients.a;
									return A2(
										$elm$html$Html$map,
										$author$project$NotificationForm$RecipientMsg,
										A4($author$project$RecipientsFilter$view, translations, recps, _List_Nil, $author$project$View$basicUserIdentification));
								case 1:
									return $author$project$Spinner$overlay(true);
								case 2:
									return $author$project$NotificationForm$errorEntry('Failed to load data');
								default:
									return $author$project$Enectiva$View$nothing;
							}
						}()
						]))
				]));
	});
var $author$project$NotificationForm$SmsNotificationCheckboxToggled = function (a) {
	return {$: 42, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$View$toggleInnerHelp = F4(
	function (translations, msg, texts, checked) {
		var attrs = texts ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-yes',
				A2($author$project$Enectiva$I18n$t, translations, 'text.yes')),
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-no',
				A2($author$project$Enectiva$I18n$t, translations, 'text.no'))
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-blue-600')
			]);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(checked),
						$elm$html$Html$Events$onCheck(msg)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('boolean-toggle__handle outline-none hover:bg-grey-800 focus:bg-grey-800'),
					attrs),
				_List_Nil)
			]);
	});
var $author$project$View$toggleHelp = F3(
	function (translations, msg, checked) {
		return A4($author$project$View$toggleInnerHelp, translations, msg, true, checked);
	});
var $author$project$View$toggleWithClass = F5(
	function (translations, cls, txt, msg, checked) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-2'),
					$elm$html$Html$Attributes$class(cls)
				]),
			_List_fromArray(
				[
					txt,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('boolean-toggle')
						]),
					A3($author$project$View$toggleHelp, translations, msg, checked))
				]));
	});
var $author$project$View$toggle = F4(
	function (translations, txt, msg, checked) {
		return A5($author$project$View$toggleWithClass, translations, '', txt, msg, checked);
	});
var $author$project$NotificationForm$smsRecipientView = F2(
	function (translations, recipient) {
		switch (recipient.$) {
			case 0:
				return $author$project$Enectiva$View$nothing;
			case 1:
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('blank_'),
							$elm$html$Html$Attributes$href(
							A2(
								$author$project$View$localizeUrl,
								'/phone_number/new',
								$author$project$Enectiva$I18n$locale(translations))),
							$elm$html$Html$Attributes$class('block link mt-2')
						]),
					$elm$core$List$singleton(
						A2($author$project$View$tt, translations, 'notification.builder.phone_number.unconfigured')));
			case 2:
				var number = recipient.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('blank_'),
							$elm$html$Html$Attributes$href(
							A2(
								$author$project$View$localizeUrl,
								'/phone_number/edit',
								$author$project$Enectiva$I18n$locale(translations))),
							$elm$html$Html$Attributes$class('block link')
						]),
					$elm$core$List$singleton(
						$elm$html$Html$text(
							A3(
								$author$project$Enectiva$I18n$tt,
								translations,
								'notification.builder.phone_number.unconfirmed',
								_List_fromArray(
									[
										A2($author$project$Enectiva$I18n$Placeholder, 'number', number)
									])))));
			default:
				var number = recipient.a;
				var selected = recipient.b;
				return A4(
					$author$project$View$toggle,
					translations,
					$elm$html$Html$text(
						A3(
							$author$project$Enectiva$I18n$tt,
							translations,
							'notification.builder.phone_number.configured',
							_List_fromArray(
								[
									A2($author$project$Enectiva$I18n$Placeholder, 'number', number)
								]))),
					$author$project$NotificationForm$SmsNotificationCheckboxToggled,
					$author$project$SelectionState$isSelected(selected));
		}
	});
var $author$project$NotificationForm$ChangeSnoozePeriodNumber = function (a) {
	return {$: 6, a: a};
};
var $author$project$NotificationForm$ChangeSnoozePeriodUnit = function (a) {
	return {$: 7, a: a};
};
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$NotificationForm$numberInput = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $elm$core$String$toInt(s);
		if (!_v0.$) {
			var i = _v0.a;
			return $elm$json$Json$Decode$succeed(i);
		} else {
			return $elm$json$Json$Decode$fail('invalid int ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$NotificationsForm$SnoozePeriod$periods = _List_fromArray(
	[
		_Utils_Tuple2(0, 30),
		$author$project$NotificationsForm$SnoozePeriod$default,
		_Utils_Tuple2(2, 1)
	]);
var $author$project$NotificationsForm$SnoozePeriod$eqUnit = F2(
	function (one, other) {
		return _Utils_eq(one.a, other.a);
	});
var $author$project$NotificationsForm$SnoozePeriod$fromComponents = F2(
	function (numberSource, unitSource) {
		return _Utils_Tuple2(unitSource.a, numberSource.b);
	});
var $author$project$Enectiva$I18n$Count = function (a) {
	return {$: 1, a: a};
};
var $author$project$NotificationsForm$SnoozePeriod$localizedUnit = F2(
	function (translations, snoozePeriod) {
		return A3(
			$author$project$Enectiva$I18n$tt,
			translations,
			'notification.snooze_periods.' + $author$project$NotificationsForm$SnoozePeriod$unit(snoozePeriod),
			_List_fromArray(
				[
					$author$project$Enectiva$I18n$Count(
					$author$project$NotificationsForm$SnoozePeriod$number(snoozePeriod))
				]));
	});
var $author$project$NotificationForm$snoozePeriodOption = F3(
	function (translations, current, snoozePeriod) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$NotificationsForm$SnoozePeriod$unit(snoozePeriod)),
					$elm$html$Html$Attributes$selected(
					A2($author$project$NotificationsForm$SnoozePeriod$eqUnit, current, snoozePeriod))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$NotificationsForm$SnoozePeriod$localizedUnit,
						translations,
						A2($author$project$NotificationsForm$SnoozePeriod$fromComponents, current, snoozePeriod)))
				]));
	});
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$NotificationForm$snoozePeriodView = F2(
	function (translations, current) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-flex items-center gap-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromInt(
								$author$project$NotificationsForm$SnoozePeriod$number(current))),
							$elm$html$Html$Attributes$type_('number'),
							$elm$html$Html$Attributes$min('0'),
							$elm$html$Html$Attributes$step('1'),
							$elm$html$Html$Attributes$class('textfield w-16 px-2 text-right'),
							A2($author$project$NotificationForm$onChangeAs, $author$project$NotificationForm$numberInput, $author$project$NotificationForm$ChangeSnoozePeriodNumber)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$author$project$View$onChange($author$project$NotificationForm$ChangeSnoozePeriodUnit),
							$elm$html$Html$Attributes$class('textfield w-max-content px-2')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$NotificationForm$snoozePeriodOption, translations, current),
						$author$project$NotificationsForm$SnoozePeriod$periods))
				]));
	});
var $author$project$NotificationForm$snoozeFieldset = F2(
	function (translations, current) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1.5')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$legend, translations, 'notification.builder.snooze_period'),
					A2($author$project$NotificationForm$snoozePeriodView, translations, current)
				]));
	});
var $author$project$NotificationForm$ChangeText = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$NotificationForm$notificationText = function (notification) {
	return A2(
		$elm$html$Html$textarea,
		_List_fromArray(
			[
				$author$project$View$onChange($author$project$NotificationForm$ChangeText),
				$elm$html$Html$Attributes$class('w-64 h-24 textfield')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(notification.c7)
			]));
};
var $author$project$NotificationForm$textFieldset = F2(
	function (translations, notification) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1.5')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$legend, translations, 'notification.builder.with_text'),
					$author$project$NotificationForm$notificationText(notification)
				]));
	});
var $author$project$NotificationForm$genericBuilder = F4(
	function (translations, allowedToSubmit, notification, _v0) {
		var before = _v0.aq;
		var extraFieldsets = _v0.av;
		var preview = _v0.u;
		var snoozePeriod = _v0.p;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-4')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$NotificationForm$nameFieldset, translations, notification),
						A2(
						$author$project$NotificationForm$builderFieldset,
						translations,
						_Utils_Tuple2(before, preview))
					]),
				_Utils_ap(
					extraFieldsets,
					_List_fromArray(
						[
							A2($author$project$NotificationForm$textFieldset, translations, notification),
							A2($author$project$NotificationForm$recipientsFieldset, translations, notification.z),
							A2(
							$author$project$Enectiva$View$viewIf,
							function (_v1) {
								return A2($author$project$NotificationForm$smsRecipientView, translations, notification.aI);
							},
							allowedToSubmit),
							A3(
							$author$project$Enectiva$View$viewMaybe,
							function (sp) {
								return A2($author$project$NotificationForm$snoozeFieldset, translations, sp);
							},
							$elm$core$Basics$always($author$project$Enectiva$View$nothing),
							snoozePeriod)
						]))));
	});
var $author$project$NotificationForm$ChangeConsumptionMeasure = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$NotificationsForm$Measure$list = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$NotificationForm$measureOption = F3(
	function (translations, spec, measure) {
		var ps = $author$project$NotificationsForm$Measure$toString(measure);
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(ps),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(measure, spec.aa))
				]),
			_List_fromArray(
				[
					A2($author$project$View$tt, translations, 'notification.builder.measures.' + ps)
				]));
	});
var $author$project$NotificationForm$measureSelect = F2(
	function (translations, spec) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A2(
					$author$project$NotificationForm$onChangeAs,
					$author$project$NotificationsForm$Measure$decoder,
					$author$project$NotificationForm$ChangeConsumptionMeasure(spec.g)),
					$elm$html$Html$Attributes$class('textfield w-max-content px-2')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$NotificationForm$measureOption, translations, spec),
				$author$project$NotificationsForm$Measure$list));
	});
var $author$project$NotificationForm$PeriodSelection = function (a) {
	return {$: 22, a: a};
};
var $author$project$NotificationsForm$Period$Close = {$: 4};
var $author$project$NotificationsForm$Period$Open = {$: 3};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$BareTime$asRangeEnd = function (time) {
	var normalized = $author$project$BareTime$normalize(time + 1);
	var _v0 = $author$project$BareTime$toComponents(normalized);
	var hours = _v0.a;
	var minutes = _v0.b;
	var adjustedHours = ((!hours) && (!minutes)) ? 24 : hours;
	return A2($author$project$BareTime$fromComponents, adjustedHours, minutes);
};
var $author$project$BareTime$toString = function (time) {
	var _v0 = $author$project$BareTime$toComponents(time);
	var hours = _v0.a;
	var minutes = _v0.b;
	var hoursString = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(hours));
	var minutesString = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(minutes));
	return hoursString + (':' + minutesString);
};
var $author$project$BareTime$rangeToString = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	return $author$project$BareTime$toString(from) + (' - ' + $author$project$BareTime$toString(
		$author$project$BareTime$asRangeEnd(to)));
};
var $author$project$NotificationsForm$Period$string = F3(
	function (translations, optionFormat, period) {
		return A2(
			$author$project$View$tt,
			translations,
			'notification.builder.' + (optionFormat + ('.' + $author$project$NotificationsForm$Period$toString(period))));
	});
var $author$project$NotificationsForm$Period$current = F3(
	function (translations, optionFormat, period) {
		var c = function () {
			var _v0 = period.aE;
			if (_v0.$ === 4) {
				var range = _v0.a;
				return _List_fromArray(
					[
						A3($author$project$NotificationsForm$Period$string, translations, optionFormat, period.aE),
						$elm$html$Html$text(
						' ' + $author$project$BareTime$rangeToString(range))
					]);
			} else {
				var p = _v0;
				return _List_fromArray(
					[
						A3($author$project$NotificationsForm$Period$string, translations, optionFormat, p)
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textfield w-max-content pl-2 pr-0'),
					$elm$html$Html$Attributes$class('flex justify-between items-center whitespace-nowrap'),
					$elm$html$Html$Events$onClick($author$project$NotificationsForm$Period$Open)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pseudo-select pr-8')
						]),
					c)
				]));
	});
var $author$project$NotificationsForm$Period$UpdateCustom = function (a) {
	return {$: 1, a: a};
};
var $author$project$NotificationsForm$Period$customInput = function (period) {
	var range = function () {
		var _v0 = period.aE;
		if (_v0.$ === 4) {
			var rng = _v0.a;
			return rng;
		} else {
			return $author$project$BareTime$wholeDay;
		}
	}();
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('text'),
				$elm$html$Html$Attributes$value(
				$author$project$BareTime$rangeToString(range)),
				$author$project$View$onChange($author$project$NotificationsForm$Period$UpdateCustom),
				A2(
				$author$project$Enectiva$Key$onKeyUp,
				_List_fromArray(
					[3]),
				$elm$core$Basics$always($author$project$NotificationsForm$Period$Close)),
				$elm$html$Html$Attributes$class('textfield w-32 px-2')
			]),
		_List_Nil);
};
var $author$project$NotificationsForm$Period$ConfirmCustom = {$: 2};
var $author$project$NotificationsForm$Period$onNonBubblingClick = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$NotificationsForm$Period$customOKButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$author$project$NotificationsForm$Period$onNonBubblingClick($author$project$NotificationsForm$Period$ConfirmCustom),
			$elm$html$Html$Attributes$class('submit-button')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('OK')
		]));
var $author$project$NotificationsForm$Period$option = F2(
	function (attrs, children) {
		return A2(
			$elm$html$Html$li,
			attrs,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full py-2 px-4 cursor-pointer whitespace-nowrap bg-grey-100 text-grey-800'),
							$elm$html$Html$Attributes$class('fast-colors-transition text-left'),
							$elm$html$Html$Attributes$class('hover:bg-white hover:text-black'),
							$elm$html$Html$Attributes$class('focus:bg-white focus:text-black'),
							$elm$html$Html$Attributes$class('current:bg-white current:text-black')
						]),
					children)));
	});
var $author$project$NotificationsForm$Period$customPeriod = F3(
	function (translations, optionFormat, period) {
		return A2(
			$author$project$NotificationsForm$Period$option,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-flex gap-1 items-center')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$NotificationsForm$Period$string,
							translations,
							optionFormat,
							$author$project$NotificationsForm$Period$Custom($author$project$BareTime$wholeDay)),
							$author$project$NotificationsForm$Period$customInput(period),
							$author$project$NotificationsForm$Period$customOKButton
						]))));
	});
var $author$project$NotificationsForm$Period$Set = function (a) {
	return {$: 0, a: a};
};
var $author$project$NotificationsForm$Period$simplePeriod = F4(
	function (translations, optionFormat, selected, period) {
		return A2(
			$author$project$NotificationsForm$Period$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'current',
							_Utils_eq(period, selected.aE))
						])),
					$author$project$NotificationsForm$Period$onNonBubblingClick(
					$author$project$NotificationsForm$Period$Set(period))
				]),
			$elm$core$List$singleton(
				A3($author$project$NotificationsForm$Period$string, translations, optionFormat, period)));
	});
var $author$project$NotificationsForm$Period$simplePeriods = F4(
	function (translations, optionFormat, periods, period) {
		return A2(
			$elm$core$List$map,
			A3($author$project$NotificationsForm$Period$simplePeriod, translations, optionFormat, period),
			periods);
	});
var $author$project$NotificationsForm$Period$dropDown = F4(
	function (translations, optionFormat, periods, period) {
		var cp = A2(
			$author$project$Enectiva$View$viewIf,
			function (_v0) {
				return A3($author$project$NotificationsForm$Period$customPeriod, translations, optionFormat, period);
			},
			period.dZ);
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute max-h-128 overflow-auto z-10'),
					$elm$html$Html$Attributes$class('shadow-md'),
					$elm$html$Html$Attributes$class('bg-grey-300 flex flex-col gap-px')
				]),
			_Utils_ap(
				A4($author$project$NotificationsForm$Period$simplePeriods, translations, optionFormat, periods, period),
				_List_fromArray(
					[cp])));
	});
var $author$project$NotificationsForm$Period$view = F4(
	function (translations, optionFormat, periods, period) {
		return _List_fromArray(
			[
				A3($author$project$NotificationsForm$Period$current, translations, optionFormat, period),
				A2(
				$author$project$Enectiva$View$viewIf,
				function (_v0) {
					return A4($author$project$NotificationsForm$Period$dropDown, translations, optionFormat, periods, period);
				},
				period.bQ)
			]);
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$OnClickOutside$invertDecoder = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (maybe) {
			return _Utils_eq(maybe, $elm$core$Maybe$Nothing) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('');
		},
		$elm$json$Json$Decode$maybe(decoder));
};
var $author$project$OnClickOutside$succeedIfBloodlineHasId = function (targetId) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return _Utils_eq(id, targetId) ? $elm$json$Json$Decode$succeed(0) : A2(
				$elm$json$Json$Decode$field,
				'parentNode',
				$author$project$OnClickOutside$succeedIfBloodlineHasId(targetId));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
};
var $author$project$OnClickOutside$succeedIfClickIsOutsideOfId = function (targetId) {
	return $author$project$OnClickOutside$invertDecoder(
		A2(
			$elm$json$Json$Decode$field,
			'relatedTarget',
			$author$project$OnClickOutside$succeedIfBloodlineHasId(targetId)));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$OnClickOutside$withId = F2(
	function (id, onClickOutsideMsg) {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$tabindex(0),
				$elm$html$Html$Attributes$id(id),
				A2(
				$elm$html$Html$Events$on,
				'focusout',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$always(onClickOutsideMsg),
					$author$project$OnClickOutside$succeedIfClickIsOutsideOfId(id)))
			]);
	});
var $author$project$NotificationsForm$Period$select = F4(
	function (translations, optionFormat, periods, period) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Events$onFocus($author$project$NotificationsForm$Period$Open),
						A2(
						$author$project$Enectiva$Key$onKeyUp,
						_List_fromArray(
							[2]),
						function (_v0) {
							return $author$project$NotificationsForm$Period$Close;
						})
					]),
				A2($author$project$OnClickOutside$withId, 'period_selector', $author$project$NotificationsForm$Period$Close)),
			A4($author$project$NotificationsForm$Period$view, translations, optionFormat, periods, period));
	});
var $author$project$NotificationForm$periodSelector = F4(
	function (translations, localizationPath, availablePeriods, period) {
		return A2(
			$elm$html$Html$map,
			$author$project$NotificationForm$PeriodSelection,
			A4($author$project$NotificationsForm$Period$select, translations, localizationPath, availablePeriods, period));
	});
var $author$project$NotificationForm$ChangeSource = function (a) {
	return {$: 15, a: a};
};
var $author$project$NotificationForm$CloseSourceSelection = {$: 31};
var $author$project$NotificationForm$HighlightNextSource = {$: 34};
var $author$project$NotificationForm$HighlightPrevSource = {$: 35};
var $author$project$NotificationForm$OpenSourceSelection = {$: 30};
var $author$project$NotificationForm$SearchSelection = function (a) {
	return {$: 32, a: a};
};
var $author$project$NotificationsForm$SourceSelection$HtmlIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$NotificationsForm$SourceSelection$NoIcon = {$: 2};
var $author$project$NotificationsForm$SourceSelection$SvgIcon = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$NotificationsForm$SourceSelection$crumbView = F3(
	function (cls, icon, name) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-1 shrink-0'),
					$elm$html$Html$Attributes$class(cls)
				]),
			_List_fromArray(
				[
					function () {
					switch (icon.$) {
						case 2:
							return $author$project$Enectiva$View$nothing;
						case 1:
							var src = icon.a;
							return A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block'),
										$elm$html$Html$Attributes$src(src)
									]),
								_List_Nil);
						default:
							var svg = icon.a;
							return svg;
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$NotificationsForm$SourceSelection$parentBreadcrumbView = function (entity) {
	return _List_fromArray(
		[
			A3(
			$author$project$NotificationsForm$SourceSelection$crumbView,
			'opacity-40',
			$author$project$NotificationsForm$SourceSelection$HtmlIcon(entity.gd),
			entity.a8),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-grey-500 opacity-40')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('▶')
				]))
		]);
};
var $author$project$NotificationsForm$SourceSelection$breadcrumbViewHelp = F3(
	function (icon, name, crumbs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 whitespace-nowrap')
				]),
			_Utils_ap(
				A2($elm$core$List$concatMap, $author$project$NotificationsForm$SourceSelection$parentBreadcrumbView, crumbs),
				_List_fromArray(
					[
						A3($author$project$NotificationsForm$SourceSelection$crumbView, '', icon, name)
					])));
	});
var $author$project$SvgIcons$energyIcon = F6(
	function (cls, iconWidth, iconHeight, children, maybeClass, maybeWidth) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('energy-icon'),
					$elm$svg$Svg$Attributes$class(cls),
					$elm$svg$Svg$Attributes$class(
					A2($elm$core$Maybe$withDefault, '', maybeClass)),
					$elm$svg$Svg$Attributes$viewBox(
					'0 0 ' + ($elm$core$String$fromFloat(iconWidth) + (' ' + $elm$core$String$fromFloat(iconHeight)))),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconWidth, maybeWidth))),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconHeight, maybeWidth)))
				]),
			children);
	});
var $author$project$SvgIcons$co = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	21.75,
	23.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12.037,23H9.67v-2.445l-1.621,1.541l-1.628-1.712l3.249-3.085v-3.506l-3.002,1.734l-1.056,4.39l-2.296-0.556l0.53-2.207 l-2.137,1.234l-1.185-2.052l2.117-1.22l-2.143-0.635l0.668-2.265l4.296,1.271l3.045-1.758L5.496,9.991l-4.33,1.281L0.498,9.007 l2.178-0.644L0.537,7.127l1.185-2.05l2.117,1.224L3.316,4.126l2.296-0.553l1.047,4.356L9.67,9.667V6.18L6.421,3.095l1.628-1.71 L9.67,2.924V0.5h2.367v2.449l1.646-1.564l1.629,1.71l-3.275,3.11v3.488l3.055-1.764l1.047-4.356l2.295,0.553l-0.521,2.175 l2.098-1.213l1.184,2.051l-2.118,1.224l2.177,0.644l-0.668,2.265l-4.33-1.281l-3.011,1.738l3.045,1.757l4.296-1.269l0.668,2.263 l-2.145,0.636l2.1,1.211l-1.184,2.051l-2.119-1.226l0.529,2.209l-2.295,0.556l-1.057-4.39l-3.045-1.76v3.506l3.275,3.11l-1.629,1.71 l-1.646-1.564V23z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$el = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	14.87,
	24,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m 4.973,1.9999455 c -0.36,0 -0.678,0.225 -0.783,0.555 L 0.537,12.767946 c -0.133,0.416 0.109,0.855 0.543,0.982 0.078,0.023 0.16,0.036 0.241,0.036 h 2.767 l -0.752,9.366 c -0.034,0.436 0.303,0.812 0.755,0.846 0.291,0.02 0.571,-0.107 0.738,-0.339 l 9.397,-12.571 c 0.258,-0.357 0.159,-0.847 -0.211,-1.0930004 -0.143,-0.089 -0.301,-0.139 -0.467,-0.139 H 9.666 l 3.881,-6.7200001 c 0.203,-0.388 0.039,-0.859 -0.367,-1.055 -0.114,-0.053 -0.239,-0.081 -0.368,-0.081 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$ga = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	17.34,
	23,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 7.983,0.50455415 C 7.85,0.53055415 7.746,0.63555416 7.729,0.76955416 6.952,5.2625542 5.221,7.1065542 3.611,8.7925542 2.003,10.476554 0.499,12.045554 0.499,15.651554 c 0,1.74 0.771,3.201 1.924,4.342 1.154,1.138 2.688,1.961 4.263,2.482 0.166,0.054 0.343,-0.038 0.395,-0.205 0.031,-0.098 0.013,-0.205 -0.05,-0.286 -1.541,-1.85 -1.971,-3.185 -1.935,-4.27 0.032,-0.956 0.443,-1.763 0.864,-2.591 0.622,0.5 1.163,0.914 1.453,1.1 0.177,0.111 0.299,0.183 0.383,0.226 0.084,0.042 0.158,0.069 0.158,0.069 0.09,0.025 0.187,0.012 0.264,-0.041 0,0 0.627,-0.432 1.13,-1.382 0.421,-0.798 0.749,-2.007 0.657,-3.624 2.023,2.204 2.773,4.091 2.75,5.683 -0.03,2.084 -1.282,3.749 -2.418,4.792 -0.131,0.11 -0.149,0.31 -0.037,0.441 0.071,0.086 0.182,0.127 0.296,0.106 3.244,-0.455 6.245,-3.308 6.245,-6.902 0,-2.544 -0.439,-4.794 -1.74,-7.1539998 -1.299,-2.361 -3.449,-4.825 -6.854,-7.85500004 -0.071,-0.064 -0.169,-0.092 -0.264,-0.078 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$hca = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$he = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$lf = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	23.93,
	22.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3.527,7.357c0,0,2.992,3.304,2.992,4.888c0,1.582-1.34,2.867-2.992,2.867c-1.653,0-2.993-1.283-2.993-2.867 C0.535,10.662,3.527,7.357,3.527,7.357z M23.429,21.12L22.6,19.012c0.231-0.179,0.33-0.48,0.214-0.76l-3.292-7.833l0.604-0.739 c0.127-0.145,0.18-0.341,0.143-0.536c-0.038-0.196-0.159-0.362-0.325-0.454l-7.321-4.248c-0.252-0.144-0.582-0.11-0.804,0.066 l-1.563-1.184c-0.074-0.058-0.162-0.1-0.267-0.126L2.816,1.52C2.443,1.424,2.031,1.676,1.963,2.027L1.589,3.726 C1.51,4.075,1.743,4.429,2.106,4.514l5.898,1.375C8.1,5.958,8.465,6.237,8.929,6.591c0.149,0.115,0.288,0.22,0.422,0.323 C9.208,7.167,9.237,7.486,9.459,7.699l0.438,0.418L12,19.264c0.194,1.155,1.308,2.061,2.537,2.061h0.03 c0.367,0,0.726-0.073,1.067-0.219l2.699-1.158l0.039,0.109c0.088,0.266,0.351,0.45,0.647,0.458l0.797,2.028 C19.906,22.813,20.181,23,20.481,23c0.102,0,0.198-0.021,0.281-0.06l2.296-0.989C23.388,21.811,23.55,21.446,23.429,21.12z M15.396,18.36c-0.227,0.094-0.486-0.05-0.524-0.28l-1.02-5.179c0,0-0.104-0.496,0.358-0.602c0.463-0.104,1.037-0.233,1.037-0.233 l2.003,5.561L15.396,18.36z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$wa = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	16.3,
	22.52,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M8.476,1.155c-0.15-0.209-0.501-0.209-0.651,0L6.007,3.656C4.715,5.439,0.5,11.511,0.5,14.869 c0,4.221,3.435,7.65,7.649,7.65c4.219,0,7.649-3.433,7.649-7.65c0-3.358-4.22-9.432-5.51-11.213L8.476,1.155z')
				]),
			_List_Nil)
		]));
var $author$project$Types$energyIconWithOpts = F3(
	function (_class, size, energy) {
		switch (energy) {
			case 1:
				return A2($author$project$SvgIcons$el, _class, size);
			case 2:
				return A2($author$project$SvgIcons$ga, _class, size);
			case 3:
				return A2($author$project$SvgIcons$wa, _class, size);
			case 4:
				return A2($author$project$SvgIcons$he, _class, size);
			case 5:
				return A2($author$project$SvgIcons$co, _class, size);
			case 6:
				return A2($author$project$SvgIcons$hca, _class, size);
			case 7:
				return A2($author$project$SvgIcons$lf, _class, size);
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$NotificationsForm$SourceSelection$breadcrumbView = function (source) {
	return A5(
		$author$project$NotificationsForm$SourceSelection$mapRealSource,
		F2(
			function (bc, meter) {
				return A3(
					$author$project$NotificationsForm$SourceSelection$breadcrumbViewHelp,
					$author$project$NotificationsForm$SourceSelection$SvgIcon(
						A3(
							$author$project$Types$energyIconWithOpts,
							$elm$core$Maybe$Just('text-grey-800 fill-current'),
							$elm$core$Maybe$Just(16),
							meter.g)),
					meter.a8,
					bc);
			}),
		F2(
			function (bc, vm) {
				return A3(
					$author$project$NotificationsForm$SourceSelection$breadcrumbViewHelp,
					$author$project$NotificationsForm$SourceSelection$SvgIcon(
						A3(
							$author$project$Types$energyIconWithOpts,
							$elm$core$Maybe$Just('text-grey-800 fill-current'),
							$elm$core$Maybe$Just(16),
							vm.g)),
					vm.a8,
					bc);
			}),
		F2(
			function (bc, entity) {
				return A3(
					$author$project$NotificationsForm$SourceSelection$breadcrumbViewHelp,
					$author$project$NotificationsForm$SourceSelection$HtmlIcon(entity.gd),
					entity.a8,
					bc);
			}),
		F2(
			function (bc, ds) {
				return A3($author$project$NotificationsForm$SourceSelection$breadcrumbViewHelp, $author$project$NotificationsForm$SourceSelection$NoIcon, ds.a8, bc);
			}),
		source);
};
var $author$project$NotificationsForm$SourceSelection$currentlySelected = F2(
	function (clickMsg, selection) {
		var current = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('currently-picked')
				]),
			$elm$core$List$singleton(
				$author$project$NotificationsForm$SourceSelection$breadcrumbView(
					$author$project$SelectList$selected(selection._))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(clickMsg),
					$elm$html$Html$Attributes$class('textfield w-auto px-2 py-1 h-full'),
					$elm$html$Html$Attributes$class('content-box relative'),
					$elm$html$Html$Attributes$class('flex justify-between items-center gap-2')
				]),
			_List_fromArray(
				[
					current,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('open-picker')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('▼')
						]))
				]));
	});
var $author$project$NotificationsForm$SourceSelection$searchInput = F4(
	function (translations, placeholderKey, inputMsg, selection) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(selection.c$),
					$elm$html$Html$Events$onInput(inputMsg),
					$elm$html$Html$Attributes$placeholder(
					A2($author$project$Enectiva$I18n$t, translations, placeholderKey)),
					$elm$html$Html$Attributes$class('textfield')
				]),
			_List_Nil);
	});
var $author$project$NotificationsForm$SourceSelection$item = F4(
	function (selectMsg, selection, index, source) {
		var attrs = function () {
			var _v0 = selection.a6;
			if (!_v0.$) {
				var i = _v0.a;
				return _Utils_eq(i, index) ? _List_Nil : _List_Nil;
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$button,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								selectMsg(source)),
								$elm$html$Html$Attributes$class('w-full py-2 px-4 cursor-pointer whitespace-nowrap bg-grey-100 text-grey-800'),
								$elm$html$Html$Attributes$class('fast-colors-transition text-left'),
								$elm$html$Html$Attributes$class('hover:bg-white hover:text-black'),
								$elm$html$Html$Attributes$class('focus:bg-white focus:text-black')
							]),
						attrs),
					$elm$core$List$singleton(
						$author$project$NotificationsForm$SourceSelection$breadcrumbView(source)))));
	});
var $author$project$NotificationsForm$SourceSelection$noMatch = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$elm$core$List$singleton(
			$elm$html$Html$text(
				A2($author$project$Enectiva$I18n$t, translations, 'notification.builder.no_source_match'))));
};
var $author$project$NotificationsForm$SourceSelection$selectedList = F3(
	function (translations, selectMsg, selection) {
		var matchingItems = $author$project$NotificationsForm$SourceSelection$matchingSources(selection);
		return $elm$core$List$isEmpty(matchingItems) ? $author$project$NotificationsForm$SourceSelection$noMatch(translations) : A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-grey-300 flex flex-col gap-px')
				]),
			A2(
				$elm$core$List$indexedMap,
				A2($author$project$NotificationsForm$SourceSelection$item, selectMsg, selection),
				matchingItems));
	});
var $author$project$NotificationsForm$SourceSelection$dropDown = F4(
	function (translations, placeholderKey, messages, selection) {
		var _v0 = selection.c5;
		if (_v0 === 1) {
			return $author$project$Enectiva$View$nothing;
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$author$project$Enectiva$Key$onKeyUp,
						_List_fromArray(
							[2]),
						$elm$core$Basics$always(messages.hT)),
						$elm$html$Html$Attributes$class('absolute max-h-128 overflow-auto z-10'),
						$elm$html$Html$Attributes$class('shadow-md')
					]),
				_List_fromArray(
					[
						A4($author$project$NotificationsForm$SourceSelection$searchInput, translations, placeholderKey, messages.iw, selection),
						A3($author$project$NotificationsForm$SourceSelection$selectedList, translations, messages.je, selection)
					]));
		}
	});
var $author$project$NotificationsForm$SourceSelection$dummySource = A3(
	$author$project$NotificationsForm$SourceSelection$PhysicalMeter,
	false,
	_List_Nil,
	{g: 1, ig: 0, K: 0, gv: 1, a8: ''});
var $author$project$NotificationsForm$SourceSelection$selectHighlighted = F2(
	function (selectMsg, selection) {
		var _v0 = selection.a6;
		if (_v0.$ === 1) {
			return selectMsg($author$project$NotificationsForm$SourceSelection$dummySource);
		} else {
			var index = _v0.a;
			return selectMsg(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$NotificationsForm$SourceSelection$dummySource,
					$elm$core$List$head(
						A2(
							$elm$core$List$drop,
							index,
							$author$project$NotificationsForm$SourceSelection$matchingSources(selection)))));
		}
	});
var $author$project$NotificationsForm$SourceSelection$view = F4(
	function (translations, placeholderKey, messages, selection) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Events$onFocus(messages.im),
						$elm$html$Html$Attributes$class('self-stretch'),
						A2(
						$author$project$Enectiva$Key$onKeyUp,
						_List_fromArray(
							[1, 0, 3]),
						function (key) {
							switch (key) {
								case 1:
									return messages.ir;
								case 0:
									return messages.is;
								case 3:
									return A2($author$project$NotificationsForm$SourceSelection$selectHighlighted, messages.je, selection);
								default:
									return messages.is;
							}
						})
					]),
				A2($author$project$OnClickOutside$withId, 'source_selection', messages.hT)),
			_List_fromArray(
				[
					A2($author$project$NotificationsForm$SourceSelection$currentlySelected, messages.im, selection),
					A4($author$project$NotificationsForm$SourceSelection$dropDown, translations, placeholderKey, messages, selection)
				]));
	});
var $author$project$NotificationForm$sourceSelect = F3(
	function (translations, placeholderKey, spec) {
		return A4(
			$author$project$NotificationsForm$SourceSelection$view,
			translations,
			placeholderKey,
			{hT: $author$project$NotificationForm$CloseSourceSelection, im: $author$project$NotificationForm$OpenSourceSelection, ir: $author$project$NotificationForm$HighlightNextSource, is: $author$project$NotificationForm$HighlightPrevSource, iw: $author$project$NotificationForm$SearchSelection, je: $author$project$NotificationForm$ChangeSource},
			spec.e);
	});
var $author$project$NotificationForm$ChangeThresholdString = function (a) {
	return {$: 12, a: a};
};
var $author$project$NotificationForm$thresholdInput = F2(
	function (translations, spec) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A3(
				$author$project$NotificationForm$inputWithError,
				_List_fromArray(
					[
						$author$project$View$onChange($author$project$NotificationForm$ChangeThresholdString),
						$elm$html$Html$Attributes$class('w-auto text-right tabular-nums')
					]),
				$author$project$Enectiva$I18n$formatNumber(translations),
				spec.E));
	});
var $author$project$NotificationForm$currencyUnit = F2(
	function (translations, currency) {
		return $elm$html$Html$text(
			A2($author$project$Enectiva$I18n$t, translations, 'currency.' + currency));
	});
var $author$project$NotificationForm$ChangeConsumptionUnit = function (a) {
	return {$: 11, a: a};
};
var $author$project$NotificationForm$unitOption = F2(
	function (current, unit) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(unit),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(current, unit))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(unit)
				]));
	});
var $author$project$NotificationForm$energyUnitSelect = F3(
	function (energy, unit, energiesWithUnits) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$author$project$View$onChange($author$project$NotificationForm$ChangeConsumptionUnit),
					$elm$html$Html$Attributes$class('textfield w-max-content px-2')
				]),
			A2(
				$elm$core$List$map,
				$author$project$NotificationForm$unitOption(unit),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.bb;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (e) {
									return _Utils_eq(e.g, energy);
								},
								energiesWithUnits))))));
	});
var $author$project$NotificationForm$unitStep = F6(
	function (translations, currency, measure, energy, unit, energiesWithUnits) {
		switch (measure) {
			case 0:
				return A3($author$project$NotificationForm$energyUnitSelect, energy, unit, energiesWithUnits);
			case 1:
				return A2($author$project$NotificationForm$currencyUnit, translations, currency);
			case 2:
				return A3($author$project$NotificationForm$energyUnitSelect, energy, unit, energiesWithUnits);
			default:
				return A2($author$project$NotificationForm$currencyUnit, translations, currency);
		}
	});
var $author$project$NotificationForm$absoluteConsumptionBuilder = F8(
	function (translations, allowedToSubmit, currency, energiesWithUnits, spec, unit, extension, notification) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _List_fromArray(
					[
						A2($author$project$NotificationForm$measureSelect, translations, spec),
						A3($author$project$NotificationForm$energySelect, translations, energiesWithUnits, spec),
						A3($author$project$NotificationForm$sourceSelect, translations, 'notification.builder.find_consumption_source', spec),
						A2($author$project$View$tt, translations, 'notification.builder.consumption.in_period'),
						A4(
						$author$project$NotificationForm$periodSelector,
						translations,
						'period',
						_List_fromArray(
							[$author$project$NotificationsForm$Period$Hour, $author$project$NotificationsForm$Period$Day, $author$project$NotificationsForm$Period$Month]),
						extension.aE),
						A2($author$project$NotificationForm$directionSelect, translations, extension.Z),
						A2($author$project$NotificationForm$thresholdInput, translations, spec),
						A6($author$project$NotificationForm$unitStep, translations, currency, spec.aa, spec.g, unit, energiesWithUnits)
					]),
				av: _List_Nil,
				u: $elm$core$Maybe$Just(spec.u),
				p: $elm$core$Maybe$Just(extension.p)
			});
	});
var $author$project$NotificationForm$ChangeArbitraryDate = function (a) {
	return {$: 8, a: a};
};
var $author$project$SvgIcons$calendar = function (svgClasses) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x('0px'),
				$elm$svg$Svg$Attributes$y('0px'),
				$elm$svg$Svg$Attributes$width('21px'),
				$elm$svg$Svg$Attributes$height('21.6px'),
				$elm$svg$Svg$Attributes$viewBox('-1.5 1.498 21 21.6'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$class('line-icon -mt-px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13.111,17.52c-0.199,0-0.361,0.163-0.361,0.363v1.715c0,0.199,0.162,0.361,0.361,0.361H15.3c0.2,0,0.362-0.162,0.362-0.361 v-1.715c0-0.2-0.162-0.363-0.362-0.363H13.111z M7.906,17.52c-0.2,0-0.363,0.163-0.363,0.363v1.715c0,0.199,0.163,0.361,0.363,0.361 h2.188c0.2,0,0.363-0.162,0.363-0.361v-1.715c0-0.2-0.163-0.363-0.363-0.363H7.906z M2.641,17.52c-0.2,0-0.363,0.163-0.363,0.363 v1.715c0,0.199,0.163,0.361,0.363,0.361h2.188c0.2,0,0.363-0.162,0.363-0.361v-1.715c0-0.2-0.163-0.363-0.363-0.363H2.641z M13.111,13.795c-0.199,0-0.361,0.162-0.361,0.361v1.715c0,0.2,0.162,0.363,0.361,0.363H15.3c0.2,0,0.362-0.163,0.362-0.363v-1.715 c0-0.199-0.162-0.361-0.362-0.361H13.111z M7.906,13.795c-0.2,0-0.363,0.162-0.363,0.361v1.715c0,0.2,0.163,0.363,0.363,0.363h2.188 c0.2,0,0.363-0.163,0.363-0.363v-1.715c0-0.199-0.163-0.361-0.363-0.361H7.906z M2.641,13.795c-0.2,0-0.363,0.162-0.363,0.361v1.715 c0,0.2,0.163,0.363,0.363,0.363h2.188c0.2,0,0.363-0.163,0.363-0.363v-1.715c0-0.199-0.163-0.361-0.363-0.361H2.641z M13.111,9.924 c-0.199,0-0.361,0.163-0.361,0.363v1.715c0,0.2,0.162,0.363,0.361,0.363H15.3c0.2,0,0.362-0.163,0.362-0.363v-1.715 c0-0.2-0.162-0.363-0.362-0.363H13.111z M7.906,9.924c-0.2,0-0.363,0.163-0.363,0.363v1.715c0,0.2,0.163,0.363,0.363,0.363h2.188 c0.197,0,0.363-0.166,0.363-0.363v-1.715c0-0.2-0.163-0.363-0.363-0.363H7.906z M2.641,9.924c-0.2,0-0.363,0.163-0.363,0.363v1.715 c0,0.2,0.163,0.363,0.363,0.363h2.188c0.197,0,0.363-0.166,0.363-0.363v-1.715c0-0.2-0.163-0.363-0.363-0.363H2.641z M13.249,2.146 c-0.226,0-0.408,0.183-0.408,0.408v3.016c0,0.224,0.183,0.407,0.408,0.407h1.158c0.225,0,0.407-0.183,0.407-0.407V2.554 c0-0.225-0.183-0.408-0.407-0.408H13.249z M3.597,2.146c-0.225,0-0.408,0.183-0.408,0.408v3.016c0,0.224,0.183,0.407,0.408,0.407 h1.159c0.224,0,0.407-0.183,0.407-0.407V2.554c0-0.225-0.183-0.408-0.407-0.408H3.597z M18.462,4.424h-2.188 c-0.114,0-0.114,0.007-0.114,0.064v0.954c0,1.111-0.69,1.801-1.802,1.801h-1.068c-1.077,0-1.801-0.724-1.801-1.801V4.538 c0-0.099-0.069-0.114-0.111-0.114H6.665c-0.128,0-0.153,0.01-0.153,0.122v0.896c0,1.145-0.656,1.801-1.801,1.801H3.643 c-1.212,0-1.802-0.589-1.802-1.801V4.581c0-0.149-0.156-0.157-0.187-0.157h-2.116c-0.321,0-0.389,0.428-0.389,0.788V22.32 c0.016,0.008,0.032,0.016,0.05,0.024c0.09,0.044,0.212,0.104,0.338,0.104h18.923c0.126,0,0.248-0.06,0.338-0.104 c0.018-0.009,0.034-0.017,0.05-0.024V5.212C18.85,4.853,18.782,4.424,18.462,4.424z M17.654,20.865c0,0.211-0.178,0.389-0.388,0.389 H0.734c-0.214,0-0.388-0.174-0.388-0.389V8.71c0-0.214,0.174-0.388,0.388-0.388h16.532c0.21,0,0.388,0.178,0.388,0.388V20.865z')
					]),
				_List_Nil)
			]));
};
var $author$project$View$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(s);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		} else {
			var d = _v0.a;
			return $elm$json$Json$Decode$succeed(d);
		}
	},
	$elm$json$Json$Decode$string);
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {fR: day, ek: hour, eG: millisecond, eI: minute, gz: month, fd: second, hG: year};
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.hG;
		var month = _v0.gz;
		var day = _v0.fR;
		var hour = _v0.ek;
		var minute = _v0.eI;
		var second = _v0.fd;
		var millisecond = _v0.eG;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Enectiva$I18n$dateToMidnight = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		A7(
			$justinmimbs$time_extra$Time$Extra$Parts,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			$justinmimbs$date$Date$day(date),
			0,
			0,
			0,
			0));
};
var $author$project$Enectiva$I18n$defaultDateFormatName = 'date.formats.date_js';
var $author$project$Enectiva$I18n$fourDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$year, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$oneDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthNumber, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$monthAbbr = F2(
	function (translations, zone) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Enectiva$I18n$oneDigitMonth(zone),
			function (number) {
				return A2($author$project$Enectiva$I18n$t, translations, 'date.abbr_month_names.' + number);
			});
	});
var $author$project$Enectiva$I18n$oneDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		$elm$core$String$fromInt);
};
var $author$project$Enectiva$I18n$oneDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$day, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$twoDigits = A2($elm$core$String$padLeft, 2, '0');
var $author$project$Enectiva$I18n$twoDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitDay(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitMinute = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toMinute(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitMonth(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitSecond = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toSecond(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$fourDigitYear(zone),
		$elm$core$String$right(2));
};
var $author$project$Enectiva$I18n$dateReplacers = F2(
	function (translations, zone) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'yyyy',
				$author$project$Enectiva$I18n$fourDigitYear(zone)),
				_Utils_Tuple2(
				'yy',
				$author$project$Enectiva$I18n$twoDigitYear(zone)),
				_Utils_Tuple2(
				'MMM',
				A2($author$project$Enectiva$I18n$monthAbbr, translations, zone)),
				_Utils_Tuple2(
				'MM',
				$author$project$Enectiva$I18n$twoDigitMonth(zone)),
				_Utils_Tuple2(
				'M',
				$author$project$Enectiva$I18n$oneDigitMonth(zone)),
				_Utils_Tuple2(
				'dd',
				$author$project$Enectiva$I18n$twoDigitDay(zone)),
				_Utils_Tuple2(
				'd',
				$author$project$Enectiva$I18n$oneDigitDay(zone)),
				_Utils_Tuple2(
				'HH',
				$author$project$Enectiva$I18n$twoDigit24Hour(zone)),
				_Utils_Tuple2(
				'H',
				$author$project$Enectiva$I18n$oneDigit24Hour(zone)),
				_Utils_Tuple2(
				'mm',
				$author$project$Enectiva$I18n$twoDigitMinute(zone)),
				_Utils_Tuple2(
				'ss',
				$author$project$Enectiva$I18n$twoDigitSecond(zone))
			]);
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $author$project$Enectiva$I18n$replacePlaceholders = F3(
	function (replacers, time, placeholder) {
		return function (replacer) {
			if (!replacer.$) {
				var r = replacer.a;
				return r(time);
			} else {
				return '';
			}
		}(
			A2(
				$elm_community$list_extra$List$Extra$findMap,
				function (_v0) {
					var p = _v0.a;
					var dr = _v0.b;
					return _Utils_eq(p, placeholder) ? $elm$core$Maybe$Just(dr) : $elm$core$Maybe$Nothing;
				},
				replacers));
	});
var $author$project$Enectiva$I18n$formatDateTimeCustomPattern = F4(
	function (pattern, translations, zone, time) {
		var replacers = A2($author$project$Enectiva$I18n$dateReplacers, translations, zone);
		var placeholdersRegex = function (s) {
			return '(' + (s + ')');
		}(
			A2(
				$elm$core$String$join,
				'|',
				A2($elm$core$List$map, $elm$core$Tuple$first, replacers)));
		var primaryRegex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('(.*?)' + placeholdersRegex));
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, matches) {
						var _v0 = matches.hi;
						_v0$2:
						while (true) {
							if (_v0.b) {
								if (_v0.a.$ === 1) {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var _v1 = _v0.a;
										var _v2 = _v0.b;
										var placeholder = _v2.a.a;
										return A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder);
									} else {
										break _v0$2;
									}
								} else {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var literal = _v0.a.a;
										var _v3 = _v0.b;
										var placeholder = _v3.a.a;
										return _Utils_ap(
											literal,
											A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder));
									} else {
										break _v0$2;
									}
								}
							} else {
								break _v0$2;
							}
						}
						return matches.iD;
					}),
				A2($elm$regex$Regex$find, primaryRegex, pattern)));
	});
var $author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate = F2(
	function (formatKey, translations) {
		return A2(
			$author$project$Enectiva$I18n$formatDateTimeCustomPattern,
			A2($author$project$Enectiva$I18n$t, translations, formatKey),
			translations);
	});
var $author$project$Enectiva$I18n$formatDate = F2(
	function (translations, date) {
		return A4(
			$author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate,
			$author$project$Enectiva$I18n$defaultDateFormatName,
			translations,
			$elm$time$Time$utc,
			$author$project$Enectiva$I18n$dateToMidnight(date));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$View$datePickerInput = F4(
	function (translations, opts, msg, date) {
		var attrs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$toIsoString,
						$elm$html$Html$Attributes$attribute('data-datepicker-min-value')),
					opts.cc),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$toIsoString,
						$elm$html$Html$Attributes$attribute('data-datepicker-max-value')),
					opts.cb)
				]));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-flex items-center justify-between w-40 bg-white'),
						$elm$html$Html$Attributes$class('textfield p-0 pr-1 focus-within:border-grey-800'),
						$elm$html$Html$Attributes$class('relative'),
						$elm$html$Html$Attributes$class(opts.b$),
						A2($elm$html$Html$Attributes$attribute, 'data-controller', 'datepicker'),
						A2($elm$html$Html$Attributes$attribute, 'data-datepicker-current-class', 'current'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-datepicker-date-format-value',
						A2($author$project$Enectiva$I18n$t, translations, 'date.formats.picker_js')),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-datepicker-locale-value',
						$author$project$Enectiva$I18n$locale(translations)),
						$elm$html$Html$Attributes$title(
						A2($author$project$Enectiva$I18n$formatDate, translations, date)),
						A2(
						$elm$html$Html$Events$on,
						'datepicker:date-picked',
						A2(
							$elm$json$Json$Decode$map,
							msg,
							A2(
								$elm$json$Json$Decode$field,
								'detail',
								A2($elm$json$Json$Decode$field, 'date', $author$project$View$dateDecoder))))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('textfield border-none outline-none min-w-0 flex-1 box-content m-0'),
							$elm$html$Html$Attributes$value(
							A2($author$project$Enectiva$I18n$formatDate, translations, date)),
							A2($elm$html$Html$Attributes$attribute, 'data-datepicker-target', 'input')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							A2($elm$html$Html$Attributes$attribute, 'data-datepicker-target', 'toggle'),
							$elm$html$Html$Attributes$class('shrink-0 box-content')
						]),
					_List_fromArray(
						[
							$author$project$SvgIcons$calendar('line-icon')
						]))
				]));
	});
var $author$project$View$datePickerOpts = {b$: '', cb: $elm$core$Maybe$Nothing, cc: $elm$core$Maybe$Nothing};
var $author$project$NotificationForm$arbitraryDate = F2(
	function (translations, spec) {
		return A4($author$project$View$datePickerInput, translations, $author$project$View$datePickerOpts, $author$project$NotificationForm$ChangeArbitraryDate, spec.dn);
	});
var $author$project$NotificationForm$arbitraryDateBuilder = F4(
	function (translations, allowedToSubmit, notification, spec) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _List_fromArray(
					[
						A2($author$project$View$tt, translations, 'notification.builder.arbitrary_date.date_is'),
						A2($author$project$NotificationForm$arbitraryDate, translations, spec)
					]),
				av: _List_Nil,
				u: $elm$core$Maybe$Nothing,
				p: $elm$core$Maybe$Nothing
			});
	});
var $author$project$NotificationForm$constraintsFieldsetHelp = F2(
	function (translations, children) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$legend, translations, 'notification.builder.constraints'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-4')
						]),
					children)
				]));
	});
var $author$project$NotificationForm$customPeriodConstraintNote = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-4 text-grey-700 max-w-64')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($author$project$Enectiva$I18n$t, translations, 'notification.builder.consumption_limit_custom_period_constraints_note'))
			]));
};
var $author$project$NotificationForm$AddDateRangeConstraint = {$: 20};
var $author$project$NotificationForm$addNewRange = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$type_('button'),
			$elm$html$Html$Events$onClick($author$project$NotificationForm$AddDateRangeConstraint),
			$elm$html$Html$Attributes$class('bg-green-600 text-white rounded w-6 h-6 opacity-30 hover:opacity-100 focus:opacity-100 text-2xl self-end inline-flex items-center justify-around')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('+')
		]));
var $author$project$NotificationForm$ChangeDateRangeConstraint = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$NotificationForm$DateRangeFrom = function (a) {
	return {$: 0, a: a};
};
var $author$project$NotificationForm$DateRangeTo = function (a) {
	return {$: 1, a: a};
};
var $author$project$BareDate$ChangeDay = function (a) {
	return {$: 1, a: a};
};
var $author$project$BareDate$ChangeMonth = function (a) {
	return {$: 0, a: a};
};
var $author$project$NotificationForm$dayOption = F2(
	function (day, d) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$selected(
					_Utils_eq(d, day)),
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(d))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(d))
				]));
	});
var $author$project$BareDate$daysInMonth = function (month) {
	return A2(
		$elm$core$List$range,
		1,
		$author$project$BareDate$lastDayOfMonth(month));
};
var $author$project$NotificationForm$intOptionDecoder = function (_default) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (s) {
			return $elm$json$Json$Decode$succeed(
				A2(
					$elm$core$Maybe$withDefault,
					_default,
					$elm$core$String$toInt(s)));
		},
		$elm$json$Json$Decode$string);
};
var $author$project$NotificationForm$monthOption = F3(
	function (translations, month, m) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$selected(
					_Utils_eq(m, month)),
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(m))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Enectiva$I18n$t,
						translations,
						'date.month_names.' + $elm$core$String$fromInt(m)))
				]));
	});
var $author$project$BareDate$months = A2($elm$core$List$range, 1, 12);
var $author$project$NotificationForm$bareDate = F3(
	function (translations, tagger, _v0) {
		var month = _v0.a;
		var day = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-flex gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textfield w-max-content px-1'),
							A2(
							$author$project$NotificationForm$onChangeAs,
							$author$project$NotificationForm$intOptionDecoder(1),
							A2($elm$core$Basics$composeR, $author$project$BareDate$ChangeDay, tagger))
						]),
					A2(
						$elm$core$List$map,
						$author$project$NotificationForm$dayOption(day),
						$author$project$BareDate$daysInMonth(month))),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textfield w-max-content px-1'),
							A2(
							$author$project$NotificationForm$onChangeAs,
							$author$project$NotificationForm$intOptionDecoder(1),
							A2($elm$core$Basics$composeR, $author$project$BareDate$ChangeMonth, tagger))
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$NotificationForm$monthOption, translations, month),
						$author$project$BareDate$months))
				]));
	});
var $author$project$NotificationForm$RemoveDateRangeConstraint = function (a) {
	return {$: 21, a: a};
};
var $author$project$NotificationForm$removeDateRange = function (idx) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Events$onClick(
				$author$project$NotificationForm$RemoveDateRangeConstraint(idx)),
				$elm$html$Html$Attributes$class('bg-red-500 text-white rounded w-6 h-6 opacity-30 hover:opacity-100 focus:opacity-100 text-sm font-bold inline-flex items-center justify-around')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('✕')
			]));
};
var $author$project$NotificationForm$dateRangeConstraint = F4(
	function (translations, allowRemove, idx, _v0) {
		var from = _v0.a;
		var to = _v0.b;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-flex items-center gap-2')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$NotificationForm$bareDate,
					translations,
					A2(
						$elm$core$Basics$composeR,
						$author$project$NotificationForm$DateRangeFrom,
						$author$project$NotificationForm$ChangeDateRangeConstraint(idx)),
					from),
					$elm$html$Html$text(' – '),
					A3(
					$author$project$NotificationForm$bareDate,
					translations,
					A2(
						$elm$core$Basics$composeR,
						$author$project$NotificationForm$DateRangeTo,
						$author$project$NotificationForm$ChangeDateRangeConstraint(idx)),
					to),
					A2(
					$author$project$Enectiva$View$viewIf,
					function (_v1) {
						return $author$project$NotificationForm$removeDateRange(idx);
					},
					allowRemove)
				]));
	});
var $author$project$NotificationForm$dateRanges = F2(
	function (translations, ranges) {
		var allowRemove = $elm$core$List$length(ranges) > 1;
		var rs = A2(
			$elm$core$List$indexedMap,
			A2($author$project$NotificationForm$dateRangeConstraint, translations, allowRemove),
			ranges);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-grey-700')
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'notification.builder.date_ranges')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-col flex gap-1')
						]),
					_Utils_ap(
						rs,
						_List_fromArray(
							[$author$project$NotificationForm$addNewRange])))
				]));
	});
var $author$project$NotificationForm$ToggleDayOfWeek = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$NotificationForm$dayOfWeek = F3(
	function (translations, current, dow) {
		var labelText = A2(
			$author$project$Enectiva$I18n$t,
			translations,
			'date.day_names.' + $elm$core$String$fromInt(
				(dow === 7) ? 0 : dow));
		var isSelected = A2(
			$elm$core$Set$member,
			dow,
			$author$project$Enectiva$ValidatedValue$value(current));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('current', isSelected)
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$View$checkboxChip,
					$author$project$NotificationForm$ToggleDayOfWeek(dow),
					labelText,
					$elm$core$String$fromInt(dow),
					isSelected)));
	});
var $author$project$NotificationForm$daysOfWeek = F2(
	function (translations, constraint) {
		var days = A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2 items-start')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$NotificationForm$dayOfWeek, translations, constraint),
				$elm$core$Set$toList($author$project$NotificationForm$everyDay)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-grey-700')
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'notification.builder.days_of_week')
						])),
					days,
					$author$project$NotificationForm$errorMessage(constraint)
				]));
	});
var $author$project$NotificationForm$ChangeHoursOfDay = function (a) {
	return {$: 18, a: a};
};
var $author$project$NotificationForm$hoursOfDay = F2(
	function (translations, range) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-grey-700')
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'notification.builder.hours_of_day')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$value(
							$author$project$BareTime$rangeToString(range)),
							$elm$html$Html$Attributes$class('textfield w-max-content px-2 text-right'),
							$author$project$View$onChange($author$project$NotificationForm$ChangeHoursOfDay)
						]),
					_List_Nil)
				]));
	});
var $author$project$BareTime$rangeStraddlesMidnight = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	return _Utils_cmp(from, to) > 0;
};
var $author$project$NotificationForm$constraintsFieldset = F3(
	function (translations, period, _v0) {
		var dow = _v0.a;
		var hod = _v0.b;
		var dr = _v0.c;
		switch (period.$) {
			case 0:
				return A2(
					$author$project$NotificationForm$constraintsFieldsetHelp,
					translations,
					_List_fromArray(
						[
							A2($author$project$NotificationForm$daysOfWeek, translations, dow),
							A2($author$project$NotificationForm$hoursOfDay, translations, hod),
							A2($author$project$NotificationForm$dateRanges, translations, dr)
						]));
			case 1:
				return A2(
					$author$project$NotificationForm$constraintsFieldsetHelp,
					translations,
					_List_fromArray(
						[
							A2($author$project$NotificationForm$daysOfWeek, translations, dow),
							A2($author$project$NotificationForm$dateRanges, translations, dr)
						]));
			case 4:
				var range = period.a;
				return A2(
					$author$project$NotificationForm$constraintsFieldsetHelp,
					translations,
					_List_fromArray(
						[
							A2($author$project$NotificationForm$daysOfWeek, translations, dow),
							A2($author$project$NotificationForm$dateRanges, translations, dr),
							A2(
							$author$project$Enectiva$View$viewIf,
							function (_v2) {
								return $author$project$NotificationForm$customPeriodConstraintNote(translations);
							},
							$author$project$BareTime$rangeStraddlesMidnight(range))
						]));
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$NotificationForm$section = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('inline-flex items-center gap-1')
		]));
var $author$project$NotificationForm$consumptionLimitBuilder = F9(
	function (translations, allowedToSubmit, currency, energiesWithUnits, spec, unit, period, constraints, notification) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _List_fromArray(
					[
						A2($author$project$NotificationForm$measureSelect, translations, spec),
						A3($author$project$NotificationForm$energySelect, translations, energiesWithUnits, spec),
						A3($author$project$NotificationForm$sourceSelect, translations, 'notification.builder.find_consumption_source', spec),
						A4(
						$author$project$NotificationForm$periodSelector,
						translations,
						'from_beginning_of_period',
						_List_fromArray(
							[$author$project$NotificationsForm$Period$Hour, $author$project$NotificationsForm$Period$Day, $author$project$NotificationsForm$Period$Month, $author$project$NotificationsForm$Period$Year]),
						period),
						$author$project$NotificationForm$section(
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$NotificationForm$directionToLocalizedString, translations, 0)),
								A2($author$project$NotificationForm$thresholdInput, translations, spec),
								A6($author$project$NotificationForm$unitStep, translations, currency, spec.aa, spec.g, unit, energiesWithUnits)
							]))
					]),
				av: _List_fromArray(
					[
						A3($author$project$NotificationForm$constraintsFieldset, translations, period.aE, constraints)
					]),
				u: $elm$core$Maybe$Just(spec.u),
				p: $elm$core$Maybe$Nothing
			});
	});
var $author$project$NotificationForm$DailyDSModeToggledTo = function (a) {
	return {$: 25, a: a};
};
var $author$project$NotificationForm$dailyDSModeInput = F2(
	function (translations, mode) {
		return _List_fromArray(
			[
				A2($author$project$View$tt, translations, 'notification.builder.data_series.daily_ds_mode'),
				A4(
				$author$project$View$toggle,
				translations,
				$author$project$Enectiva$View$nothing,
				function (checked) {
					return $author$project$NotificationForm$DailyDSModeToggledTo(
						checked ? 1 : 0);
				},
				mode === 1)
			]);
	});
var $author$project$NotificationForm$ChangeDataSeriesSubtype = function (a) {
	return {$: 23, a: a};
};
var $author$project$NotificationForm$dataSeriesSubtypeToString = function (type_) {
	if (!type_.$) {
		return 'instantaneous';
	} else {
		var m = type_.a;
		return $author$project$NotificationForm$dataSeriesMeasureToString(m);
	}
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$NotificationForm$uppercaseFirst = function (string) {
	var _v0 = A2($elm$core$String$split, '', string);
	if (_v0.b) {
		var first = _v0.a;
		var rest = _v0.b;
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$cons,
				$elm$core$String$toUpper(first),
				rest));
	} else {
		return string;
	}
};
var $author$project$NotificationForm$dataSeriesSubtypeOption = F3(
	function (translations, current, subtype) {
		var ps = $author$project$NotificationForm$dataSeriesSubtypeToString(subtype);
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(ps),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(subtype, current))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$NotificationForm$uppercaseFirst(
						A2($author$project$Enectiva$I18n$t, translations, 'notification.builder.data_series_subtypes.' + ps)))
				]));
	});
var $author$project$NotificationForm$specToDataSeriesSubtype = function (spec) {
	switch (spec.$) {
		case 6:
			return $author$project$NotificationForm$Instantaneous;
		case 7:
			var m = spec.b;
			return $author$project$NotificationForm$Daily(m);
		default:
			return $author$project$NotificationForm$Instantaneous;
	}
};
var $author$project$NotificationForm$dataSeriesSubtypeSelect = F2(
	function (translations, notification) {
		var subtype = $author$project$NotificationForm$specToDataSeriesSubtype(notification.j);
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A2($author$project$NotificationForm$onChangeAs, $author$project$NotificationForm$dataSeriesSubtypeDecoder, $author$project$NotificationForm$ChangeDataSeriesSubtype),
					$elm$html$Html$Attributes$class('textfield w-max-content px-2')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$NotificationForm$dataSeriesSubtypeOption, translations, subtype),
				_List_fromArray(
					[
						$author$project$NotificationForm$Daily(0),
						$author$project$NotificationForm$Daily(1),
						$author$project$NotificationForm$Daily(2),
						$author$project$NotificationForm$Instantaneous
					])));
	});
var $author$project$NotificationsForm$SourceSelection$selectedSourceUnit = function (_v0) {
	var list = _v0._;
	return A5(
		$author$project$NotificationsForm$SourceSelection$mapRealSource,
		$elm$core$Basics$always(
			$elm$core$Basics$always($elm$core$Maybe$Nothing)),
		$elm$core$Basics$always(
			$elm$core$Basics$always($elm$core$Maybe$Nothing)),
		$elm$core$Basics$always(
			$elm$core$Basics$always($elm$core$Maybe$Nothing)),
		F2(
			function (_v1, ds) {
				return $elm$core$Maybe$Just(ds.ad);
			}),
		$author$project$SelectList$selected(list));
};
var $author$project$NotificationForm$dataSeriesCoreBuilder = F3(
	function (translations, notification, spec) {
		return _List_fromArray(
			[
				A2($author$project$NotificationForm$dataSeriesSubtypeSelect, translations, notification),
				A2($author$project$View$tt, translations, 'notification.builder.data_series.value'),
				A3($author$project$NotificationForm$sourceSelect, translations, 'notification.builder.find_data_series', spec),
				A2($author$project$NotificationForm$directionSelect, translations, spec.Z),
				A2($author$project$NotificationForm$thresholdInput, translations, spec),
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$NotificationsForm$SourceSelection$selectedSourceUnit(spec.e)))
			]);
	});
var $author$project$NotificationForm$ChangeRepetition = function (a) {
	return {$: 24, a: a};
};
var $author$project$NotificationForm$repetitionInput = F2(
	function (translations, repetition) {
		return $author$project$NotificationForm$section(
			_Utils_ap(
				A3(
					$author$project$NotificationForm$inputWithError,
					_List_fromArray(
						[
							A2($author$project$NotificationForm$onChangeAs, $author$project$NotificationForm$numberInput, $author$project$NotificationForm$ChangeRepetition),
							$elm$html$Html$Attributes$class('textfield w-12 px-1 text-right'),
							$elm$html$Html$Attributes$type_('number'),
							$elm$html$Html$Attributes$min('0')
						]),
					$elm$core$String$fromInt,
					repetition),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3(
							$author$project$Enectiva$I18n$tt,
							translations,
							'notification.snooze_periods.d',
							_List_fromArray(
								[
									$author$project$Enectiva$I18n$Count(
									$author$project$Enectiva$ValidatedValue$value(repetition))
								]))),
						$elm$html$Html$text(' '),
						A2($author$project$View$tt, translations, 'notification.builder.data_series.repetition'),
						$elm$html$Html$text(',')
					])));
	});
var $author$project$NotificationForm$dailyDataSeriesBuilder = F6(
	function (translations, allowedToSubmit, spec, repetition, mode, notification) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _Utils_ap(
					A3($author$project$NotificationForm$dataSeriesCoreBuilder, translations, notification, spec),
					_Utils_ap(
						_List_fromArray(
							[
								A2($author$project$NotificationForm$repetitionInput, translations, repetition)
							]),
						_List_fromArray(
							[
								$author$project$NotificationForm$section(
								A2($author$project$NotificationForm$dailyDSModeInput, translations, mode))
							]))),
				av: _List_Nil,
				u: $elm$core$Maybe$Nothing,
				p: $elm$core$Maybe$Nothing
			});
	});
var $author$project$NotificationForm$ChangeAdvanceString = function (a) {
	return {$: 4, a: a};
};
var $author$project$NotificationForm$ChangeIncludeWeekendDays = function (a) {
	return {$: 5, a: a};
};
var $author$project$NotificationForm$holidayBuilder = F4(
	function (translations, allowedToSubmit, notification, spec) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _List_fromArray(
					[
						A2($author$project$View$tt, translations, 'notification.builder.holiday.advance'),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A3(
							$author$project$NotificationForm$inputWithError,
							_List_fromArray(
								[
									$author$project$View$onChange($author$project$NotificationForm$ChangeAdvanceString),
									$elm$html$Html$Attributes$class('textfield w-12 p-1 text-right'),
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$min('1')
								]),
							$elm$core$String$fromInt,
							spec.aZ)),
						$elm$html$Html$text(
						A3(
							$author$project$Enectiva$I18n$tt,
							translations,
							'notification.snooze_periods.d',
							_List_fromArray(
								[
									$author$project$Enectiva$I18n$Count(
									$author$project$Enectiva$ValidatedValue$value(spec.aZ))
								]))),
						$elm$html$Html$text(' '),
						A2($author$project$View$tt, translations, 'notification.builder.holiday.advance_after'),
						$elm$html$Html$text(', '),
						$elm$html$Html$text(
						A2($author$project$Enectiva$I18n$t, translations, 'notification.builder.holiday.include_weekend_days')),
						A4($author$project$View$toggle, translations, $author$project$Enectiva$View$nothing, $author$project$NotificationForm$ChangeIncludeWeekendDays, spec.cN)
					]),
				av: _List_fromArray(
					[
						A2(
						$elm$html$Html$fieldset,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('space-y-1')
							]),
						_List_fromArray(
							[
								A2($author$project$NotificationForm$legend, translations, 'notification.builder.constraints'),
								A2($author$project$NotificationForm$dateRanges, translations, spec.aM)
							]))
					]),
				u: $elm$core$Maybe$Nothing,
				p: $elm$core$Maybe$Nothing
			});
	});
var $author$project$NotificationForm$instantaneousDataSeriesBuilder = F6(
	function (translations, allowedToSubmit, spec, snoozePeriod, constraints, notification) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: A3($author$project$NotificationForm$dataSeriesCoreBuilder, translations, notification, spec),
				av: _List_fromArray(
					[
						A3($author$project$NotificationForm$constraintsFieldset, translations, $author$project$NotificationsForm$Period$Hour, constraints)
					]),
				u: $elm$core$Maybe$Nothing,
				p: $elm$core$Maybe$Just(snoozePeriod)
			});
	});
var $author$project$NotificationForm$ChangeExternalRecipients = function (a) {
	return {$: 27, a: a};
};
var $author$project$NotificationForm$externalRecipientsFieldset = F2(
	function (translations, spec) {
		var lines = A2($elm$core$String$join, '\n', spec.dt) + '\n';
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$legend, translations, 'notification.builder.meter_error_state.external_recipients'),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$author$project$View$onChange($author$project$NotificationForm$ChangeExternalRecipients),
									$elm$html$Html$Attributes$class('w-64 h-24 textfield')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(lines)
								]))
						]))
				]));
	});
var $author$project$NotificationForm$ChangeNotifyAboutResolution = function (a) {
	return {$: 26, a: a};
};
var $author$project$NotificationForm$notifyAboutResolutionFieldset = F2(
	function (translations, spec) {
		return A4(
			$author$project$View$toggle,
			translations,
			A2($author$project$View$tt, translations, 'notification.builder.meter_error_state.notify_about_resolution'),
			$author$project$NotificationForm$ChangeNotifyAboutResolution,
			spec.dF);
	});
var $author$project$NotificationForm$meterErrorStateBuilder = F4(
	function (translations, allowedToSubmit, notification, spec) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-4')
				]),
			_List_fromArray(
				[
					A2($author$project$NotificationForm$notifyAboutResolutionFieldset, translations, spec),
					A2($author$project$NotificationForm$recipientsFieldset, translations, notification.z),
					A2($author$project$NotificationForm$externalRecipientsFieldset, translations, spec),
					A2(
					$author$project$Enectiva$View$viewIf,
					function (_v0) {
						return A2($author$project$NotificationForm$smsRecipientView, translations, notification.aI);
					},
					allowedToSubmit)
				]));
	});
var $author$project$NotificationForm$qExtremeBuilder = F4(
	function (translations, allowedToSubmit, spec, notification) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _List_fromArray(
					[
						A2($author$project$View$tt, translations, 'notification.builder.q_extreme.q_max'),
						A3($author$project$NotificationForm$sourceSelect, translations, 'notification.builder.find_consumption_source', spec),
						A2($author$project$View$tt, translations, 'notification.directions.greater_than'),
						A2($author$project$NotificationForm$thresholdInput, translations, spec),
						$elm$html$Html$text('kW')
					]),
				av: _List_fromArray(
					[
						A3($author$project$NotificationForm$constraintsFieldset, translations, $author$project$NotificationsForm$Period$Hour, spec.Y)
					]),
				u: $elm$core$Maybe$Nothing,
				p: $elm$core$Maybe$Just(spec.p)
			});
	});
var $author$project$NotificationForm$relativeConsumptionBuilder = F6(
	function (translations, allowedToSubmit, spec, extension, notification, energiesWithUnits) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _List_fromArray(
					[
						A2($author$project$NotificationForm$measureSelect, translations, spec),
						A3($author$project$NotificationForm$energySelect, translations, energiesWithUnits, spec),
						A3($author$project$NotificationForm$sourceSelect, translations, 'notification.builder.find_consumption_source', spec),
						$author$project$NotificationForm$section(
						_List_fromArray(
							[
								A2($author$project$View$tt, translations, 'notification.builder.consumption.between_periods'),
								A4(
								$author$project$NotificationForm$periodSelector,
								translations,
								'relative_period',
								_List_fromArray(
									[$author$project$NotificationsForm$Period$Hour, $author$project$NotificationsForm$Period$Day, $author$project$NotificationsForm$Period$Month]),
								extension.aE)
							])),
						$author$project$NotificationForm$section(
						_List_fromArray(
							[
								A2($author$project$NotificationForm$directionSelect, translations, extension.Z),
								A2($author$project$NotificationForm$thresholdInput, translations, spec),
								$elm$html$Html$text('%')
							]))
					]),
				av: _List_Nil,
				u: $elm$core$Maybe$Just(spec.u),
				p: $elm$core$Maybe$Just(extension.p)
			});
	});
var $author$project$NotificationForm$DivisorOptionSelected = function (a) {
	return {$: 38, a: a};
};
var $author$project$Divisor$eq = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var dsa = _v0.a.a;
						var dsb = _v0.b.a;
						return _Utils_eq(dsa.K, dsb.K);
					} else {
						break _v0$4;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var pda = _v0.a.a;
						var pdb = _v0.b.a;
						return _Utils_eq(pda.K, pdb.K);
					} else {
						break _v0$4;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var atda = _v0.a.a;
						var atdb = _v0.b.a;
						return _Utils_eq(atda.K, atdb.K);
					} else {
						break _v0$4;
					}
				default:
					if (_v0.b.$ === 3) {
						var atda = _v0.a.a;
						var atdb = _v0.b.a;
						return _Utils_eq(atda.K, atdb.K);
					} else {
						break _v0$4;
					}
			}
		}
		return false;
	});
var $author$project$Divisor$toLocalizedString = F2(
	function (translations, divisor) {
		switch (divisor.$) {
			case 0:
				var name = divisor.a.a8;
				var unit = divisor.a.ad;
				return name + (' (' + (unit + ')'));
			case 1:
				var name = divisor.a.a8;
				var unit = divisor.a.ad;
				return name + (' (' + (unit + ')'));
			case 2:
				var name = divisor.a.a8;
				var unit = divisor.a.ad;
				return name + (' (' + (unit + ')'));
			default:
				var name = divisor.a.a8;
				var unit = divisor.a.ad;
				return name + (' (' + (unit + ')'));
		}
	});
var $author$project$NotificationForm$divisorOption = F3(
	function (translations, current, divisor) {
		var selected = function () {
			if (current.$ === 1) {
				return false;
			} else {
				var d = current.a;
				return A2($author$project$Divisor$eq, d, divisor);
			}
		}();
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Divisor$toString(divisor)),
					$elm$html$Html$Attributes$selected(selected)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Divisor$toLocalizedString, translations, divisor))
				]));
	});
var $author$project$Divisor$localizedTypeName = F2(
	function (translations, divisor) {
		switch (divisor.$) {
			case 0:
				return A2($author$project$Enectiva$I18n$t, translations, 'stats.divisor_types.data_sources');
			case 1:
				return A2($author$project$Enectiva$I18n$t, translations, 'stats.divisor_types.properties');
			case 2:
				return A2($author$project$Enectiva$I18n$t, translations, 'stats.divisor_types.aggregate_area_types');
			default:
				return A2($author$project$Enectiva$I18n$t, translations, 'stats.divisor_types.individual_area_types');
		}
	});
var $elm$html$Html$optgroup = _VirtualDom_node('optgroup');
var $author$project$NotificationForm$divisorOptgroup = F3(
	function (translations, current, divisors) {
		if (divisors.b) {
			var head = divisors.a;
			return A2(
				$elm$html$Html$optgroup,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$attribute,
						'label',
						A2($author$project$Divisor$localizedTypeName, translations, head))
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$NotificationForm$divisorOption, translations, current),
					divisors));
		} else {
			return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$Divisor$reverseResults = function (results) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
		_List_fromArray(
			[
				$elm$core$List$reverse(results.cC),
				$elm$core$List$reverse(results.c_),
				$elm$core$List$reverse(results.cO),
				$elm$core$List$reverse(results.cv)
			]));
};
var $author$project$Divisor$groupByType = function (divisors) {
	var divide = function (list) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					switch (x.$) {
						case 0:
							return _Utils_update(
								acc,
								{
									cC: A2($elm$core$List$cons, x, acc.cC)
								});
						case 1:
							return _Utils_update(
								acc,
								{
									c_: A2($elm$core$List$cons, x, acc.c_)
								});
						case 2:
							return _Utils_update(
								acc,
								{
									cv: A2($elm$core$List$cons, x, acc.cv)
								});
						default:
							return _Utils_update(
								acc,
								{
									cO: A2($elm$core$List$cons, x, acc.cO)
								});
					}
				}),
			{cv: _List_Nil, cC: _List_Nil, cO: _List_Nil, c_: _List_Nil},
			list);
	};
	return $author$project$Divisor$reverseResults(
		divide(divisors));
};
var $author$project$NotificationForm$noDivisorOption = function (current) {
	var selected = function () {
		if (current.$ === 1) {
			return true;
		} else {
			return false;
		}
	}();
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(''),
				$elm$html$Html$Attributes$selected(selected)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('---')
			]));
};
var $author$project$NotificationForm$divisorOptions = F3(
	function (translations, divisors, current) {
		var currentValue = $author$project$Enectiva$ValidatedValue$value(current);
		return A2(
			$elm$core$List$cons,
			$author$project$NotificationForm$noDivisorOption(currentValue),
			A2(
				$elm$core$List$map,
				A2($author$project$NotificationForm$divisorOptgroup, translations, currentValue),
				$author$project$Divisor$groupByType(divisors)));
	});
var $author$project$NotificationForm$divisorSelect = F3(
	function (translations, divisors, divisor) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$author$project$View$onChange($author$project$NotificationForm$DivisorOptionSelected),
							$elm$html$Html$Attributes$class('textfield px-2')
						]),
					A3($author$project$NotificationForm$divisorOptions, translations, divisors, divisor)),
					$author$project$NotificationForm$errorMessage(divisor)
				]));
	});
var $author$project$NotificationForm$divisorStep = F3(
	function (translations, divisorsRequest, divisor) {
		switch (divisorsRequest.$) {
			case 0:
				return $author$project$Enectiva$View$nothing;
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Spinner$container]),
					_List_fromArray(
						[
							$author$project$Spinner$overlay(true)
						]));
			case 3:
				var divisors = divisorsRequest.a;
				return A3($author$project$NotificationForm$divisorSelect, translations, divisors, divisor);
			default:
				return $author$project$NotificationForm$errorEntry('error, failed to fetch applicable divisors');
		}
	});
var $author$project$NotificationForm$specificConsumptionBuilder = function (translations) {
	return function (allowedToSubmit) {
		return function (currency) {
			return function (energiesWithUnits) {
				return function (spec) {
					return function (unit) {
						return function (period) {
							return function (divisors) {
								return function (divisor) {
									return function (notification) {
										return A4(
											$author$project$NotificationForm$genericBuilder,
											translations,
											allowedToSubmit,
											notification,
											{
												aq: _List_fromArray(
													[
														$author$project$NotificationForm$section(
														_List_fromArray(
															[
																A2($author$project$NotificationForm$measureSelect, translations, spec),
																A3($author$project$NotificationForm$energySelect, translations, energiesWithUnits, spec),
																A3($author$project$NotificationForm$sourceSelect, translations, 'notification.builder.find_consumption_source', spec),
																A4(
																$author$project$NotificationForm$periodSelector,
																translations,
																'period',
																_List_fromArray(
																	[$author$project$NotificationsForm$Period$Day, $author$project$NotificationsForm$Period$Month]),
																period)
															])),
														$author$project$NotificationForm$section(
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($author$project$NotificationForm$directionToLocalizedString, translations, 0)),
																A2($author$project$NotificationForm$thresholdInput, translations, spec),
																A6($author$project$NotificationForm$unitStep, translations, currency, spec.aa, spec.g, unit, energiesWithUnits),
																$elm$html$Html$text(' / '),
																A3($author$project$NotificationForm$divisorStep, translations, divisors, divisor)
															]))
													]),
												av: _List_Nil,
												u: $elm$core$Maybe$Nothing,
												p: $elm$core$Maybe$Nothing
											});
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$NotificationForm$wastageDetectionBuilder = F4(
	function (translations, allowedToSubmit, notification, spec) {
		return A4(
			$author$project$NotificationForm$genericBuilder,
			translations,
			allowedToSubmit,
			notification,
			{
				aq: _List_fromArray(
					[
						A2($author$project$View$tt, translations, 'notification.builder.wastage_detection.water_consumption'),
						A3($author$project$NotificationForm$sourceSelect, translations, 'notification.builder.find_consumption_source', spec)
					]),
				av: _List_Nil,
				u: $elm$core$Maybe$Nothing,
				p: $elm$core$Maybe$Nothing
			});
	});
var $author$project$NotificationForm$specificBuilder = function (model) {
	var notification = model.h;
	var translations = model.A;
	var divisors = model.a2;
	var allowedToSubmit = model.bG;
	var _v0 = notification.j;
	switch (_v0.$) {
		case 1:
			var spec = _v0.a;
			return A4($author$project$NotificationForm$arbitraryDateBuilder, translations, allowedToSubmit, notification, spec);
		case 2:
			var spec = _v0.a;
			return A4($author$project$NotificationForm$holidayBuilder, translations, allowedToSubmit, notification, spec);
		case 3:
			var spec = _v0.a;
			var unit = _v0.b;
			var extension = _v0.c;
			return A8($author$project$NotificationForm$absoluteConsumptionBuilder, translations, allowedToSubmit, model.bm, model.aB, spec, unit, extension, notification);
		case 4:
			var spec = _v0.a;
			var extension = _v0.b;
			return A6($author$project$NotificationForm$relativeConsumptionBuilder, translations, allowedToSubmit, spec, extension, notification, model.aB);
		case 5:
			var spec = _v0.a;
			var unit = _v0.b;
			var period = _v0.c;
			var constraints = _v0.d;
			return A9($author$project$NotificationForm$consumptionLimitBuilder, translations, allowedToSubmit, model.bm, model.aB, spec, unit, period, constraints, notification);
		case 10:
			var spec = _v0.a;
			var unit = _v0.b;
			var period = _v0.c;
			var divisor = _v0.d;
			return $author$project$NotificationForm$specificConsumptionBuilder(translations)(allowedToSubmit)(model.bm)(model.aB)(spec)(unit)(period)(divisors)(divisor)(notification);
		case 6:
			var spec = _v0.a;
			var snoozePeriod = _v0.b;
			var constraints = _v0.c;
			return A6($author$project$NotificationForm$instantaneousDataSeriesBuilder, translations, allowedToSubmit, spec, snoozePeriod, constraints, notification);
		case 7:
			var spec = _v0.a;
			var repetition = _v0.c;
			var mode = _v0.d;
			return A6($author$project$NotificationForm$dailyDataSeriesBuilder, translations, allowedToSubmit, spec, repetition, mode, notification);
		case 8:
			var spec = _v0.a;
			return A4($author$project$NotificationForm$qExtremeBuilder, translations, allowedToSubmit, spec, notification);
		case 9:
			var spec = _v0.a;
			return A4($author$project$NotificationForm$meterErrorStateBuilder, translations, allowedToSubmit, notification, spec);
		case 11:
			var spec = _v0.a;
			return A4($author$project$NotificationForm$wastageDetectionBuilder, translations, allowedToSubmit, notification, spec);
		default:
			return $author$project$Enectiva$View$nothing;
	}
};
var $author$project$NotificationForm$SelectType = function (a) {
	return {$: 1, a: a};
};
var $author$project$NotificationForm$typeSelectionToString = function (selection) {
	switch (selection) {
		case 0:
			return 'arbitrary_date';
		case 1:
			return 'holiday';
		case 2:
			return 'absolute_consumption';
		case 3:
			return 'relative_consumption';
		case 4:
			return 'consumption_limit';
		case 5:
			return 'q_extreme';
		case 6:
			return 'data_series';
		case 7:
			return 'specific_consumption';
		default:
			return 'wastage_detection';
	}
};
var $author$project$NotificationForm$typeSelectionOption = F2(
	function (translations, selection) {
		var tp = $author$project$NotificationForm$typeSelectionToString(selection);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$NotificationForm$SelectType(selection)),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('bg-grey-100 text-grey-800 w-full h-full cursor-pointer p-2'),
					$elm$html$Html$Attributes$class('border border-solid border-grey-600 rounded'),
					$elm$html$Html$Attributes$class('fast-colors-transition leading-tight text-base'),
					$elm$html$Html$Attributes$class('hover:bg-blue-100 hover:text-black hover:border-blue-600'),
					$elm$html$Html$Attributes$class('focus:bg-blue-100 focus:text-black focus:border-blue-600')
				]),
			_List_fromArray(
				[
					A2($author$project$View$tt, translations, 'notification.types.' + tp)
				]));
	});
var $author$project$NotificationForm$typeSelection = F2(
	function (translations, types) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-cols-2 lg:grid-cols-3 gap-2')
				]),
			A2(
				$elm$core$List$map,
				$author$project$NotificationForm$typeSelectionOption(translations),
				types));
	});
var $author$project$NotificationForm$formBody = function (model) {
	var translations = model.A;
	return $author$project$NotificationForm$anyTypeIsSelected(model.h) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$NotificationForm$specificBuilder(model),
				A2($author$project$NotificationForm$serverRequestState, translations, model.h.bU),
				A3($author$project$NotificationForm$saveButton, translations, model.h, model.bG)
			])) : A2($author$project$NotificationForm$typeSelection, translations, model.e5);
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$NotificationForm$title = F2(
	function (translations, notification) {
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main_heading')
				]),
			$elm$core$List$singleton(
				function () {
					var _v0 = notification.K;
					if (_v0.$ === 1) {
						return A2($author$project$View$tt, translations, 'notification.new_title');
					} else {
						return $elm$html$Html$text(
							A2($author$project$Enectiva$I18n$t, translations, 'notification.edit_title') + (': ' + $author$project$Enectiva$ValidatedValue$value(notification.a8)));
					}
				}()));
	});
var $author$project$NotificationForm$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('space-y-2')
			]),
		_List_fromArray(
			[
				A2($author$project$NotificationForm$title, model.A, model.h),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-transparent p-0 m-0'),
						$elm$html$Html$Events$onSubmit($author$project$NotificationForm$Save),
						$author$project$Spinner$container
					]),
				_List_fromArray(
					[
						$author$project$NotificationForm$formBody(model)
					]))
			]));
};
var $author$project$NotificationForm$main = $elm$browser$Browser$element(
	{iv: $author$project$NotificationForm$init, jn: $author$project$NotificationForm$subscriptions, jA: $author$project$NotificationForm$update, jC: $author$project$NotificationForm$view});
/*
_Platform_export({'NotificationForm':{'init':$author$project$NotificationForm$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (virtualMeters) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (userId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (translations) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (smsRecipient) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (physicalMeters) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (now) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (notification) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (locale) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (entities) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (energiesWithUnits) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (emailRecipients) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (divisors) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (dataSeries) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (currency) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (csrfToken) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (allowedToSubmit) {
																																	return $elm$json$Json$Decode$succeed(
																																		{bG: allowedToSubmit, bl: csrfToken, bm: currency, d7: dataSeries, a2: divisors, z: emailRecipients, aB: energiesWithUnits, ee: entities, eE: locale, h: notification, cf: now, e4: physicalMeters, aI: smsRecipient, A: translations, fw: userId, fx: virtualMeters});
																																},
																																A2($elm$json$Json$Decode$field, 'allowedToSubmit', $elm$json$Json$Decode$bool));
																														},
																														A2($elm$json$Json$Decode$field, 'csrfToken', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'currency', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'dataSeries', $elm$json$Json$Decode$value));
																								},
																								A2($elm$json$Json$Decode$field, 'divisors', $elm$json$Json$Decode$value));
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'emailRecipients',
																							$elm$json$Json$Decode$list(
																								A2(
																									$elm$json$Json$Decode$andThen,
																									function (name) {
																										return A2(
																											$elm$json$Json$Decode$andThen,
																											function (id) {
																												return A2(
																													$elm$json$Json$Decode$andThen,
																													function (email) {
																														return $elm$json$Json$Decode$succeed(
																															{fY: email, K: id, a8: name});
																													},
																													A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
																											},
																											A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int));
																									},
																									A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)))));
																				},
																				A2(
																					$elm$json$Json$Decode$field,
																					'energiesWithUnits',
																					$elm$json$Json$Decode$list(
																						A2(
																							$elm$json$Json$Decode$andThen,
																							function (units) {
																								return A2(
																									$elm$json$Json$Decode$andThen,
																									function (energy) {
																										return $elm$json$Json$Decode$succeed(
																											{g: energy, bb: units});
																									},
																									A2($elm$json$Json$Decode$field, 'energy', $elm$json$Json$Decode$value));
																							},
																							A2(
																								$elm$json$Json$Decode$field,
																								'units',
																								$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))));
																		},
																		A2($elm$json$Json$Decode$field, 'entities', $elm$json$Json$Decode$value));
																},
																A2($elm$json$Json$Decode$field, 'locale', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'notification', $elm$json$Json$Decode$value));
												},
												A2($elm$json$Json$Decode$field, 'now', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'physicalMeters', $elm$json$Json$Decode$value));
								},
								A2($elm$json$Json$Decode$field, 'smsRecipient', $elm$json$Json$Decode$value));
						},
						A2($elm$json$Json$Decode$field, 'translations', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$field, 'virtualMeters', $elm$json$Json$Decode$value)))(0)}});}(this));
*/
export const Elm = {'NotificationForm':{'init':$author$project$NotificationForm$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (virtualMeters) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (userId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (translations) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (smsRecipient) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (physicalMeters) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (now) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (notification) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (locale) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (entities) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (energiesWithUnits) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (emailRecipients) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (divisors) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (dataSeries) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (currency) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (csrfToken) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (allowedToSubmit) {
																																	return $elm$json$Json$Decode$succeed(
																																		{bG: allowedToSubmit, bl: csrfToken, bm: currency, d7: dataSeries, a2: divisors, z: emailRecipients, aB: energiesWithUnits, ee: entities, eE: locale, h: notification, cf: now, e4: physicalMeters, aI: smsRecipient, A: translations, fw: userId, fx: virtualMeters});
																																},
																																A2($elm$json$Json$Decode$field, 'allowedToSubmit', $elm$json$Json$Decode$bool));
																														},
																														A2($elm$json$Json$Decode$field, 'csrfToken', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'currency', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'dataSeries', $elm$json$Json$Decode$value));
																								},
																								A2($elm$json$Json$Decode$field, 'divisors', $elm$json$Json$Decode$value));
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'emailRecipients',
																							$elm$json$Json$Decode$list(
																								A2(
																									$elm$json$Json$Decode$andThen,
																									function (name) {
																										return A2(
																											$elm$json$Json$Decode$andThen,
																											function (id) {
																												return A2(
																													$elm$json$Json$Decode$andThen,
																													function (email) {
																														return $elm$json$Json$Decode$succeed(
																															{fY: email, K: id, a8: name});
																													},
																													A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
																											},
																											A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int));
																									},
																									A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)))));
																				},
																				A2(
																					$elm$json$Json$Decode$field,
																					'energiesWithUnits',
																					$elm$json$Json$Decode$list(
																						A2(
																							$elm$json$Json$Decode$andThen,
																							function (units) {
																								return A2(
																									$elm$json$Json$Decode$andThen,
																									function (energy) {
																										return $elm$json$Json$Decode$succeed(
																											{g: energy, bb: units});
																									},
																									A2($elm$json$Json$Decode$field, 'energy', $elm$json$Json$Decode$value));
																							},
																							A2(
																								$elm$json$Json$Decode$field,
																								'units',
																								$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))));
																		},
																		A2($elm$json$Json$Decode$field, 'entities', $elm$json$Json$Decode$value));
																},
																A2($elm$json$Json$Decode$field, 'locale', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'notification', $elm$json$Json$Decode$value));
												},
												A2($elm$json$Json$Decode$field, 'now', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'physicalMeters', $elm$json$Json$Decode$value));
								},
								A2($elm$json$Json$Decode$field, 'smsRecipient', $elm$json$Json$Decode$value));
						},
						A2($elm$json$Json$Decode$field, 'translations', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$field, 'virtualMeters', $elm$json$Json$Decode$value)))(0)}};
  